(function () {
    'use strict';

    angular.module('managementConsole', ['ui.router', 'ui.bootstrap', 'ngAnimate', 'angularMoment', 'angular-loading-bar', 'nya.bootstrap.select', 'chart.js', 'slickCarousel', 'ui.grid', 'ui.grid.autoResize', 'toastr', 'angular.filter', 'angular.img',])
        .config(function ($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, toastrConfig) {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false
            });

            $stateProvider
                .state('default', {
                    url: '/default',
                    abstract: true,
                    templateUrl: 'app/layout/views/_default.html',
                    controller: 'LayoutController as layoutCtrl'
                })
                .state('mainAuth', {
                    abstract: true,
                    templateUrl: 'app/layout/views/main.html',
                    controller: 'LayoutController  as layoutCtrl',
                    controllerAs: 'layout',
                    resolve: {
                        init: function ($q, $state, commonHelperService) {
                            var currentToken = commonHelperService.getFromLocalStorage('accessToken');

                            if (!currentToken) {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/login";
                            }
                            return '';
                        }
                    }
                })

                .state('managePass', {
                    url: '/manage-password/:type?code&email',
                    templateUrl: 'app/manage-password/res-password.html',
                    controller: 'ManagePasswordController as managePassCtrl',
                    resolve: {
                        managePassParams: function ($q, $stateParams, managePasswordService) {
                            var type = $stateParams.type;
                            var code = managePasswordService.base64decode($stateParams.code);
                            var email = managePasswordService.base64decode($stateParams.email);

                            if (!code || !email || (type != 'reset' && type != 'set')) {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/login";
                                return $q.reject();
                            } else {
                                return {
                                    type: type,
                                    code: code,
                                    email: email
                                };
                            }
                        }
                    }
                })
                .state('mainAuth.changePassword', {
                    url: '/change-password',
                    templateUrl: 'app/manage-password/change-password.html',
                    controller: 'ChangePasswordController as changePass'
                })

                .state('mainAuth.dashboard', {
                    url: '/dashboard',
                    templateUrl: 'app/dashboard/views/dashboard.html',
                    controller: 'DashboardController as dashboardCtrl'
                })

                .state('mainAuth.dashboard.releasedBooks', {
                    url: '/releasedBooks',
                    templateUrl: 'app/dashboard/partials/_releasedBooks.html',
                    controller: 'DashboardController as dashboardCtrl'
                })
                .state('mainAuth.dashboard.booksTesting', {
                    url: '/booksTesting',
                    templateUrl: 'app/dashboard/partials/_booksTesting.html',
                    controller: 'DashboardController as dashboardCtrl'
                })
                .state('mainAuth.dashboard.booksApproved', {
                    url: '/booksApproved',
                    templateUrl: 'app/dashboard/partials/_approvedBooks.html',
                    controller: 'DashboardController as dashboardCtrl'
                })

                .state('mainAuth.management', {
                    url: '/management',
                    abstract: true,
                    templateUrl: 'app/management/views/management.html',
                    controller: 'ManagementController as managementCtrl'
                })
                .state('mainAuth.management.role', {
                    url: '/role',
                    templateUrl: 'app/management/role/views/role.html',
                    controller: 'RoleController as roleCtrl',
                    resolve: {
                        init: function ($rootScope, $q) {
                            var getUsersAllowed = $rootScope.checkForPermission('GetRoles');
                            if (!getUsersAllowed) {
                                return $q.reject({ redirectTo: 'mainAuth.dashboard' });
                            }
                        }
                    }
                })
                .state('mainAuth.management.user', {
                    url: '/ManagementConsole/user-management',
                    resolve: {
                        redirect: function ($q) {
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/user-management";
                            }, 1);
                            return $q.reject({ redirectTo: 'mainAuth.dashboard' });;
                        }
                    }
                })
                .state('mainAuth.management.loaner', {
                    url: '/ManagementConsole/loaners',
                    resolve: {
                        redirect: function ($q) {
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/loaners";
                            }, 1);
                            return $q.reject({ redirectTo: 'mainAuth.dashboard' });
                        }
                    }
                })
                .state('mainAuth.management.loanerDetails', {
                    url: '/ManagementConsole/loaner/:userId',
                    resolve: {
                        redirect: function ($q, $stateParams) {
                            var userId = $stateParams.userId;
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/loaner/" + userId;
                            }, 1);
                            return $q.reject({ redirectTo: 'mainAuth.dashboard' });
                        }
                    }
                })
                .state('mainAuth.management.noneTeachingStaffDetails', {
                    url: '/ManagementConsole/non-teaching/:nonTachingStaffId',
                    resolve: {
                        redirect: function ($q, $stateParams) {
                            var userId = $stateParams.userId;
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/non-teaching/" + userId;
                            }, 1);
                            return $q.reject({ redirectTo: 'mainAuth.dashboard' });
                        }
                    }
                })
                .state('mainAuth.management.device', {
                    url: '/ManagementConsole/devices',
                    resolve: {
                        redirect: function ($q) {
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/devices";
                            }, 1);
                            return $q.reject({ redirectTo: 'mainAuth.dashboard' });
                        }
                    }
                })
                .state('mainAuth.management.deviceDetails', {
                    url: '/devicedetails/:deviceId',
                    params: {
                        deviceSearchResults: null,
                        searchCriteriaBackup: null
                    },
                    templateUrl: 'app/management/device/views/deviceDetails.html',
                    controller: 'DeviceDetailsController as deviceDetailsCtrl',
                    resolve: {
                        init: function ($rootScope, $state, $timeout, $q) {
                            $rootScope.relatedState = 'mainAuth.management.device';

                            var getUsersAllowed = $rootScope.checkForPermission('GetDevices');
                            if (!getUsersAllowed) {
                                return $q.reject({ redirectTo: 'mainAuth.dashboard' });
                            }
                        }
                    }
                })
                .state('mainAuth.management.book', {
                    url: '/book',
                    templateUrl: 'app/management/book/views/book.html',
                    controller: 'BookController as bookCtrl'
                })

                .state('mainAuth.reports', {
                    url: '/ManagementConsole',
                    resolve: {
                        redirect: function ($q) {
                            var viewStatisticsAllowed = true;//$rootScope.checkForPermission('ViewStatistics');
                            if (viewStatisticsAllowed) {
                                setTimeout(function () {
                                    window.location.href = window.location.origin + "/MC/ManagementConsole/reports";
                                }, 1);
                            }
                            return $q.reject({ redirectTo: 'mainAuth.dashboard' });
                        }
                    }
                }) 
                .state('mainAuth.releaseScheduling', {
                    url: '/release-scheduling',
                    params: {
                        selectedScheduleId: null,
                        period: 'future'
                    },
                    templateUrl: 'app/scheduleRelease/views/scheduleRelease.html',
                    controller: 'ScheduleReleaseCtrl as scheduleReleaseCtrl',
                    cache: false,
                    resolve: {
                        init: function ($rootScope, $q) {
                            var releasesAllowed = $rootScope.checkForPermission('GetReleases');
                            if (!releasesAllowed) {
                                return $q.reject({ redirectTo: 'mainAuth.dashboard' });
                            }
                        }
                    }
                })
                .state('mainAuth.releaseScheduling.releases', {
                    url: '/releases',
                    params: {
                        filteredReleases: '',
                        selectedSchedule: '',
                        timeSpanSelected: ''
                    },
                    views: {
                        'releases': {
                            templateUrl: 'app/scheduleRelease/views/releases.html',
                            controller: 'ReleaseController as releaseCtrl'
                        }
                    },
                    cache: false,
                    resolve: {
                        init: function ($rootScope, $q, commonHelperService) {
                            var releasesAllowed = $rootScope.checkForPermission('GetReleases');
                            if (!releasesAllowed) {
                                return $q.reject({
                                    redirectTo: 'mainAuth.dashboard'
                                });
                            }
                        }
                    }
                })
                .state('mainAuth.addRelease', {
                    url: '/add-release/:id/:releaseId',
                    templateUrl: 'app/scheduleRelease/partials/_addRelease.html',
                    params: {
                        currentRelease: null,
                        editRelease: null,
                        period: 'future'
                    },
                    controller: 'AddReleaseCtrl as addReleaseCtrl',
                    resolve: {
                        init: function ($rootScope, $q) {
                            var addReleasesAllowed = $rootScope.checkForPermission('AddRelease');
                            if (!addReleasesAllowed) {
                                return $q.reject({ redirectTo: 'mainAuth.dashboard' });
                            }
                        }
                    }
                })
                .state('mainAuth.systemSettings', {
                    url: '/ManagementConsole',
                    abstract: true,
                    templateUrl: '',
                    controller: 'ManagementController as managementCtrl'
                })

                .state('mainAuth.notificationSettings', {
                    url: '/ManagementConsole/notification-settings',
                    resolve: {
                        redirect: function ($q) {
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/notification-settings";
                            }, 1);
                        }
                    }
                })
                .state('mainAuth.applicationSettings', {
                    url: '/ManagementConsole/application-settings',
                    resolve: {
                        redirect: function ($q) {
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/application-settings";
                            }, 1);
                        }
                    }
                })
                .state('mainAuth.userAccessSettings', {
                    url: '/ManagementConsole/user-access-settings',
                    resolve: {
                        redirect: function ($q) {
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/user-access-settings";
                            }, 1);
                        }
                    }
                }).state('mainAuth.supportSettings', {
                    url: '/ManagementConsole/support-settings',
                    resolve: {
                        redirect: function ($q) {
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/support-settings";
                            }, 1);
                        }
                    }
                }).state('mainAuth.dataCleaning', {
                    url: '/ManagementConsole/data-cleaning',
                    resolve: {
                        redirect: function ($q) {
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/data-cleaning";
                            }, 1);
                        }
                    }
                }).state('mainAuth.copyrights-and-licenses', {
                    url: '/ManagementConsole/copyrights-and-licenses',
                    resolve: {
                        redirect: function ($q) {
                            setTimeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/copyrights-and-licenses";
                            }, 1);
                        }
                    }
                })
                ;

            $urlRouterProvider.otherwise(function ($injector) {
                var $state = $injector.get('$state');
                $state.go('mainAuth.dashboard');
            });


            $httpProvider.interceptors.push('authInterceptorService');

            //initialize get if not there
            if (!$httpProvider.defaults.headers.get) {
                $httpProvider.defaults.headers.get = {};
            }

            // Answer edited to include suggestions from comments
            // because previous version of code introduced browser-related errors

            //disable IE ajax request caching
            $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
            // extra
            $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
            $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

            angular.extend(toastrConfig, {
                positionClass: 'toast-bottom-right'
            });
        })

        .run(function ($rootScope, $state, userInfoService) {
            $rootScope.$state = $state;

            $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
                $state.go(error.redirectTo);
            });

            $rootScope.$on('$stateChangeSuccess', function () {
                var toastrContainer = $('#toast-container');
                if (toastrContainer && toastrContainer.length > 0) {
                    toastrContainer.remove();
                }
            });

            $rootScope.checkForPermission = function (requiredPermission) {
                var permissions = userInfoService.getUserPermissionStorage();
                if (!permissions) {
                    return false;
                }

                var userPermissions = permissions.toLowerCase().replace(/ /g, '');
                var listOfPermissions = userPermissions.split(',');

                return listOfPermissions.indexOf(requiredPermission.toLowerCase()) != -1;
            }
        });

})();

/*
 ***********************Very Important***********************
 * 
 * all new configurations should be included in src/configurations/{all-config-file}.js
 * the configuration file that is read by the application is in src/resources/config.js
 * 
 */
(function () {
    angular.module('managementConsole').constant({
        CONSTANTS: {
            API_URL: config.apiUrl
        }
    });
}());
(function () {
    angular.module('managementConsole').constant({
       userRolesConstant: {           
            loaner: 23,
            nonTeachingStaff: 24,
            schoolAdmin:4
        }
    });
}());
(function () {
    'use strict';

    angular.module('managementConsole')
        .controller('ChangePasswordController', function (managePasswordService, toastr, commonHelperService) {
            var vm = this;

            vm.changePassword = function () {
                if (!commonHelperService.passwordRegExpression.test(vm.newPassword)) {
                    toastr.error('Password field contains illegal symbols');
                    return
                }

                managePasswordService.changePassword(vm.oldPassword, vm.newPassword, vm.confirmPassword).then(
                    function (res) {
                        toastr.success('Password changed successfully');
                        vm.oldPassword = '';
                        vm.newPassword = '';
                        vm.confirmPassword = '';
                    },
                    function (err) {
                        if (err.status == 400) {
                            toastr.error('The old password is incorrect or the new passwords do not match.');
                        } else {
                            toastr.error('There was an error while changing your password.');
                        }
                    }
                );
            };

            vm.validatePass = function () {
                return vm.oldPassword && vm.newPassword
                    && vm.newPassword == vm.confirmPassword;
            }
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .controller('ManagePasswordController', function (managePassParams, managePasswordService,commonHelperService, toastr, $state, $timeout) {
            var vm = this,
                code = managePassParams.code,
                email = managePassParams.email;

            vm.title = managePassParams.type == 'reset' ? 'Reset Password' : 'Set Password';
            vm.newPassText = managePassParams.type == 'reset' ? 'New Password' : 'Password';
            vm.confirmPassText = managePassParams.type == 'reset' ? 'Confirm New Password' : 'Confirm Password';
            vm.displayedMessage = "Please note that the password is case sensitive";
            vm.isValid = true;

            vm.resetPassword = function () {
                if (vm.validatePass()) {

                    if (!commonHelperService.passwordRegExpression.test(vm.confirmPassword)) {
                        toastr.error('Password field contains illegal symbols');
                        return
                    }

                    managePasswordService.resetPassword(code, email, vm.password, vm.confirmPassword).then(
                        function (res) {
                            toastr.success('Password changed successfully');

                            vm.password = '';
                            vm.confirmPassword = '';

                            $timeout(function () {
                                window.location.href = window.location.origin + "/MC/ManagementConsole/login";
                            }, 2000);
                        },
                        function (err) {
                            toastr.error('Error while resetting your password. ' + err);
                        }
                    );
                }
            };
            vm.checkValidationCode = function () {
                managePasswordService.checkValidationCode(code, email).then(
                        function (res) {
                            vm.displayedMessage = "Please note that the password is case sensitive";
                            vm.isValid = true;
                        },
                        function (err) { 
                            vm.displayedMessage = err.data;
                            vm.isValid = false;
                        }
                    );              
            };
            vm.validatePass = function () {
                return vm.password && vm.password == vm.confirmPassword;
            };

            vm.checkValidationCode();
        });
})();

(function () {

    angular.module('managementConsole')
        .factory('managePasswordService', function ($http, CONSTANTS) {
            var managePasswordService = this;

            managePasswordService.base64decode = function (s) {
                try {
                    return window.atob(s);
                } catch (e) {
                    //not a correct base64 string
                    return null;
                }
            };

            var _sendRequest = function (method, url, data) {
                return $http({
                    method: method,
                    url: CONSTANTS.API_URL + url,
                    headers: { 'Content-Type': 'application/json' },
                    data: data
                });
            };

            managePasswordService.resetPassword = function (code, email, password, confirmPassword) {
                var data = {
                    password: password,
                    confirmPassword: confirmPassword,
                    verificationCode: code,
                    email: email
                };

                return _sendRequest('POST', '/users/reset-password', data);
            };

            managePasswordService.forgotPassword = function (email) {
                return _sendRequest('POST', '/users/forgot-password', '\'' + email + '\'');
            };

            managePasswordService.changePassword = function (oldPassword, newPassword, confirmPassword) {
                var data = {
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                    confirmPassword: confirmPassword
                };

                return _sendRequest('POST', '/users/change-password', data);
            };

            managePasswordService.checkValidationCode = function (code, email) {
                var data = {
                    verificationCode: code,
                    email: email
                };

                return _sendRequest('POST', '/users/verify-code', data);
            };

            return managePasswordService;
        });

})();

(function () {
    'use strict';

    angular.module('managementConsole').controller('AddReleaseCtrl', AddReleaseCtrl);

    function AddReleaseCtrl($rootScope, dashboardService, CONSTANTS, $scope, $http, $timeout, $state, toastr, scheduleService, commonHelperService, $uibModal, subjectService) {
        var vm = this;
        vm.releaseAction = 'New Release';
        vm.confirmAdd = 'Add';
        vm.books = [];
        vm.StatusChangeDate = '';
        vm.getApprovedBooks = function () {
            dashboardService.getApprovedBooks().then(function (response) {
                var allAprovedBooks = response.data;
                //add only the books that are not scheduled for release 

                //Scrumble - filter books that already has a version in this release if edit mode
                var releaseBooksISBN = [];
                for (var i = 0; i < vm.books.length; i++) {
                    releaseBooksISBN.push(vm.books[i].Identifier);
                }

                for (var i = 0; i < allAprovedBooks.length; i++) {
                    if (!allAprovedBooks[i].IsScheduledForRelease && releaseBooksISBN.indexOf(allAprovedBooks[i].Identifier) == -1) {
                        allAprovedBooks[i].StatusChangeDate = new Date(trimEnd(allAprovedBooks[i].StatusChangeDate.toUpperCase(), 'Z') + 'Z').toLocaleString();
                        vm.books.push(allAprovedBooks[i]);
                    }
                }
            }, function (err) { });
        };

        var editMode = false;

        if ($state.params.id) {
            var releaseId = $state.params.releaseId;
            editMode = releaseId != null && releaseId.trim() != '';
            scheduleService.getSchedule($state.params.id).then(function (schedule) {
                vm.currentSchedule = schedule;
                vm.currentScheduleName = schedule.Name;
                vm.currentScheduleId = schedule.Id;

                if (editMode) {
                    vm.confirmAdd = 'Update';
                    var selectedRelease = schedule.Releases.filter(function (obj) { return obj.Id == releaseId; });
                    vm.setBooksData(selectedRelease[0]);
                    vm.release = selectedRelease[0];
                    if (!vm.release.IsInactive) {
                        vm.getApprovedBooks();
                    }
                } else {
                    schedule.Start = commonHelperService.transformDateToLocalTime(schedule.Start);
                    var currentDate = new Date();
                    vm.setBooksData();
                    var scheduleStartDate = new Date(schedule.start);
                    vm.dateSelected = currentDate < scheduleStartDate ? scheduleStartDate : currentDate;
                    vm.getApprovedBooks();
                }
            }, function (error) { });
        }
        vm.setBooksData = function (selectedRelease) {
            subjectService.getUserSubjects()
                .then(function (subjects) {
                    vm.userSubjects = subjects;
                    if (selectedRelease != null) {
                        setBooksDisabled(selectedRelease);
                        setEditModeReleaseProperties(selectedRelease);
                    }

                }, function (err) {
                    console.log(err);
                });
        };

        vm.options = {
            minDate: new Date(),
            showWeeks: true
        };
        vm.coverUrlFirstPart = CONSTANTS.API_URL + '/books/';
        vm.coverUrlSecondPart = '/thumbs/page-1/jpeg';

        //region Date picker options
        $scope.inlineOptions = {
            minDate: new Date(),
            showWeeks: false
        };
        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var oneyearfromnow = new Date(year + 1, month, day);

        $scope.dateOptions = {
            formatYear: 'yy',
            maxDate: oneyearfromnow,
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false,
            selectOtherMonths: false,
            maxMode: 'day'
        };
        $scope.toggleMin = function () {
            $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date();
            $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
        };
        $scope.toggleMin();
        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };
        $scope.setDate = function (year, month, day) {
            vm.dateSelected = new Date(year, month, day);
        };
        $scope.popup1 = {
            opened: false
        };
        $scope.clear = function () {
            vm.dateSelected = null;
        };
        $scope.format = 'MMMM dd,yyyy';
        $scope.altInputFormats = ['M!/d!/yyyy'];
        //endregion

        vm.submitRelease = function (parentSelector) {
            if (!vm.dateSelected) {
                toastr.warning('Please, select date for the release!');
                return;
            }

            if (!vm.time) {
                toastr.warning('Please, select exact time for the release!');
                vm.releaseTimeInvalid = true;
                return;
            }
            vm.releaseTimeInvalid = false;

            if (!vm.releaseName || vm.releaseName.length < 1) {
                toastr.warning('Please enter name of the release');
                vm.releaseNameInvalid = true;
                return;
            }

            vm.releaseNameInvalid = false;

            if (!$state.params.id) {
                toastr.warning('No schedule selected');
                $state.go('mainAuth.releaseScheduling');
                return;
            }

            var year = vm.dateSelected.getFullYear(),
                month = vm.dateSelected.getMonth(),
                day = vm.dateSelected.getDate(),
                hour = vm.time.getHours(),
                minute = vm.time.getMinutes();
            var dateSelected = new Date(year, month, day, hour, minute, 0);

            if (dateSelected < new Date()) {
                toastr.warning('Release date should be in the future!');
                return;
            }

            if (dateSelected < new Date(vm.currentSchedule.Start) || dateSelected > new Date(vm.currentSchedule.End)) {
                toastr.warning('Release date should be between ' + new Date(vm.currentSchedule.Start).toUTCString()/*.toLocaleString()*/ + ' and ' + new Date(vm.currentSchedule.End)/*.toLocaleString()*/);
                return;
            }

            var release = {};

            var releases = vm.books.filter(function (value) {
                return value.isSelected;
            });

            if (releases.length < 1) {
                toastr.error('No books selected for this release!');
                return;
            }

            var bookIds = [];
            for (var i = 0; i < releases.length; i++) {
                bookIds.push({ BookId: releases[i].Id, BookVersionId: releases[i].BookVersionId });
            }

            release.ReleaseDate = dateSelected;
            release.ReleaseDate = release.ReleaseDate.toUTCString();
            release.Name = vm.releaseName;
            release.Id = $state.params.releaseId;
            release.ReleasesBooks = bookIds;
            release.IsGlobalRelease = true;
            scheduleService.checkReleaseBooks(release)
                .then(function (res) {
                    if (res.ShowWarning) {
                        var parentElem = parentSelector
                            ? angular.element($document[0].querySelector('.container ' + parentSelector))
                            : undefined;
                        var modalInstance = $uibModal.open({
                            animation: true,
                            ariaLabelledBy: 'modal-title',
                            ariaDescribedBy: 'modal-body',
                            templateUrl: 'app/management/book/views/_modalConfirm.html',
                            controller: function ($scope, $uibModalInstance) {
                                $scope.title = 'LMS';
                                $scope.header = 'Books Release';
                                $scope.confirmAction = res.Warnings.join("\r\n");
                                $scope.confirmActionSecond = res.AdditionalMessage;
                                $scope.actionName = 'Ok';

                                $scope.isWarningModal = true;

                                $scope.ok = function () {
                                    addEditRelease(release);
                                    $uibModalInstance.dismiss('cancel');
                                };

                                $scope.cancel = function () {
                                    $uibModalInstance.dismiss('cancel');
                                };
                            },
                            appendTo: parentElem
                        });
                    }
                    else {
                        addEditRelease(release);
                    }
                });
        };

        //Initialize grid header names
        vm.headerNames = ['Code ( ISBN )', 'Name', 'Subject', 'Version', 'Approved Date'];
        vm.navigateBack = function () {
            $state.go('mainAuth.releaseScheduling', { selectedScheduleId: vm.currentScheduleId, period: $state.params.period });
        };

        function addEditRelease(release) {
            if (!editMode) {
                release.ScheduleId = $state.params.id;
                scheduleService.addRelease(release)
                    .then(function (res) {
                        toastr.success('Release added successfully');
                        $state.go('mainAuth.releaseScheduling');
                    }, function (err) {
                        toastr.error(err.data.length > 0 ? err.data : err.statusText);
                    });
            }
            else {
                release.ScheduleId = $state.params.id;
                release.Id = $state.params.releaseId;
                scheduleService.editRelease(release)
                    .then(function (res) {
                        toastr.success('Released edited successfully');
                        $state.go('mainAuth.releaseScheduling');
                    }, function (err) {
                        toastr.error(err.data.length > 0 ? err.data : err.statusText);
                    });
            }
        }

        function setEditModeReleaseProperties(release) {

            vm.release = release;
            vm.releaseAction = release.Name;
            vm.releaseName = release.Name;
            release.ReleaseDate = commonHelperService.transformDateToLocalTime(release.ReleaseDate);
            vm.dateSelected = new Date(release.ReleaseDate);
            vm.time = new Date(release.ReleaseDate);
            for (var i = 0; i < release.Books.length; i++) {
                var currentBook = release.Books[i];
                release.Books[i].StatusChangeDate = new Date(trimEnd(release.Books[i].PreviousStatusDate.toUpperCase(), 'Z') + 'Z').toLocaleString();
                currentBook.isSelected = true;
                vm.books.push(currentBook);

            }
        };

        function setBooksDisabled(release) {
            for (var i = 0; i < release.Books.length; i++) {
                var currentBook = release.Books[i];
                currentBook.isDisabled = true;
                vm.userSubjects.forEach(function (item) {
                    if (currentBook.Subject.toLowerCase() == item.Name.toLowerCase()) {
                        currentBook.isDisabled = false;
                    }
                });
            }
        }
        function trimEnd(str, trailer) {
            var index = str.lastIndexOf(trailer);
            if (index > -1 && index == str.length - trailer.length) {
                str = str.substring(0, str.length - trailer.length);
                return trimEnd(str, trailer);
            }
            return str;
        }
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('ReleaseController', ReleaseController);


    function ReleaseController($scope, $state, $timeout, $uibModal, scheduleService) {
        var vm = this;
        $scope.period = '';
        $scope.selectedSchedule = $state.params.selectedSchedule;

        var currentSelectedScheduleExist = $('.schedule-selected');
        if (currentSelectedScheduleExist.length == 0) {
            $('.slick-initialized').addClass('schedule-selected');
        }

        $scope.releases = $state.params.filteredReleases;

        console.log($scope.releases)

        $scope.$on('releaseSelected', function (event, args) {
            $scope.releases = args;
        });

        $scope.$on('periodChanged', function (event, args) {
            $scope.releases = [];
        });

        var deleteRelease = function (release) {
            for (var i = 0; i < $scope.releases.length; i++) {
                if (release.Id == $scope.releases[i].Id) {
                    $scope.releases.splice(i, 1);
                    break;
                }
            }
        }

        var deleteReleaseConfirm = function deleteReleaseConfirm(release) {
            if (release.IsInactive) {
                return;
            }

            scheduleService.deleteRelease(release.Id)
            .then(function (res) {
                deleteRelease(release);
            }, function (err) {
                toastr.warning(err.data);
                console.log(err)
            })
        }

        $scope.deleteRelease = function (release, parentSelector) {
            var parentElem = parentSelector ?
              angular.element($document[0].querySelector('.container ' + parentSelector)) : undefined;
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-message-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/management/book/views/_modalConfirm.html',
                controller: function ($scope, $uibModalInstance) {
                    $scope.title = 'LMS';
                    $scope.header = 'Delete Release';
                    $scope.confirmAction = 'Are you sure you want to delete selected release?';
                    $scope.actionName = 'Delete';

                    $scope.isWarningModal = true;
                    
                    $scope.ok = function () {
                        deleteReleaseConfirm(release);
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                appendTo: parentElem
            });
        }

        
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('ScheduleReleaseCtrl', ScheduleReleaseCtrl);


    function ScheduleReleaseCtrl($rootScope, $scope, $window, $state, $timeout, $filter, toastr, scheduleService, scheduleHelper, $uibModal, commonHelperService, subjectService) {
        var vm = this;
        vm.currentPeriod = $state.params.period
        vm.currentStateName = vm.currentPeriod == 'future' ? 'Release Scheduling' : 'Archive';

        vm.periodChanged = false;

        $scope.disabledDelete = [];
        vm.isLoading = false;
        vm.isSaving = false;

        vm.schedulesToshow = 3;

        vm.slickLoaded = true;// This is used as hack for the slick carousel for dynamic data loading.
        vm.slickConfig = {
            autoplay: false,
            infinite: false,
            slidesToShow: vm.schedulesToshow,
            slidesToScroll: vm.schedulesToshow,
            arrows: false,
            dots: true,
            method: {},
            event: {}
        };
        vm.isScheduleEntryVisible = false;

        vm.scheduleModel = {
            Id: 0,
            Name: '',
            Start: '',
            End: ''
        }
        vm.schedules = [];
        vm.fakeSchedules = [];
        vm.selectedSchedule = vm.activeSchedule || null;
        vm.isScheduleStartDateOpen = false;
        vm.isScheduleEndDateOpen = false;

        vm.initModule = function () {
            vm.getSchedules();
            if ($scope.$resolve.params) {
                vm.scheduleToUpdate = jQuery.extend({}, $scope.$resolve.params.schedule);
            }
        };

        vm.resetForm = function () {
            $scope.scheduleForm.$setPristine();
            $scope.scheduleForm.$setUntouched();

            vm.resetScheduleModel();
        };

        vm.resetScheduleModel = function () {
            vm.scheduleModel.Id = 0;
            vm.scheduleModel.Name = '';
            vm.scheduleModel.Start = '';
            vm.scheduleModel.End = '';
        };

        // Watch for scrollbar visibility
        $scope.$watch(function () {
            return $(document).height() + $(window).height();
        },
            function () {
                vm.setReleasesFullHeight();
            });

        angular.element($window).bind('resize', function () {
            vm.setReleasesFullHeight();
        });

        vm.setReleasesFullHeight = function () {
            $timeout(function () {
                $('.releases').height($('.main-content').height() - $('.schedules').height() - 15);
            });
        }

        vm.getSchedules = function () {
            vm.isLoading = true;
            vm.schedules = [];
            vm.slickLoaded = false;

            scheduleService.getSchedules()
                .then(function (response) {

                    //Convert dates to UTC
                    response.map(function (schedule) {
                        schedule.Start = commonHelperService.transformDateToLocalTime(schedule.Start);
                        schedule.end = commonHelperService.transformDateToLocalTime(schedule.end);
                        return schedule;
                    });

                    vm.schedules = scheduleHelper.getScheduleFilteredByTime(response, vm.currentPeriod);

                    vm.schedules.forEach(function (schedule) {
                        if (!schedule.Releases || schedule.Releases.length == 0) {
                            return;
                        }
                        schedule.Relases = scheduleHelper.sortByDate(schedule.Releases, 'ReleaseDate');
                    });

                    if (vm.schedules.length > 0) {
                        vm.createFakeSchedules();
                    }

                    vm.schedules.sort(function (a, b) {
                        return new Date(a.Start) - new Date(b.Start);
                    });

                    vm.isLoading = false;
                    vm.slickLoaded = true;

                    if ($state.params.selectedScheduleId) {
                        vm.scheduleSelected = response.filter(function (obj) {
                            return obj.Id == $state.params.selectedScheduleId;
                        });
                        if (vm.scheduleSelected) {
                            vm.setBooksData(vm.scheduleSelected[0]);
                            vm.setActiveSchedule(vm.scheduleSelected);
                            vm.getScheduleReleases(vm.scheduleSelected[0].Id);
                        }
                    }
                },
                    function (error) {
                        toastr.error(error.data.Message);
                        vm.isLoading = false;
                        vm.slickLoaded = true;
                    });
        };

        vm.createFakeSchedules = function () {
            vm.fakeSchedules = [];

            if (vm.schedules.length < 3) {
                for (var x = vm.schedules.length; x < 3; x++) {

                    vm.fakeSchedules.push({
                        Id: x * -1,
                        Name: 'Schedule Template',
                        Start: new Date(),
                        End: new Date()
                    });
                }
            }
        };

        vm.getScheduleReleases = function (scheduleId) {
            var scheduleReleases = [];
            vm.isLoading = true;

            scheduleService.getScheduleReleases(scheduleId)
                .then(function (response) {
                    scheduleReleases = response;

                    vm.setBooksData(scheduleReleases);
                    if (vm.activeSchedule[0]) {
                        vm.selectedSchedule = angular.copy(vm.activeSchedule[0]);
                    } else {
                        vm.selectedSchedule = angular.copy(vm.activeSchedule);
                    }

                    $state.go('mainAuth.releaseScheduling.releases', { filteredReleases: scheduleReleases, selectedSchedule: vm.activeSchedule, timeSpanSelected: vm.currentPeriod });
                    $rootScope.$broadcast('releaseSelected', scheduleReleases);

                    vm.setReleasesFullHeight();

                    vm.isLoading = false;
                },
                    function (error) {

                        vm.isLoading = false;
                    });
        };

        vm.schedulesListSelectedChanged = function (schedule) {
            vm.selectedSchedule = schedule;
            vm.getScheduleReleases(schedule.Id);

            var scheduleIndex = vm.schedules.indexOf(schedule)
            if (scheduleIndex !== undefined) {
                vm.slickConfig.method.slickGoTo(scheduleIndex);
            }
        };

        if ($state.params.filteredReleases) {
            $scope.releases = $state.params.filteredReleases;
        }

        vm.addSchedule = function () {
            if (moment(vm.scheduleModel.End).diff(vm.scheduleModel.Start, 'days') < 0) {
                toastr.error('End Date should equal or greater than Start Date');

                return;
            }

            var clonedSchedule = jQuery.extend({}, vm.scheduleModel);// This is used to avoid changing the model on scope espacially when converting to UTC, the calendar model becomes empty and gives validation error

            clonedSchedule.Start = clonedSchedule.Start;//.toUTCString();  //Converting to UTC will cause it to be one day back
            clonedSchedule.End = clonedSchedule.End//.toUTCString();  //Converting to UTC will cause it to be one day back

            vm.isSaving = true;

            vm.slickLoaded = false;
            scheduleService.addSchedule(clonedSchedule)
                .then(function (response) {
                    toastr.success('Schedule saved successfully');

                    vm.schedules.push(response);

                    if (vm.schedules.length < vm.schedulesToshow) {
                        vm.createFakeSchedules();
                    }
                    else {
                        vm.fakeSchedules = [];
                    }

                    vm.slickLoaded = true;

                    vm.isScheduleEntryVisible = false;
                    vm.isSaving = false;
                    vm.resetForm();
                },
                    function (error) {
                        toastr.warning(error.data);
                        vm.isSaving = false;
                        vm.slickLoaded = true;

                    });
        };

        var scheduleIdForDelete = null;
        vm.deleteSchedule = function (scheduleId) {
            scheduleIdForDelete = scheduleId;
            $scope.deleteRelease();

        };

        vm.confirmDeleteSchedule = function () {
            vm.slickLoaded = false;
            scheduleService.deleteSchedule(scheduleIdForDelete)
                .then(function (response) {
                    toastr.success('Schedule deleted successfully');

                    var scheduleIndex;
                    var schedule = $filter('filter')(vm.schedules, { Id: scheduleIdForDelete }, true);
                    if (schedule && schedule !== undefined && schedule.length) {
                        scheduleIndex = vm.schedules.indexOf(schedule[0]);
                        vm.schedules.splice(scheduleIndex, 1);
                    }

                    vm.selectedSchedule = null;
                    if (vm.schedules.length != 0 && vm.schedules.length < vm.schedulesToshow) {
                        vm.createFakeSchedules();
                    }
                    else {
                        vm.fakeSchedules = [];
                    }

                    vm.resetForm();
                    scheduleIdForDelete = null;
                    vm.slickLoaded = true;

                    $state.go('mainAuth.releaseScheduling');
                },
                    function (error) {
                        toastr.error(error.data);
                        vm.slickLoaded = true;
                        scheduleIdForDelete = null;
                    });
        }

        $scope.deleteRelease = function (release, parentSelector) {
            var parentElem = parentSelector ?
                angular.element($document[0].querySelector('.container ' + parentSelector)) : undefined;
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-message-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/management/book/views/_modalConfirm.html',
                controller: function ($scope, $uibModalInstance) {
                    $scope.title = 'LMS';
                    $scope.header = 'Delete Schedule';
                    $scope.confirmAction = 'Are you sure you want to delete selected schedule?';
                    $scope.actionName = 'Delete';

                    $scope.isWarningModal = true;

                    $scope.ok = function () {
                        vm.confirmDeleteSchedule();
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                appendTo: parentElem
            });
        }

        vm.changePeriod = function (newPeriod) {
            vm.selectedSchedule = null;
            vm.activeSchedule = null;
            vm.currentPeriod = newPeriod;
            vm.getSchedules();
            if (newPeriod == 'past') {
                vm.currentStateName = 'Archive';
            } else {
                vm.currentStateName = 'Release Scheduling'
                $state.go('mainAuth.releaseScheduling', { selectedScheduleId: null, period: 'future' });
            }
            $state.params.timeSpanSelected = newPeriod;

            $scope.$broadcast('periodChanged', newPeriod)
            vm.periodChanged = true;
        }

        vm.setBooksData = function (scheduleReleases) {
            subjectService.getUserSubjects()
                .then(function (subjects) {
                    vm.userSubjects = subjects;
                    for (var i = 0; i < scheduleReleases.length; i++) {
                        setDeleteBtnDisabled(scheduleReleases[i], i);
                    };
                }, function (err) {
                    console.log(err);
                });
        };

        function setDeleteBtnDisabled(release, count) {
            $scope.disabledDelete[count] = false;
            for (var i = 0; i < release.Books.length; i++) {
                var hasDifferentBookSubject = true;
                vm.userSubjects.forEach(function (item) {
                    var currentBook = release.Books[i];
                    if (currentBook.Subject.toLowerCase() == item.Name.toLowerCase()) {
                        hasDifferentBookSubject = false
                    }
                });
                if (hasDifferentBookSubject) {
                    $scope.disabledDelete[count] = true

                }
            }

        }
        vm.setActiveSchedule = function (schedule) {
            vm.activeSchedule = schedule;
        }

        vm.sendToAddRelease = function () {
            var selectedSchedule = $state.params.selectedSchedule[0] || $state.params.selectedSchedule;
            if (selectedSchedule != null) {
                $state.go('mainAuth.addRelease', { id: selectedSchedule.Id, period: 'future' });
            }
        }

        //date picker
        vm.today = function () {
            vm.dateSelected = new Date();
        };
        vm.today();

        vm.inlineOptions = {
            minDate: new Date(),
            showWeeks: false,
            showButtonBar: false
        };

        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var oneyearfromnow = new Date(year + 1, month, day);

        vm.dateOptions = {
            formatYear: 'yy',
            maxDate: oneyearfromnow,
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false,
            selectOtherMonths: false,
            maxMode: 'day'
        };

        vm.toggleMin = function () {
            vm.inlineOptions.minDate = vm.inlineOptions.minDate ? null : new Date();
            vm.dateOptions.minDate = vm.inlineOptions.minDate;
        };

        vm.toggleMin();

        vm.openStartDate = function () {
            vm.startDateOpened.opened = true;
        };

        vm.openEndDate = function () {
            vm.endDateOpened.opened = true;
        };

        vm.setDate = function (year, month, day) {
            vm.dateSelected = new Date(year, month, day);
        };

        vm.startDateOpened = {
            opened: false
        };

        vm.endDateOpened = {
            opened: false
        };

        vm.format = 'MMMM dd,yyyy';
        vm.altInputFormats = ['M!/d!/yyyy'];

        vm.askEditSchedule = function (schedule) {
            vm.showWarning('editSchedule', { schedule: schedule, parentScope: $scope });
        };

        vm.updateSchedule = function () {
            if (moment(vm.scheduleToUpdate.End).diff(vm.scheduleToUpdate.Start, 'days') < 0) {
                toastr.error('End Date should equal or greater than Start Date');

                return;
            }

            vm.isSavingSchedule = true;

            var clonedSchedule = jQuery.extend({}, vm.scheduleToUpdate);// This is used to avoid changing the model on parent scope in case the update is not done (canceled for example)

            clonedSchedule.Start = clonedSchedule.Start;//.toUTCString();
            clonedSchedule.End = moment(clonedSchedule.End).set({ 'hour': 0, 'minute': 0, 'second': 0 })._d;//.toUTCString();

            scheduleService.updateSchedule(clonedSchedule)
                .then(function (response) {
                    toastr.success('Schedule saved successfully');

                    var parentScopeSchedules = $scope.$resolve.params.parentScope.scheduleReleaseCtrl.schedules;
                    var schedule = $filter('filter')(parentScopeSchedules, { Id: clonedSchedule.Id }, true);
                    if (schedule && schedule !== undefined && schedule.length) {
                        var objectIndex = parentScopeSchedules.indexOf(schedule[0]);
                        parentScopeSchedules[objectIndex].Name = clonedSchedule.Name;
                        parentScopeSchedules[objectIndex].Start = new Date(clonedSchedule.Start);
                        parentScopeSchedules[objectIndex].End = new Date(clonedSchedule.End);
                    }

                    vm.hideWarning();

                    vm.isSavingSchedule = false;
                },
                    function (error) {
                        toastr.warning(error.data);
                        vm.isSavingSchedule = false;
                    });
        };

        vm.showWarning = function (action, params) {
            var templateURL = "";
            switch (action) {
                case "editSchedule":
                    params.schedule.Start = new Date(params.schedule.Start);
                    params.schedule.End = new Date(params.schedule.End);
                    templateURL = 'app/scheduleRelease/partials/_editSchedule.html';
                    break;
            }

            $rootScope.modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-message-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: templateURL,
                controller: ScheduleReleaseCtrl,
                controllerAs: 'scheduleReleaseCtrl',
                resolve: {
                    params: params
                }
            });
        };

        vm.hideWarning = function () {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }
        };

        $scope.$watch(function () {
            return vm.selectedSchedule;
        }, function (newval, oldval) {

        });


        vm.initModule();
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('ModalController', [
        '$scope', '$uibModalInstance',
        function ($scope, $uibModalInstance) {
            var vm = this;
            vm.ConfirmAction = function () {
                var params = $scope.$resolve.params.ConfirmActionParams;
                if (params != null) {
                    $scope.$resolve.params.ConfirmAction(params);
                } else {
                    $scope.$resolve.params.ConfirmAction();
                }
                vm.closeModal();
            };

            vm.closeModal = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }]);
}());
(function () {
    'use strict';

    angular
        .module('managementConsole')
        .directive('customGrid', function () {
            return {
                restrict: 'E',
                templateUrl: 'app/common/partials/custom-grid.template.html',
                scope: {
                    headerNames: "=",
                    headerValues: '=',
                    gridData: '=',
                    filterCriteriaName: '@',
                    chosenFilterCriteria: '=',
                    isRowSelectable: '=',
                    isDisabled:'='
                },
                controller: function ($scope) {
                    $scope.allItemsSelected = {
                        checked:false
                    };
                    function checkIfAllSelected(filter) {
                        var allItemsSelected = false;
                        if ($scope.gridData.length > 0) {
                            var data = $scope.gridData;
                            if (filter != "" && filter != null) {                                
                                data = $scope.gridData.filter(function (item) {
                                    return item.Identifier.includes(filter);
                                })
                            }
                            if (data.length > 0) {
                                allItemsSelected = true;
                            }
                            
                            for (var i = 0; i < data.length; i++) {                                
                                if (!data[i].isSelected) {
                                    allItemsSelected = false;
                                    break;
                                }
                            }
                        }
                        return allItemsSelected;
                    }


                    $scope.onSelectionChange = function () {                       
                        $scope.allItemsSelected.checked = checkIfAllSelected();                         
                    }

                    $scope.customFilter = {};

                    $scope.customFilter[$scope.filterCriteriaName] = $scope.chosenFilterCriteria;

                    $scope.$watch('chosenFilterCriteria', function (newval) {
                        $scope.customFilter[$scope.filterCriteriaName] = newval;
                        $scope.allItemsSelected.checked = checkIfAllSelected(newval);  
                    });

                    $scope.$watchCollection('gridData', function (newval, oldval) {
                        $scope.allItemsSelected.checked = checkIfAllSelected(); 
                    });

                    $scope.orderCriteria = '';
                    $scope.changeOrderCriteria = function (input, headerValue) {

                        if ($scope.selectedHeader == headerValue) {
                            $scope.ascendingFilter = !$scope.ascendingFilter;
                        }
                        $scope.selectedHeader = headerValue;

                        if (input == $scope.orderCriteria) {
                            $scope.orderCriteria = '-' + $scope.orderCriteria;
                        } else {
                            $scope.orderCriteria = input;
                        }
                    }

                    $scope.orderByCriteria = function (v1, v2) {
                        // If we don't get strings, just compare by index
                        if (v1.type !== 'string' || v2.type !== 'string') {
                            return (v1.index < v2.index)
                                ? -1
                                : 1;
                        }
                        return v1
                            .value
                            .localeCompare(v2.value);
                    }

                    $scope.toggleAllItems = function () {                       
                        var bookCode = $scope.chosenFilterCriteria;
                        for (var i = 0; i < $scope.gridData.length; i++) {
                            var identifier = $scope.gridData[i].Identifier.toLowerCase();
                            var newbookCode= bookCode ? bookCode.toLowerCase():"";
                            if (!bookCode || identifier.includes(newbookCode)) {
                                if (!$scope.gridData[i].isDisabled) {
                                    $scope.gridData[i].isSelected = $scope.allItemsSelected.checked;
                                }
                            }
                        }
                    }
                }
            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole').directive('dropdownClearSelection', dropdownClearSelection);

    function dropdownClearSelection($compile) {
        function link(scope, el, attrs, ctrl) {
            // This directive requires OL element that has "nya-bs-select" css class
            if (el[0].nodeName !== "OL" && !el[0].classList.contains("nya-bs-select")) {
                alert("dropdownClearSelection requires OL element and nya-bs-select CSS class");

                return;
            }

            el.wrap('<div class="element-with-clear-btn-wrapper"></div>');

            // Clear selection icon template
            var template = $compile('<a borderless-eks-icon ng-show="showClearBtn" href="#" ng-click="clearSelection()" class="clear-selection-btn"></a><hr />')(scope);
            el.after(template);

            scope.clearSelection = function () {
                scope.ngModel = null;
            };

            // Show/hide clear button when dropdown model change
            scope.$watch('ngModel', function (val) {
                var hasValue = angular.isDefined(val) && scope.ngModel != null;
                scope.showClearBtn = hasValue;
            });
        };

        return {
            restrict: 'A',
            scope: {
                ngModel:'='
            },
            link: link
        };
    }
}());
(function () {
    'use strict';
    angular.module('managementConsole').directive('executeOnEnter', function () {
        return {
            restrict: 'A',
            link: function (scope, el, attrs) {                      
                $('body').on('keypress', function (evt) {
          
                    if (evt.keyCode === 13) {
                        el.trigger('click', function () {
                        });
                    }            
                })
            
            },
            controller: function ($rootScope) {
                function removeEvent() {
                  
                    $("body").unbind("keypress");
                }
                $rootScope.$on('$stateChangeStart', removeEvent);
            }
        }
    })
}());

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('isolatedForm', function () {
            // This directive is used when parent form need to be validated without validating the nested forms (ng-form)
            return {
                restrict: 'A',
                require: '?form',
                link: function (scope, element, attrs, formController) {
                    if (!formController) {
                        return;
                    }

                    var parentForm = formController.$$parentForm; // Note this uses private API
                    if (!parentForm) {
                        return;
                    }

                    // Remove this form from parent controller
                    parentForm.$removeControl(formController);
                }
            };
        });
}());
(function () {
    'use strict';

    angular.module('managementConsole').directive('inputClear', inputClear);

    function inputClear($compile, $timeout) {
        function link(scope, el, attrs, ctrl) {
            // This directive requires input element
            if (el[0].nodeName !== "INPUT" && el[0].nodeName !== "TEXTAREA") {
                alert("inputClear is limited to input and textarea elements");

                return;
            }
            // This directive requires "name" attribute
            if (!el[0].name) {
                alert('inputClear requires name attribute');

                return;
            }

            // Wrap the input field with a div in order to position the close button
            el.wrap('<div class="element-with-clear-btn-wrapper"></div>');
            
            var modelName = attrs.ngModel;
     
            // Close button template
            var template = $compile('<a id="' + el[0].name + '" borderless-eks-icon href="#" ng-click="clearInput(\'' + el[0].name + '\',\'' + modelName + '\')" class="input-clear-btn"></a>')(scope);

            el.after(template);

            // Reset input field value (or model)
            scope.clearInput = function (inputName, modelName) {
                scope.$eval(modelName + " = ''");
              
                $timeout(function () {
                    var input = $('[name="' + inputName + '"]');
                    if (input && input.length > 0) {
                        input.focus();
                    }
                }, 0, false);
            };
            
            el.bind('input', function () {
                showHideClearButton(el, false);
            })
            .bind('focus', function() {
                showHideClearButton(el, false);
            })
            .bind('blur', function () {
                showHideClearButton(el, true);
            });


            function showHideClearButton(elem, forceHide) {
                $timeout(function () {
                    var isEmpty = forceHide ? true : ctrl.$isEmpty(elem.val());
                    var clearBtn = $('#' + elem[0].name);

                    if (clearBtn) {
                        if (isEmpty) {
                            clearBtn.removeClass('show-input-clear-btn');
                        }
                        else {
                            clearBtn.addClass('show-input-clear-btn');
                        }
                    }
                    else {
                        alert('inputClear requires name attribute');
                    }                
                }, 150);
            };
        }
        
        // Isolated scope is not used in order to avoid multiple isolated scopes error in case this directive is used with another one.
        return {
            require: 'ngModel',
            restrict: 'A',
            link: link
        };
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').directive('inputNumberPositive', inputNumberPositive);

    function inputNumberPositive($timeout) {
        function link(scope, el, attrs, ctrl) {
            el.bind('keydown', function (e) {
                // Disable all key codes except numbers, delete, increment and decrement
                if ((e.keyCode >= 48 && e.keyCode <= 57) ||
                    (e.keyCode >= 96 && e.keyCode <= 105) ||
                    e.keyCode === 8 ||
                    e.keyCode === 38 ||
                    e.keyCode === 40 ||
                    e.keyCode === 46) {
                    $timeout(function () {
                        // Deny user from entering other than numbers
                        var inputValue = ctrl.$viewValue.replace(/[^0-9]/g, '');

                        if (inputValue !== ctrl.$viewValue) {
                            ctrl.$setViewValue(inputValue);
                            ctrl.$render();
                        }
                    });
                }   
                else {
                    return false;
                }
            });
        }

        return {
            require: 'ngModel',
            restrict: 'A',
            link: link
        };
    }
}());
(function () {
    'use strict';
    // Directive to manage clicks outside target element
    // attrs.outsideClick: is the action that should be done when outside click occurs
    // attrs.ignoreFor: class names (seperated by comma ",") of the element which the click event management will be ignored
    angular.module('managementConsole').directive('outsideClick', outsideClick);

    function outsideClick($window, $parse) {
        function link(scope, el, attrs, ctrl) {
            if (!attrs.outsideClick) {
                alert("outside-click attribute value is undefined");

                return;
            }

            var classList = []
            if (attrs.ignoreFor) {
                classList = attrs.ignoreFor.split(/[,]+/)
            }

            var targetElement = el[0];
            var fn = $parse(attrs.outsideClick);

            var windowClickHandler = function (e) {
                // If click event occurs within the directive target element or elements with the given classes then ignore the action
                if (targetElement === e.target ||
                    targetElement.contains(e.target) ||
                    (classList.length > 0 && classList.includes(e.target.className)) ||
                    (e.target.tagName == 'svg' && classList.includes(e.target.parentElement.className))) {
                    return;
                }

                scope.$apply(fn);
            };

            $window.addEventListener('click', windowClickHandler, true);

            scope.$on('$destroy', function (e) {
                $window.removeEventListener('click', windowClickHandler);
            });
        }

        return {
            restrict: 'A',
            link: link
        };
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').directive('searchKeywords', searchKeywords);

    function searchKeywords($filter) {
        function link(scope, elem, attrs) {
            if (scope.keywordClass === undefined) {
                scope.keywordClass = "search-keywords-tags"; // Default directive css class
            }

            function buildKeywordsList() {
                if (scope.searchText !== undefined && scope.searchText.trim() !== "") {
                    // Remove double spaces
                    scope.searchText = scope.searchText.replace(/\s{2,}/g, ' ').trim();

                    var localSearchText = scope.searchText;
                    // Build the search text from model existing keywords array, if the joined value matches with the original text then no change was made. 
                    // This is mainly used for avoiding re-init of the keywords list
                    var keywordsJoinedArray = '';

                    if (scope.keywords.length > 0) {
                        keywordsJoinedArray = scope.keywords.map(function (elem) {
                            return elem.Value;
                        }).join(' ');
                    }

                    if (keywordsJoinedArray === localSearchText) {
                        return;
                    }
                    scope.keywords = [];

                    // Manage predefined keywords (avoid splitting them)
                    if (scope.predefinedKeywords !== undefined && scope.predefinedKeywords.length > 0) {
                        angular.forEach(scope.predefinedKeywords, function (value, key) {
                            localSearchText = localSearchText.toLowerCase().replace(scope.predefinedKeywords[key].toLowerCase(), scope.predefinedKeywords[key].toLowerCase().replace(' ', '~!@#$%^'));
                        })
                    }

                    var splittedSearchText = localSearchText.split(' ');

                    // Create keywords (array of keyword objects)
                    for (var t = 0; t < splittedSearchText.length; t++) {
                        scope.keywords.push({ Id: t + 1, Value: splittedSearchText[t].replace('~!@#$%^', ' '), HasResult: false });
                    }
                }
                else {
                    scope.keywords = [];
                }
            }

            scope.removeKeyword = function (keywordId) {
                var keyword = $filter('filter')(scope.keywords, { Id: keywordId }, true);
                var keywordIndex = 0;

                if (keyword && keyword !== undefined && keyword.length) {
                    keywordIndex = scope.keywords.indexOf(keyword[0]);
                    scope.keywords.splice(keywordIndex, 1);

                    scope.searchText = scope.keywords.map(function(elem){
                        return elem.Value;
                    }).join(' ');
                }

                if (scope.search) {
                    scope.search();
                }
            }

            scope.$watch('searchText', function () {
                buildKeywordsList();
            });
        }

        return {
            restrict: 'E',
            replace: true,
            scope: {
                searchText: '=',
                keywords: '=',
                predefinedKeywords: '=',
                search: '&',
                keywordClass: '@'
            },
            link: link,
            templateUrl: 'app/common/partials/_searchKeywords.html'
        };
    }

}());
(function () {
    'use strict';

    angular.module('managementConsole').filter('byteSizeToString', function () {
        var unitsArray = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        function getSuitableSizeUnit(sizeInBytes) {
            var unitIndex = 0;
            if (sizeInBytes > 0) {
                unitIndex = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
            }
            return unitsArray[unitIndex];
        }

        function convertTo(sizeInBytes, requestedUnit) {
            if (sizeInBytes === 0) {
                return 0;
            }
            var exponentPower = unitsArray.indexOf(requestedUnit);
            return parseFloat((sizeInBytes / Math.pow(1024, exponentPower)).toFixed(2));
        }

        return function (sizeInBytes) {
            var suitableUnit = getSuitableSizeUnit(sizeInBytes);
            return convertTo(sizeInBytes, suitableUnit).toString().replace(".00", "") +" "+ suitableUnit;

        };
    });

}());
(function () {
    'use strict';

    angular.module('managementConsole').filter('SchoolNameDisplayFilter', function () {
        return function (school) {
            return (school != undefined && school != null ? school.LongName : 'All schools');
        };
    });
}());
(function(){
    'use strict';

    angular.module('managementConsole').filter('statusImageFilter', statusImageFilter);

    function statusImageFilter() {
        function statusFilter(status) {
            var statusImg = "";

            switch (status) {
                case 0:
                case false:
                    statusImg = "enabled.svg";
                    break;
                case 1:
                case true:
                    statusImg = "disabled.svg";
                    break;
            }
            return statusImg;
        }

        return statusFilter;
    }
}());
(function () {
    angular.module('managementConsole').factory('chartOptionService', chartOptionFactory);

    function chartOptionFactory() {
        var chartOptionService = this;
        // Common options for all chart types
        var optionsBase = {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                backgroundColor: '#fff',
                cornerRadius: 0,
                borderColor: '#40b4e2',
                titleFontColor: '#40b4e2',
                bodyFontColor: '#40b4e2',
                borderWidth: 1,
                xPadding: 10,
                yPadding: 10
            },
            legend: {
                display: true,
                position: 'left'
            },
            title: {
                display: false,
                text: '',
                fontSize: 18,
                fontColor: '#7b6d65'
            }
        };

        chartOptionService.chartColors = [
            {
                backgroundColor: 'rgba(243, 117, 94, 0.9)',
                pointBackgroundColor: '#f3755f'
            }, {
                backgroundColor: 'rgba(174, 217, 241, 0.9)',
                pointBackgroundColor: '#aed9f1'
            }, {
                backgroundColor: 'rgba(255, 220, 146, 0.9)',
                pointBackgroundColor: '#ffdc92'
            }, {
                backgroundColor: 'rgba(229, 60, 46, 0.9)',
                pointBackgroundColor: '#e53c2e'
            }, {
                backgroundColor: 'rgba(227, 219, 211, 0.9)',
                pointBackgroundColor: '#e3dbd3'
            }, {
                backgroundColor: 'rgba(0, 128, 187, 0.9)',
                pointBackgroundColor: '#0080bb'
            }, {
                backgroundColor: 'rgba(64, 180, 229, 0.9)',
                pointBackgroundColor: '#40b4e5'
            }, {
                backgroundColor: 'rgba(252, 217, 209, 0.9)',
                pointBackgroundColor: '#fcd9d1'
            }, {
                backgroundColor: 'rgba(249, 190, 0, 0.9)',
                pointBackgroundColor: '#f9be00'
            }, {
                backgroundColor: 'rgba(182, 173, 164, 0.9)',
                pointBackgroundColor: '#b6ada4'
            }, {
                backgroundColor: 'rgba(0, 159, 203, 0.9)',
                pointBackgroundColor: '#009fcb'
            }, {
                backgroundColor: 'rgba(255, 240, 212, 0.9)',
                pointBackgroundColor: '#fff0d4'
            }, {
                backgroundColor: 'rgba(128, 198, 234, 0.9)',
                pointBackgroundColor: '#80c6ea'
            }, {
                backgroundColor: 'rgba(247, 162, 145, 0.9)',
                pointBackgroundColor: '#f7a291'
            }, {
                backgroundColor: 'rgba(123, 109, 101, 0.9)',
                pointBackgroundColor: '#7b6d65'
            }, {
                backgroundColor: 'rgba(1, 104, 54, 0.9)',
                pointBackgroundColor: '#016836'
            }

        ];

        // Pie chart options
        chartOptionService.pieOptions = jQuery.extend(true, {}, optionsBase);
        chartOptionService.pieOptions.pieceLabel = {
            render: 'value',
            fontSize: 14,
            fontStyle: 'bold',
            position: 'outside'
        };

        // Bar chart options
        chartOptionService.barOptions = optionsBase;

        return chartOptionService;
    }
}());
(function () {
    angular.module('managementConsole').factory('commonHelperService', commonHelperService);

    function commonHelperService() {
        var commonHelperService = this;

        commonHelperService.passwordRegExpression = new RegExp('^[a-zA-Z0-9_.-]*$');

        commonHelperService.transformDateToLocalTime = function (dateString) {
            if (!dateString || dateString == '') {
                return '';
            }

            if (dateString[dateString.length - 1] != 'Z') {
                dateString += 'Z';
            }

            return dateString;
        }

        commonHelperService.getFromSessionStorage = function (key) {
            var sessionStorageObject = sessionStorage.getItem(key);

            if (sessionStorageObject) {

                try {
                    return JSON.parse(sessionStorageObject);
                }
                catch (ex) {
                    return sessionStorageObject;
                }
            }
        }

        commonHelperService.setInSessionStorage = function (key,value) {
            try {
                localStorage.setItem(key, JSON.stringify(value));
            }
            catch(ex){
                console.log(ex);
            }
        }

        commonHelperService.getFromLocalStorage = function (key) {
            var localStorageObject = localStorage.getItem(key);

            if(localStorageObject){
                try {
                    return JSON.parse(decodeURI(localStorageObject));
                }
                catch (ex) {
                    return localStorageObject;
                }
            }
        }

        commonHelperService.setInLocalStorage = function (key, value) {
            try {
                localStorage.setItem(key, encodeURI(JSON.stringify(value)));
            }
            catch (ex) {
                console.log(ex);
            }
        }

/**         commonHelperService.isTokenExpired = function () {
            var currentUserTokenExpiry = userInfoService.getItem('tokenExpiry')

            if (currentUserTokenExpiry) {
                var currentTokenExpiryDate = new Date(currentUserTokenExpiry);

                if (currentTokenExpiryDate < new Date()) {

                    return true;
                }
                else return false;
            }
            return true;
        }
*/
        return commonHelperService;
    }
}());
(function () {
    angular.module('managementConsole').factory('authInterceptorService', authInteceptorFactory);

    function authInteceptorFactory(userInfoService, $location) {
        var authInterceptorService = this;

        // Add access token to each $http request
        authInterceptorService.request = function (config) {
            var accessToken = userInfoService.getUserToken();

            if (config.url.indexOf('login') === -1) {

                if (typeof accessToken !== 'undefined' && accessToken && accessToken !== '') {
                    config.headers['Authorization'] = 'Bearer ' + accessToken;

                    var currentUserTokenExpiry = userInfoService.getItem('tokenExpiry')

                    if (currentUserTokenExpiry) {
                        var currentTokenExpiryDate = new Date(currentUserTokenExpiry);
                        if (currentTokenExpiryDate < new Date()) {
                            userInfoService.resetUserToken();
                            window.location.href = window.location.origin + "/MC/ManagementConsole/logout";
                        }
                    }
                }
            }
            return config;
        };

        return authInterceptorService;
    }
}());
(function () {
    angular.module('managementConsole').factory('subjectService', subjectService);

    function subjectService($http, $q, CONSTANTS) {
        var subjectService = this;

        var subjectsURL = CONSTANTS.API_URL + '/subjects';
        var usersURL = CONSTANTS.API_URL + '/users';


        subjectService.getAllSubjects = function () {
            var deferred = $q.defer();
            $http.get(subjectsURL, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });
            return deferred.promise;
        };

        subjectService.getUserSubjects = function () {
            var deferred = $q.defer();
            $http.get(usersURL +'/user-subjects', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });
            return deferred.promise;
        };

        return subjectService;
    }
}());
(function () {
    angular.module('managementConsole').factory('userInfoService', userInfoFactory);

    function userInfoFactory(commonHelperService) {
        var userInfoService = this;

        userInfoService.userinfo = {};

        userInfoService.setUserToken = function (accessToken) {
            commonHelperService.setInLocalStorage('accessToken', accessToken);
        };

        userInfoService.getUserToken = function () {
            return commonHelperService.getFromLocalStorage('accessToken');
        };

        userInfoService.resetUserToken = function () {
            sessionStorage.removeItem('accessToken');
            localStorage.removeItem('accessToken');            
        };

        userInfoService.setUserPermissionStorage = function (permissions) {
            commonHelperService.setInLocalStorage('permissions', permissions);
        }

        userInfoService.setItem = function (key,value) {
            commonHelperService.setInLocalStorage(key, value);
        }

        userInfoService.getItem = function (key) {
            return commonHelperService.getFromLocalStorage(key);
        }

        userInfoService.getUserRoleId = function () {
            var userInfo = commonHelperService.getFromLocalStorage('userInfo');                         
            return userInfo.RoleId;
        }

        userInfoService.getUserPermissionStorage = function () {
            return commonHelperService.getFromLocalStorage('permissions');
        }

        userInfoService.setDashboardView = function (preferences) {
            var dashboardView = {};
            dashboardView.dashboardView = preferences;            
            var currentUser = commonHelperService.getFromLocalStorage('currentUser');
            if (currentUser) {               
                commonHelperService.setInLocalStorage('dashboardView', dashboardView);
            }         
        }

        userInfoService.getDashboardView = function () {
            var currentUser = commonHelperService.getFromLocalStorage('currentUser');
            if (currentUser && commonHelperService.getFromLocalStorage('dashboardView')) {           
                try{
                    return commonHelperService.getFromLocalStorage('dashboardView').dashboardView;
                }
                catch (ex) {
                    console.log(ex);
                }
            }
           
        }

        userInfoService.setDeviceStatisticsView = function (preferences) {
            commonHelperService.setInLocalStorage('deviceStatisticsView', preferences)
        }
        userInfoService.getDeviceStatisticsView = function () {
            return commonHelperService.getFromLocalStorage('deviceStatisticsView');
        }

        return userInfoService;
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('DashboardController', DashboardController);

    function DashboardController($rootScope, $scope, $state, $timeout, CONSTANTS, $filter, dashboardService, userInfoService, userService, chartOptionService, $q, commonHelperService) {
        var vm = this;

        vm.slickLoaded = true;// This is used as hack for the slick carousel for dynamic data loading.
        vm.slickConfig = {
            autoplay: false,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: true,
            method: {},
            event: {}
        };
        vm.bookStats = {};
  
        vm.pendingBooksVisible = $rootScope.checkForPermission('GetPendingBooks');
        //vm.isScheduledBooksVisible = $rootScope.checkForPermission('GetScheduledBooks');
        vm.approvedBooksVisible = $rootScope.checkForPermission('GetApprovedBooks');
        vm.releasedBooksVisible = $rootScope.checkForPermission('GetReleasedBooks');

        vm.booksStatisticsVisible = vm.pendingBooksVisible || vm.approvedBooksVisible || vm.releasedBooksVisible;
  
        vm.allReleases = [];   
        var currentBooksCovers = 0,
            coversPerLine = 5;

        vm.coverUrlFirstPart = CONSTANTS.API_URL + '/books/';
        vm.coverUrlSecondPart = '/thumbs/page-1/jpeg';

        vm.initModule = function () {
           
        };

        personalizedView = userInfoService.getDashboardView();

        //set to default values if none
        if (!personalizedView) {
            vm.booksPanelOpen = true;

            var personalizedView = {
                statisticTabOpen: false,
                currentBookSectionOpened: ''
            };
        }

        if (personalizedView && Object.keys(personalizedView).length != 0) {
            if (personalizedView.currentBookSectionOpened && personalizedView.currentBookSectionOpened.length > 0 && $state.current.name != personalizedView.currentBookSectionOpened)
                $state.go(personalizedView.currentBookSectionOpened);
            if (personalizedView.currentBookSectionOpened && personalizedView.currentBookSectionOpened.length > 0)
                vm.booksPanelOpen = true;
        }
        var options = jQuery.extend(true, {}, chartOptionService.barOptions);
   
        vm.getStatsForBooks = function () {
            dashboardService.getStats()
                .then(function (res) {
                    vm.bookStats = {
                        booksInTesting: res.data.InTesting,
                        booksApproved: res.data.Approved
                    };

                }, function (err) {
                    console.log(err)
                });
        };

        vm.setActiveTab = function (nameOfState) {
            personalizedView.currentBookSectionOpened = nameOfState;
            userInfoService.setDashboardView(personalizedView);
        }

        function getMoreBookCovers(collectionToAdd, begin, end) {
            var newCovers = vm.bookCoversAll.slice(begin, end);
            newCovers.forEach(function (currentValue) {
                collectionToAdd.push(currentValue);
            })
            return collectionToAdd;
        }

        vm.calculateBookCoversPerLine = function () {
            var containerWidth = $('.container-book-covers').width() || 1000;
            containerWidth -= 30;


            var currentMargin = 2 / 100 * containerWidth;
            //value for class book-cover-dashboard
            var bookCoversWidth = 174;


            var booksPerLine = 0;

            while (true) {
                containerWidth -= bookCoversWidth;

                booksPerLine++;

                if (containerWidth < 0) {
                    booksPerLine--;
                    break;
                }
                containerWidth -= currentMargin;

            }

            coversPerLine = booksPerLine;
        }

        vm.getReleasedBooks = function (numberOfRelease) {
            dashboardService.getReleaseBooks(numberOfRelease)
                .then(function (res) {

                    //fix wrong date format
                    res.data.ReleaseDate = commonHelperService.transformDateToLocalTime(res.data.ReleaseDate);

                    vm.calculateBookCoversPerLine();
                    vm.allReleases.push({
                        name: res.data.Name,
                        date: res.data.ReleaseDate,
                        books: res.data.Books
                    });

                    if (res.data.Books) {
                        vm.bookStats.booksReleased = res.data.Books.length;
                        vm.allBooksReleased = vm.allReleases[0].books.length;
                        vm.bookCoversAll = angular.copy(vm.allReleases[0].books);
                        vm.bookCovers = [];
                        vm.bookCovers = vm.addMoreBookCovers();
                    } else {
                        vm.bookStats.booksReleased = 0;
                        vm.allBooksReleased = 0;
                    }


                }, function (err) {
                    vm.bookStats.booksReleased = 0;
                    console.log(err)
                });
        };

        vm.addMoreBookCovers = function () {
            vm.bookCovers = getMoreBookCovers(vm.bookCovers, currentBooksCovers * coversPerLine, (currentBooksCovers + 1) * coversPerLine);
            currentBooksCovers += 1;

            return vm.bookCovers;
        }

        vm.getBooksInTesting = function () {

            dashboardService.getBooksInTesting()
                .then(function (res) {
                    vm.calculateBookCoversPerLine();

                    vm.allBooksInTesting = res.data.length;
                    vm.bookCoversAll = angular.copy(res.data);
                    vm.bookCovers = [];
                    vm.bookCovers = vm.addMoreBookCovers();

                }, function (err) {
                    console.log(err)
                });
        };

        vm.getApprovedBooks = function () {
            dashboardService.getApprovedBooks()
                .then(function (res) {
                    vm.calculateBookCoversPerLine();
                    vm.allBooksInTesting = res.data.length;
                    vm.bookCoversAll = angular.copy(res.data);
                    vm.bookCovers = [];
                    vm.bookCovers = vm.addMoreBookCovers();

                }, function (err) {
                    console.log(err)
                })
        }

        vm.togglePanel = function () {

        }

        vm.initModule();
    }

}());
(function () {
    angular.module('managementConsole').factory('dashboardService', dashboardService);

    /** @ngInject */
    function dashboardService($http, $q, CONSTANTS) {
        var dashboardService = this,
            statsUrl = CONSTANTS.API_URL + '/stats/counts',
            releasedUrl = CONSTANTS.API_URL + '/stats/released-books/',
            testingUrl = CONSTANTS.API_URL + '/stats/in-testing',
            approvedBooks = CONSTANTS.API_URL + '/stats/approved',
            dashboardURL = CONSTANTS.API_URL + '/bookshelfDownloads';

        dashboardService.getStats = function () {
            var deferred = $q.defer();

            $http
                .get(statsUrl, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(function (res) {
                    deferred.resolve(res);
                }, function (err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        };

        dashboardService.getReleaseBooks = function (numberOfRelease) {
            var deferred = $q.defer();

            $http
                .get(releasedUrl + numberOfRelease, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(function (res) {
                    deferred.resolve(res);
                }, function (err) {
                    deferred.reject(err)
                });
            return deferred.promise;
        };

        dashboardService.getAllReleasedBooks = function () {
            var deferred = $q.defer();

            $http
                .get(releasedUrl, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(function (res) {
                    deferred.resolve(res);
                }, function (err) {
                    deferred.reject(err)
                })
            return deferred.promise;
        }

        dashboardService.getBooksInTesting = function () {
            var deferred = $q.defer();

            $http
                .get(testingUrl, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(function (res) {
                    deferred.resolve(res);
                }, function (err) {
                    deferred.reject(err)
                })
            return deferred.promise;
        }

        dashboardService.getApprovedBooks = function () {
            var deferred = $q.defer();

            $http
                .get(approvedBooks, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(function (res) {
                    deferred.resolve(res);
                }, function (err) {
                    deferred.reject(err)
                })
            return deferred.promise;
        }

     
        return dashboardService;
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('ManagementController', ManagementController);

    function ManagementController() {
        
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('LayoutController', LayoutController);

    function LayoutController($state, $rootScope, $scope, $timeout, $window, $filter, moment, toastr, userService, userInfoService, commonHelperService) {
        var vm = this;
        vm.currentYear = moment().format('YYYY');

        vm.isHeaderAndMenuVisible = false;

        vm.menuItems = [
            {
                id: 1,
                image: 'someImage',
                text: 'Dashboard',
                stateName: 'mainAuth.dashboard',
                icon: 'assets/images/dashboard-icon.svg',
                stateVisible: true
            }, {
                id: 2,
                image: 'someImage',
                text: 'Management',
                stateName: 'mainAuth.management',
                icon: 'assets/images/management-icon.svg',
                stateVisible: false,
                tabActive: false,
                subTabs: [
                    {
                        id: 3,
                        text: 'User Management',
                        stateName: 'mainAuth.management.user',
                        stateVisible: false
                    },
                    {
                        id: 10,
                        text: 'Loaner Management',
                        stateName: 'mainAuth.management.loaner',
                        stateVisible: false
                    },
                    {
                        id: 4,
                        text: 'Role Management',
                        stateName: 'mainAuth.management.role',
                        stateVisible: false
                    },
                    {
                        id: 5,
                        text: 'Book Management',
                        stateName: 'mainAuth.management.book',
                        stateVisible: true
                    },
                    {
                        id: 6,
                        text: 'Device Management',
                        stateName: 'mainAuth.management.device',
                        stateVisible: false
                    }
                ]
            }, {
                id: 7,
                image: 'someImage',
                text: 'Release Scheduling',
                stateName: 'mainAuth.releaseScheduling',
                icon: 'assets/images/release-icon.svg',
                stateVisible: false
            }, {
                id: 9,
                image: 'someImage',
                text: 'Reports',
                stateName: 'mainAuth.reports',
                icon: 'assets/images/release-icon.svg',
                stateVisible: false
            },

            {
                id: 8,
                image: 'someImage',
                text: 'Settings',
                stateName: 'mainAuth.systemSettings',
                icon: 'assets/images/settings-icon.svg',
                stateVisible: false,
                tabActive: false,
                subTabs: [
                    {
                        id: 11,
                        text: 'Notification Settings',
                        stateName: 'mainAuth.notificationSettings',
                        stateVisible: false
                    },
                    {
                        id: 12,
                        text: 'Application Settings',
                        stateName: 'mainAuth.applicationSettings',
                        stateVisible: false
                    },
                    {
                        id: 13,
                        text: 'User Access',
                        stateName: 'mainAuth.userAccessSettings',
                        stateVisible: false
                    },
                    {
                        id: 14,
                        text: 'Support Settings',
                        stateName: 'mainAuth.supportSettings',
                        stateVisible: false
                    },
                    {
                        id: 15,
                        text: 'Data Cleaning',
                        stateName: 'mainAuth.dataCleaning',
                        stateVisible: false
                    }
                ]
            },
            {
                id: 16,
                image: 'someImage',
                text: 'Copyright and Licenses',
                stateName: 'mainAuth.copyrights-and-licenses',
                icon: 'assets/images/CopyrightandLicensesIcon.svg',
                stateVisible: true
            }
        ];

        // Watch for scrollbar visibility
        $scope.$watch(function () {
            return $(document).height() + $(window).height();
        },
            function () {
                setLayoutFullHeight();
            });

        angular.element($window).bind('resize', function () {
            setLayoutFullHeight();
        });

        if (commonHelperService.getFromLocalStorage('accessToken')) {
            vm.isHeaderAndMenuVisible = true;
        } else {
            vm.isHeaderAndMenuVisible = false;
        }

        // Set smaller layout container to the highest one
        function setLayoutFullHeight() {
            $timeout(function () {
                if ($('.side-container').height() > $('.main-container').height()) {
                    if ($('.side-container > nav').height() > $('.main-container').height()) {
                        $('.main-container').height($('.side-container').height());
                    }
                    else {
                        $('.side-container').height($('.main-container').height());
                    }
                }
                else {
                    $('.side-container').height($('.main-container').height());
                }
            }, 1000);
        }


        vm.pendingBooksVisible = $rootScope.checkForPermission('GetPendingBooks');
        vm.approvedBooksVisible = $rootScope.checkForPermission('GetApprovedBooks');
        vm.releasedBooksVisible = $rootScope.checkForPermission('GetReleasedBooks');

        vm.changePassVisible = $rootScope.checkForPermission('ChangePassword');

        if (!vm.releasedBooksVisible && !vm.approvedBooksVisible && !vm.pendingBooksVisible) {
            for (var i = 0; i < vm.menuItems.length; i++) {
                if (vm.menuItems[i].text == 'Management') {
                    for (var q = 0; q < vm.menuItems[i].subTabs.length; q++) {
                        if (vm.menuItems[i].subTabs[q].stateName == 'mainAuth.management.book') {
                            vm.menuItems[i].subTabs.splice(q, 1);
                        }
                    }
                }
            }
        }


        vm.me = null;
        vm.managementActive = false;
        vm.menuActive = true;

        vm.initModule = function () {
            var accessToken = userInfoService.getUserToken();

            if (typeof accessToken !== 'undefined' && accessToken && accessToken !== '') {
                vm.getMyInfo();
                vm.filterMenuPerPermissions();
            }
        }

        vm.getMyInfo = function () {
            userService.getMyInfo().then(function (response) {
                vm.me = response;
                commonHelperService.setInLocalStorage('userInfo', response);
            },
                function (error) {
                    toastr.error('getMyInfo: ' + error);
                });
        };

        vm.filterMenuPerPermissions = function () {
            applyMenuItemPermission(['GetUsers'], 2, 3);
            applyMenuItemPermission(['GetUsers'], 2, 11);
            applyMenuItemPermission(['GetRoles'], 2, 4);
            applyMenuItemPermission(['GetDevices'], 2, 6);
            applyMenuItemPermission(['GetReleases'], null, 7);
            applyMenuItemPermission(['GetSettings'], null, 8);
            applyMenuItemPermission(['ManageNotificationSettings'], 8, 11);
            applyMenuItemPermission(['ManageApplicationSettings'], 8, 12);
            applyMenuItemPermission(['ManageUserAccessSettings'], 8, 13);
            applyMenuItemPermission(['ManageSupportSettings'], 8, 14);
            applyMenuItemPermission(['AccessCleaningTool'], 8, 15);
            applyMenuItemPermission(['GetDownloadStatistics', 'GetSlaveStatistics', 'ViewReleasedBooksReport'], null, 9);
            applyMenuItemPermission(['ViewLoaner'], 2, 10);
            // Hide parent menu items when all sub items are not visible
            applyParentMenuItemPermission();
        };

        function applyMenuItemPermission(permissionNames, parentMenuItemId, menuItemId) {
            var hasPermission = false;
            permissionNames.forEach(function (permissionName) {
                if ($rootScope.checkForPermission(permissionName)) {
                    hasPermission = true;
                }
            });

            var filteredMenuItems = vm.menuItems;

            if (parentMenuItemId !== null) {
                var parentItems = $filter('filter')(vm.menuItems, { 'id': parentMenuItemId });

                if (parentItems && parentItems[0].subTabs) {
                    filteredMenuItems = parentItems[0].subTabs;
                }
            }

            var item = $filter('filter')(filteredMenuItems, { 'id': menuItemId });
            if (item && item[0]) {
                item[0].stateVisible = hasPermission;
            }
        }

        function applyParentMenuItemPermission() {
            // Get menu items that has sub items
            var parentItems = $filter('filter')(vm.menuItems, function (value, index, array) {
                if (value.subTabs) {
                    return true;
                }
            });

            // For each menu with sub items, check if at least one of the child items is visible. If yes then show the parent menu item
            angular.forEach(parentItems, function (parentItem, key) {
                angular.forEach(parentItem.subTabs, function (childItem, key) {
                    if (childItem.stateVisible) {
                        parentItem.stateVisible = true;
                        return;
                    }
                });
            });
        }

        vm.logoutUser = function () {
            window.location.href = window.location.origin + "/MC/ManagementConsole/logout";
        };

        vm.initModule();
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').directive('cmsSideMenu', cmsSideMenu);

    function cmsSideMenu($state, $compile) {
        function CmsSideMenuController($rootScope, $scope, $state, $timeout) {
            $scope.$state = $state;

            // Watch for 'relatedState' $rootScope variable in order to keep submenu parent item active
            $scope.$watch(function () {
                return $rootScope.relatedState;
            }, function () {
                $timeout(function () {
                    $scope.relatedState = $rootScope.relatedState;
                },100);
            });

            $scope.collapseAllSubItems = function () {
                var parentItems = $scope.menuItems.filter(function (obj) {
                    return obj.subTabs && obj.subTabs.length > 0;
                });

                angular.forEach(parentItems, function (value, key) {
                    parentItems[key].tabActive = false;
                });
            };
        }
        return {
            restrict: 'E',
            scope: {
                menuItems: '=',
                logout: '&?'
            },
            controller: CmsSideMenuController,
            controllerAs: 'cmsSideMenuCtrl',
            templateUrl: 'app/layout/partials/_sideMenu.html'
        };
    }

}());
(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('hamburgerIcon', function () {
            return {
                restrict: 'A',
                scope: {
                    bindClass: '@'
                },
                template: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="20px" height="16px" viewBox="0 0 20 16" enable-background="new 0 0 20 16" xml:space="preserve"><g>	<rect fill="#FFFFFF" width="20" height="2"/>	<rect y="7" fill="#FFFFFF" width="20" height="2"/>	<rect y="14" fill="#FFFFFF" width="20" height="2"/></g></svg>'
            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('heightWatch', function () {
            return {
                restrict: 'A',
                link: function (scope,linkElement,attr) {
                    scope.$watch(function () {
                        return linkElement.height();
                    },
                    function (newValue, oldValue) {
                        if (newValue != oldValue) {
                            $('.side-menu-fullheight').height(newValue);
                        }
                    }
    );
                }
            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('plusIcon', function () {
            return {
                restrict: 'AE',
                replace: true,
                template: '<div class="action-svg-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 0 15 15" width="15" height="15"><defs><path d="M15 7.5L0 7.5" id="a9fV0uyJ8"></path><path d="M7.5 15L7.5 0" id="eBa1jwyQz"></path></defs><g><g><g><g><use xlink:href="#a9fV0uyJ8" opacity="1" fill-opacity="0" stroke="#ffffff" stroke-width="1" stroke-opacity="1"></use></g></g><g><g><use xlink:href="#eBa1jwyQz" opacity="1" fill-opacity="0" stroke="#ffffff" stroke-width="1" stroke-opacity="1"></use></g></g></g></g></svg></div>'
            };
        })
        .directive('minusIcon', function () {
            return {
                restrict: 'AE',
                replace: true,
                template: '<div class="action-svg-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 0 15 15" width="15" height="15"><defs><path d="M15 7.5L0 7.5" id="e3oA9kB6N"></path></defs><g><g><g><use xlink:href="#e3oA9kB6N" opacity="1" fill="#ffffff" fill-opacity="1"></use><g><use xlink:href="#e3oA9kB6N" opacity="1" fill-opacity="0" stroke="#ffffff" stroke-width="1" stroke-opacity="1"></use></g></g></g></g></svg></div>'
            };
        })
        .directive('addIcon', function () {
            return {
                restrict: 'AE',
                replace: true,
                template: '<div class="action-svg-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="11px" height="11px" viewBox="0 0 13 13" enable-background="new 0 0 13 13" xml:space="preserve"><path fill="#0080BB" d="M12.256,5.755H7.244v-5.01C7.244,0.334,6.91,0,6.5,0S5.756,0.334,5.756,0.745v5.01H0.744            C0.334,5.755,0,6.089,0,6.5s0.334,0.745,0.744,0.745h5.012v5.01C5.756,12.666,6.09,13,6.5,13s0.744-0.334,0.744-0.745v-5.01h5.012            C12.666,7.245,13,6.911,13,6.5S12.666,5.755,12.256,5.755z"/>        </svg></div>'
            };
        })
        .directive('viewIcon', function () {
            return {
                restrict: 'AE',
                replace: true,
                template: '<div class="action-svg-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 25 25" enable-background="new 0 0 25 25" xml:space="preserve"><g><g><g><g><path fill="#7B6E66" d="M12.5,24.916c-6.846,0-12.416-5.568-12.416-12.416c0-6.846,5.57-12.417,12.416-12.417 S24.916,5.654,24.916,12.5C24.916,19.348,19.346,24.916,12.5,24.916L12.5,24.916z M12.5,0.635  C5.959,0.635,0.636,5.958,0.636,12.5c0,6.543,5.323,11.865,11.864,11.865c6.542,0,11.864-5.322,11.864-11.865 C24.364,5.958,19.042,0.635,12.5,0.635L12.5,0.635z"/> <path fill="#7B6E66" d="M12.5,25.041c-6.915,0-12.541-5.627-12.541-12.541c0-6.916,5.626-12.542,12.541-12.542 S25.041,5.584,25.041,12.5C25.041,19.414,19.415,25.041,12.5,25.041z M12.5,0.208C5.723,0.208,0.209,5.723,0.209,12.5	S5.723,24.791,12.5,24.791S24.791,19.277,24.791,12.5S19.277,0.208,12.5,0.208z M12.5,24.49c-6.611,0-11.989-5.379-11.989-11.99	S5.889,0.51,12.5,0.51S24.489,5.889,24.489,12.5S19.111,24.49,12.5,24.49z M12.5,0.76C6.027,0.76,0.761,6.027,0.761,12.5 c0,6.475,5.267,11.74,11.739,11.74s11.739-5.266,11.739-11.74C24.239,6.027,18.973,0.76,12.5,0.76z"/>	</g></g></g><g><g><g><path fill="#7B6E66" d="M12.5,16.846c-2.797,0-5.233-1.711-6.064-4.259c-0.019-0.056-0.019-0.117,0-0.172	c0.832-2.548,3.27-4.26,6.064-4.26s5.232,1.712,6.064,4.26c0.018,0.055,0.018,0.116,0,0.172	C17.732,15.135,15.295,16.846,12.5,16.846L12.5,16.846z M6.988,12.5c0.783,2.273,2.986,3.795,5.512,3.795	c2.524,0,4.727-1.521,5.51-3.795c-0.783-2.273-2.986-3.794-5.51-3.794C9.975,8.706,7.773,10.227,6.988,12.5L6.988,12.5z"/><path fill="#7B6E66" d="M12.5,16.971c-2.851,0-5.336-1.746-6.184-4.346c-0.026-0.081-0.026-0.17,0-0.25 C7.166,9.776,9.65,8.029,12.5,8.029s5.334,1.747,6.184,4.347c0.025,0.08,0.025,0.167,0,0.248	C17.834,15.225,15.35,16.971,12.5,16.971z M12.5,8.279c-2.74,0-5.13,1.677-5.945,4.174c-0.011,0.031-0.01,0.063,0,0.094 	c0.814,2.498,3.203,4.173,5.945,4.173c2.741,0,5.131-1.676,5.945-4.173c0.01-0.03,0.01-0.064,0-0.095 C17.63,9.957,15.241,8.279,12.5,8.279z M12.5,16.42c-2.567,0-4.83-1.559-5.63-3.879L6.855,12.5l0.015-0.041	c0.802-2.319,3.063-3.878,5.63-3.878c2.567,0,4.829,1.559,5.628,3.878l0.014,0.041l-0.014,0.041 C17.328,14.861,15.066,16.42,12.5,16.42z M7.121,12.5c0.777,2.197,2.934,3.67,5.379,3.67s4.601-1.473,5.377-3.67	c-0.776-2.196-2.932-3.669-5.377-3.669C10.056,8.831,7.899,10.304,7.121,12.5z"/></g></g><g><path fill="#7B6E66" d="M14.525,14.285c0.08-0.088,0.16-0.178,0.228-0.277c0.049-0.07,0.082-0.148,0.122-0.225 c0.044-0.082,0.094-0.16,0.131-0.246c0.029-0.072,0.045-0.148,0.069-0.223c0.029-0.096,0.064-0.188,0.085-0.289	c0.016-0.08,0.016-0.162,0.023-0.244c0.011-0.094,0.028-0.184,0.028-0.281c0-0.098-0.018-0.192-0.029-0.288	c-0.008-0.079-0.008-0.159-0.022-0.236c-0.021-0.101-0.057-0.196-0.087-0.293c-0.023-0.073-0.038-0.147-0.067-0.219	c-0.037-0.086-0.086-0.165-0.131-0.247c-0.04-0.074-0.073-0.152-0.122-0.224c-0.062-0.093-0.138-0.176-0.211-0.26	c-0.044-0.049-0.078-0.104-0.124-0.152c-0.053-0.052-0.111-0.09-0.167-0.136c-0.08-0.068-0.156-0.14-0.243-0.198  c-0.078-0.053-0.162-0.09-0.244-0.132c-0.076-0.041-0.147-0.086-0.226-0.12c-0.081-0.032-0.165-0.051-0.247-0.076	c-0.087-0.028-0.173-0.062-0.265-0.078c-0.101-0.021-0.201-0.023-0.302-0.031c-0.076-0.006-0.148-0.023-0.225-0.023	c-0.004,0-0.007,0.002-0.012,0.002c-0.69,0.003-1.381,0.266-1.908,0.793c-0.526,0.525-0.79,1.216-0.793,1.909	c0,0.003-0.002,0.005-0.002,0.008c0,0.056,0.014,0.108,0.017,0.163c0.007,0.124,0.014,0.246,0.038,0.367  c0.016,0.082,0.046,0.158,0.069,0.236c0.027,0.092,0.049,0.186,0.085,0.275c0.029,0.068,0.069,0.129,0.104,0.197	c0.048,0.09,0.09,0.186,0.149,0.273c0.042,0.062,0.095,0.113,0.141,0.172c0.063,0.08,0.119,0.162,0.192,0.236	c0.004,0.004,0.008,0.004,0.013,0.008c0.49,0.486,1.164,0.787,1.907,0.787s1.418-0.303,1.908-0.789 	c0.004-0.002,0.006-0.002,0.009-0.006C14.459,14.379,14.488,14.33,14.525,14.285z M10.799,13.818	c-0.03-0.037-0.066-0.074-0.094-0.115c-0.047-0.068-0.081-0.146-0.12-0.221c-0.026-0.051-0.06-0.102-0.081-0.154 c-0.028-0.066-0.045-0.141-0.066-0.213c-0.02-0.064-0.044-0.128-0.057-0.194c-0.018-0.085-0.021-0.175-0.027-0.263	c-0.044-0.605,0.155-1.225,0.616-1.686c0.474-0.473,1.114-0.671,1.732-0.613c0.071,0.007,0.147,0.009,0.215,0.023  c0.077,0.014,0.15,0.042,0.226,0.066c0.06,0.019,0.124,0.032,0.183,0.057c0.066,0.027,0.129,0.067,0.192,0.1	c0.062,0.034,0.125,0.062,0.183,0.101c0.079,0.052,0.15,0.117,0.223,0.182c0.062,0.054,0.121,0.111,0.177,0.172	c0.069,0.078,0.14,0.155,0.195,0.24c0.036,0.054,0.062,0.114,0.093,0.171c0.038,0.068,0.079,0.134,0.107,0.204  c0.022,0.054,0.035,0.113,0.054,0.169c0.024,0.079,0.053,0.157,0.07,0.238c0.011,0.059,0.011,0.123,0.018,0.185	c0.017,0.149,0.018,0.298,0.003,0.447c-0.007,0.068-0.008,0.138-0.021,0.204c-0.017,0.075-0.043,0.147-0.066,0.221	c-0.02,0.062-0.034,0.127-0.058,0.186c-0.026,0.064-0.063,0.125-0.098,0.186c-0.033,0.064-0.062,0.131-0.104,0.191	c-0.048,0.07-0.107,0.135-0.164,0.201c-0.396,0.459-0.977,0.758-1.63,0.758C11.807,14.662,11.194,14.328,10.799,13.818z"/><path fill="#7B6E66" d="M12.5,15.34c-0.751,0-1.459-0.293-1.995-0.822c-0.067-0.064-0.112-0.123-0.157-0.182l-0.057-0.074			c-0.018-0.021-0.035-0.041-0.053-0.062c-0.033-0.037-0.066-0.076-0.095-0.119c-0.047-0.066-0.084-0.141-0.12-0.215l-0.074-0.139 c-0.025-0.045-0.05-0.09-0.07-0.137c-0.028-0.072-0.049-0.143-0.068-0.213l-0.045-0.148c-0.019-0.059-0.037-0.115-0.049-0.174 c-0.024-0.124-0.031-0.247-0.039-0.366c-0.002-0.038-0.005-0.058-0.008-0.077c-0.005-0.036-0.01-0.073-0.01-0.111l0.002-0.035 c0.01-0.747,0.304-1.445,0.83-1.97c0.525-0.527,1.229-0.822,1.979-0.83L12.5,9.662c0.053,0,0.104,0.007,0.154,0.014 c0.026,0.004,0.053,0.007,0.08,0.01l0.072,0.005c0.082,0.005,0.164,0.011,0.244,0.028c0.073,0.013,0.146,0.037,0.217,0.061 l0.137,0.042c0.061,0.017,0.121,0.034,0.18,0.057c0.062,0.026,0.115,0.057,0.171,0.088l0.128,0.068  c0.066,0.033,0.132,0.066,0.195,0.109c0.07,0.047,0.136,0.104,0.2,0.16l0.108,0.089c0.041,0.031,0.081,0.062,0.119,0.099 c0.031,0.032,0.056,0.064,0.081,0.097c0.016,0.021,0.031,0.042,0.049,0.061l0.026,0.03c0.068,0.078,0.137,0.157,0.194,0.243 c0.036,0.054,0.065,0.11,0.094,0.167l0.072,0.134c0.035,0.062,0.069,0.125,0.099,0.191c0.021,0.051,0.035,0.103,0.049,0.154 c0.007,0.025,0.015,0.051,0.022,0.076l0.024,0.076c0.025,0.076,0.05,0.151,0.065,0.23c0.012,0.058,0.016,0.114,0.019,0.171 l0.016,0.146c0.011,0.077,0.021,0.153,0.021,0.232c0,0.076-0.01,0.147-0.02,0.219l-0.015,0.151 c-0.004,0.06-0.009,0.12-0.02,0.179c-0.017,0.077-0.04,0.151-0.063,0.224l-0.025,0.078c-0.009,0.029-0.017,0.057-0.024,0.084 c-0.014,0.049-0.028,0.1-0.048,0.148c-0.028,0.066-0.062,0.125-0.096,0.186l-0.074,0.139c-0.029,0.059-0.059,0.117-0.096,0.17 c-0.072,0.107-0.156,0.201-0.238,0.291l-0.03,0.041c-0.026,0.033-0.052,0.068-0.084,0.1l-0.028,0.021 C13.96,15.047,13.251,15.34,12.5,15.34z M9.911,12.524c0.001,0.018,0.004,0.035,0.007,0.052c0.004,0.026,0.007,0.052,0.009,0.078 c0.008,0.135,0.015,0.244,0.035,0.35c0.011,0.05,0.026,0.097,0.042,0.146l0.047,0.158c0.018,0.062,0.035,0.125,0.06,0.186 c0.017,0.037,0.036,0.074,0.058,0.111c0.014,0.023,0.027,0.049,0.041,0.074l0.037,0.074c0.031,0.062,0.063,0.127,0.104,0.188 c0.023,0.033,0.051,0.064,0.076,0.094c0.021,0.023,0.041,0.047,0.061,0.072l0.06,0.076c0.038,0.051,0.077,0.102,0.122,0.148 c0.502,0.49,1.147,0.758,1.832,0.758s1.331-0.268,1.82-0.752l0.017-0.014c0.022-0.025,0.036-0.045,0.051-0.064 c0.013-0.018,0.026-0.035,0.041-0.055c0.083-0.092,0.158-0.174,0.221-0.268c0.031-0.045,0.055-0.094,0.078-0.141l0.081-0.15 c0.029-0.053,0.059-0.104,0.082-0.158c0.016-0.039,0.027-0.08,0.039-0.121c0.008-0.031,0.017-0.061,0.026-0.092l0.026-0.08 c0.021-0.064,0.042-0.127,0.056-0.194c0.009-0.047,0.012-0.097,0.015-0.146l0.018-0.169c0.008-0.061,0.017-0.122,0.017-0.186 c0-0.067-0.01-0.133-0.019-0.198l-0.017-0.164c-0.003-0.047-0.006-0.093-0.015-0.139c-0.014-0.067-0.036-0.134-0.058-0.2 l-0.025-0.079c-0.009-0.028-0.017-0.057-0.025-0.085c-0.011-0.042-0.021-0.083-0.038-0.123c-0.024-0.056-0.056-0.11-0.086-0.165 l-0.078-0.145c-0.023-0.047-0.047-0.094-0.077-0.139c-0.053-0.078-0.114-0.148-0.176-0.218l-0.025-0.03 c-0.021-0.023-0.041-0.049-0.061-0.075c-0.019-0.024-0.037-0.049-0.06-0.072c-0.027-0.027-0.061-0.051-0.093-0.076 c-0.021-0.016-0.043-0.033-0.063-0.05l-0.058-0.05c-0.057-0.05-0.113-0.099-0.176-0.141c-0.054-0.037-0.111-0.064-0.168-0.093 l-0.14-0.074c-0.047-0.027-0.093-0.053-0.143-0.075c-0.047-0.019-0.099-0.033-0.15-0.047l-0.15-0.046 c-0.06-0.02-0.12-0.041-0.184-0.052c-0.072-0.015-0.144-0.02-0.215-0.024l-0.075-0.005c-0.032-0.002-0.063-0.007-0.094-0.011 c-0.034-0.004-0.067-0.01-0.103-0.011l-0.029,0.002c-0.689,0.003-1.336,0.272-1.82,0.757c-0.484,0.484-0.753,1.131-0.756,1.821 L9.911,12.524z M12.5,14.787c-0.703,0-1.359-0.324-1.8-0.891l-0.03-0.037c-0.025-0.027-0.049-0.057-0.069-0.088 c-0.036-0.051-0.065-0.109-0.095-0.17l-0.059-0.109c-0.021-0.039-0.043-0.076-0.059-0.117c-0.021-0.051-0.038-0.107-0.054-0.164 L10.3,13.096c-0.017-0.051-0.032-0.1-0.042-0.15c-0.016-0.075-0.021-0.153-0.025-0.231l-0.004-0.047 c-0.049-0.669,0.189-1.319,0.652-1.783c0.479-0.477,1.149-0.715,1.833-0.649l0.066,0.006c0.056,0.004,0.11,0.008,0.162,0.019 c0.062,0.011,0.123,0.031,0.186,0.052l0.113,0.035c0.045,0.012,0.09,0.025,0.133,0.043c0.046,0.019,0.093,0.044,0.139,0.07 l0.122,0.065c0.047,0.023,0.093,0.047,0.136,0.077c0.08,0.053,0.152,0.118,0.223,0.181c0.077,0.068,0.141,0.128,0.199,0.193 c0.078,0.087,0.148,0.167,0.207,0.256c0.025,0.038,0.048,0.081,0.068,0.123l0.053,0.098c0.033,0.058,0.066,0.116,0.091,0.176 c0.015,0.037,0.027,0.078,0.038,0.118l0.037,0.119c0.021,0.063,0.041,0.126,0.055,0.191c0.009,0.045,0.012,0.087,0.015,0.131 l0.005,0.067c0.018,0.157,0.019,0.316,0.003,0.473l-0.005,0.065c-0.004,0.051-0.008,0.102-0.017,0.15 c-0.015,0.064-0.033,0.123-0.053,0.182l-0.036,0.117c-0.013,0.045-0.025,0.088-0.042,0.131c-0.022,0.055-0.052,0.107-0.081,0.158 l-0.047,0.088c-0.026,0.053-0.053,0.105-0.086,0.154c-0.04,0.059-0.088,0.113-0.136,0.17l-0.037,0.041 C13.785,14.496,13.156,14.787,12.5,14.787z M12.492,10.475c-0.546,0-1.055,0.208-1.434,0.586 c-0.412,0.412-0.623,0.991-0.58,1.588l0.003,0.048c0.005,0.067,0.009,0.135,0.021,0.199c0.009,0.041,0.021,0.081,0.034,0.121 l0.039,0.127c0.012,0.045,0.025,0.092,0.043,0.135c0.014,0.031,0.029,0.061,0.046,0.09l0.063,0.121 c0.025,0.049,0.049,0.098,0.08,0.143c0.016,0.023,0.033,0.043,0.049,0.062l0.039,0.045c0.395,0.508,0.979,0.797,1.604,0.797 c0.584,0,1.144-0.26,1.535-0.715l0.037-0.043c0.042-0.049,0.084-0.096,0.118-0.146c0.027-0.039,0.048-0.082,0.069-0.125 l0.053-0.1c0.024-0.043,0.049-0.084,0.067-0.129c0.013-0.033,0.022-0.068,0.033-0.105l0.039-0.127 c0.017-0.051,0.033-0.102,0.045-0.154c0.007-0.036,0.01-0.077,0.013-0.118l0.006-0.072c0.014-0.14,0.013-0.282-0.003-0.421 c-0.003-0.026-0.005-0.052-0.007-0.078c-0.002-0.034-0.004-0.067-0.01-0.099c-0.012-0.053-0.029-0.108-0.047-0.163l-0.04-0.128 c-0.009-0.031-0.018-0.062-0.029-0.092c-0.021-0.051-0.049-0.098-0.076-0.146l-0.059-0.11c-0.017-0.033-0.033-0.066-0.054-0.097 c-0.049-0.075-0.11-0.144-0.176-0.216c-0.062-0.068-0.117-0.122-0.175-0.172c-0.078-0.07-0.141-0.126-0.209-0.172 c-0.036-0.024-0.073-0.043-0.111-0.062l-0.13-0.07c-0.037-0.021-0.073-0.042-0.112-0.058c-0.034-0.015-0.069-0.023-0.104-0.033 l-0.126-0.039c-0.051-0.017-0.102-0.034-0.153-0.043c-0.046-0.009-0.09-0.012-0.134-0.016l-0.072-0.006 C12.625,10.478,12.559,10.475,12.492,10.475z"/> </g></g></g></svg></div>'
            };
        })
        .directive('editIcon', function () {
            return {
                restrict: 'AE',
                replace: true,
                template: '<div class="action-svg-icon"><svg version="1.1" id="Layer_1"  x="0px" y="0px"	 width="25px" height="25px" viewBox="0 0 25 25" enable-background="new 0 0 25 25" xml:space="preserve"><g>	<g>		<g>			<path fill="#7B6E66" d="M12.5,25C5.607,25,0,19.393,0,12.5S5.607,0,12.5,0S25,5.607,25,12.5S19.393,25,12.5,25L12.5,25z				 M12.5,0.556C5.914,0.556,0.556,5.914,0.556,12.5c0,6.586,5.358,11.944,11.944,11.944c6.586,0,11.944-5.358,11.944-11.944				C24.444,5.914,19.086,0.556,12.5,0.556L12.5,0.556z"/>		</g>	</g>	<g>		<g>			<g>				<path fill="#7B6E66" d="M6.609,18.386c-0.074,0-0.144-0.028-0.196-0.081c-0.056-0.057-0.085-0.133-0.081-0.213l0.167-2.822					c0.004-0.066,0.032-0.131,0.081-0.18l8.409-8.408c0.052-0.052,0.123-0.081,0.196-0.081l0,0c0.074,0,0.145,0.029,0.196,0.081					l2.654,2.654c0.053,0.052,0.081,0.123,0.081,0.197s-0.028,0.144-0.081,0.196L9.626,18.14c-0.048,0.048-0.112,0.076-0.181,0.08					l-2.82,0.165C6.62,18.386,6.615,18.386,6.609,18.386L6.609,18.386z M7.046,15.407l-0.142,2.405l2.403-0.142l8.139-8.138					l-2.262-2.262L7.046,15.407L7.046,15.407z"/>			</g>			<g>				<path fill="#7B6E66" d="M16.342,11.041c-0.071,0-0.143-0.027-0.197-0.082l-2.386-2.387c-0.109-0.109-0.109-0.284,0-0.393					c0.108-0.109,0.284-0.109,0.393,0l2.387,2.387c0.108,0.108,0.108,0.285,0,0.393C16.483,11.014,16.413,11.041,16.342,11.041					L16.342,11.041z"/>			</g>			<g>				<path fill="#7B6E66" d="M8.542,16.454c-0.071,0-0.142-0.026-0.196-0.081c-0.108-0.108-0.108-0.284,0-0.393l6.565-6.565					c0.107-0.108,0.284-0.108,0.393,0c0.108,0.109,0.108,0.285,0,0.393l-6.565,6.565C8.684,16.428,8.613,16.454,8.542,16.454					L8.542,16.454z"/>			</g>			<path fill="#7B6E66" d="M6.922,16.727c-0.038,0-0.075,0.003-0.115,0.006c-0.037,0.004-0.069,0.016-0.104,0.021l-0.081,1.369				l1.314-0.081c0.011-0.049,0.024-0.098,0.031-0.151C8.026,17.226,7.567,16.727,6.922,16.727L6.922,16.727z"/>		</g>		<g>			<path fill="#7B6E66" d="M18.391,18.296h-6.204c-0.154,0-0.278-0.123-0.278-0.277c0-0.153,0.124-0.277,0.278-0.277h6.204				c0.153,0,0.278,0.124,0.278,0.277C18.669,18.173,18.544,18.296,18.391,18.296L18.391,18.296z"/>		</g>	</g></g></svg></div>'
            };
        })
        .directive('deleteIcon',function(){
            return{
                restrict: 'AE',
                replace: true,
                template: '<div class="action-svg-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 25 25" enable-background="new 0 0 25 25" xml:space="preserve"><g>	<g>		<g>			<path fill="#7B6E66" d="M12.5,25C5.607,25,0,19.393,0,12.5S5.607,0,12.5,0C19.393,0,25,5.607,25,12.5S19.393,25,12.5,25L12.5,25z				 M12.5,0.556C5.914,0.556,0.556,5.914,0.556,12.5c0,6.586,5.358,11.944,11.944,11.944S24.444,19.086,24.444,12.5				C24.444,5.914,19.086,0.556,12.5,0.556L12.5,0.556z"/>		</g>	</g>	<g>		<g>			<path fill="#7B6E66" d="M18.173,7.917H6.645c-0.154,0-0.278-0.124-0.278-0.277c0-0.154,0.124-0.278,0.278-0.278h11.528				c0.154,0,0.278,0.124,0.278,0.278C18.451,7.793,18.327,7.917,18.173,7.917L18.173,7.917z"/>		</g>		<g>			<path fill="#7B6E66" d="M14.115,7.811c-0.165-0.808-0.883-1.393-1.706-1.393c-0.824,0-1.541,0.585-1.705,1.392l-0.544-0.11				c0.216-1.064,1.162-1.837,2.249-1.837c1.086,0,2.032,0.772,2.25,1.836L14.115,7.811L14.115,7.811z"/>		</g>		<g>			<path fill="#7B6E66" d="M16.155,18.625H8.663c-0.429,0-0.8-0.366-0.826-0.816c-0.193-3.209-0.385-6.42-0.576-9.63				C7.252,8.026,7.369,7.895,7.522,7.885c0.163-0.014,0.284,0.108,0.293,0.261c0.19,3.21,0.382,6.42,0.576,9.629				c0.01,0.16,0.133,0.294,0.271,0.294h7.492c0.138,0,0.263-0.134,0.272-0.295c0.19-3.208,0.383-6.419,0.576-9.629				c0.01-0.153,0.143-0.266,0.294-0.26c0.152,0.009,0.27,0.141,0.26,0.294c-0.192,3.209-0.385,6.42-0.576,9.629				C16.954,18.26,16.583,18.625,16.155,18.625L16.155,18.625z"/>		</g>		<g>			<g>				<path fill="#7B6E66" d="M10.302,16.586c-0.146,0-0.269-0.114-0.277-0.262L9.654,9.704C9.646,9.55,9.763,9.419,9.916,9.411					c0.146-0.02,0.284,0.109,0.293,0.262l0.371,6.62c0.008,0.154-0.109,0.284-0.262,0.293					C10.312,16.586,10.307,16.586,10.302,16.586L10.302,16.586z"/>			</g>			<g>				<path fill="#7B6E66" d="M14.516,16.586c-0.005,0-0.011,0-0.016-0.001c-0.153-0.009-0.271-0.139-0.262-0.293l0.369-6.62					C14.616,9.52,14.745,9.39,14.9,9.411c0.153,0.009,0.271,0.14,0.262,0.293l-0.369,6.621					C14.784,16.472,14.662,16.586,14.516,16.586L14.516,16.586z"/>			</g>		</g>		<g>			<path fill="#7B6E66" d="M12.409,16.586c-0.153,0-0.277-0.124-0.277-0.278v-6.62c0-0.153,0.124-0.278,0.277-0.278				c0.154,0,0.278,0.125,0.278,0.278v6.62C12.687,16.462,12.563,16.586,12.409,16.586L12.409,16.586z"/>		</g>	</g></g></svg></div>'
            };
        })
        .directive('eksIcon', function () {
            return {
                restrict: 'AE',
                replace: true,
                template: '<div class="action-svg-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><g>	<g>		<g>			<path fill="#7B6E66" d="M20,40C8.971,40,0,31.025,0,20C0,8.97,8.971,0,20,0C31.026,0,40,8.97,40,20C40,31.025,31.026,40,20,40            L20,40z M20,0.891C9.465,0.891,0.891,9.46,0.891,20c0,10.54,8.575,19.11,19.109,19.11c10.54,0,19.109-8.57,19.109-19.11            C39.109,9.46,30.54,0.891,20,0.891L20,0.891z"/>    </g></g><path fill="#7B6E66" d="M27.076,12.292L20,19.373l-7.077-7.081c-0.174-0.17-0.458-0.17-0.632,0c-0.17,0.174-0.17,0.458,0,0.632            L19.373,20l-7.081,7.078c-0.17,0.178-0.17,0.457,0,0.627c0.174,0.178,0.458,0.178,0.632,0L20,20.628l7.076,7.077            c0.179,0.178,0.458,0.178,0.628,0c0.178-0.17,0.178-0.449,0-0.627L20.627,20l7.077-7.077c0.178-0.174,0.178-0.458,0-0.632            C27.534,12.121,27.255,12.121,27.076,12.292z"/>    </g>    </svg></div>'
            };
        })
        .directive('borderlessEksIcon', function () {
            return {
                restrict: 'AE',
                replace: true,
                template: '<div class="action-svg-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="9.954px" height="10.023px" viewBox="0 0 9.954 10.023" enable-background="new 0 0 9.954 10.023" xml:space="preserve"><g>	<g>		<path fill="#B6ADA4" d="M9.745,8.798L5.983,5.011l3.763-3.788c0.276-0.28,0.276-0.732,0-1.012c-0.277-0.282-0.728-0.282-1.006,0            L4.977,3.999L1.214,0.211c-0.278-0.282-0.729-0.282-1.008,0c-0.275,0.279-0.275,0.731,0,1.012L3.97,5.011L0.207,8.798            c-0.276,0.282-0.276,0.734,0,1.014c0.14,0.139,0.321,0.211,0.503,0.211s0.365-0.072,0.504-0.211l3.763-3.788L8.74,9.812            c0.139,0.139,0.321,0.211,0.503,0.211s0.363-0.072,0.502-0.211C10.023,9.533,10.023,9.081,9.745,8.798z"/>	</g></g></svg></div>'
            };
        })
        .directive('dropdownArrowIcon', function () {
            return {
                restrict: 'AE',
                replace: true,
                template: '<div class="action-svg-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="14px" height="7.383px" viewBox="381.834 96.701 14 7.383" enable-background="new 381.834 96.701 14 7.383"            xml:space="preserve">       <path fill="#007FBE" d="M395.654,96.768c-0.232-0.232-0.636-0.232-0.868,0l-5.953,5.948l-5.951-5.948            c-0.232-0.232-0.637-0.231-0.867-0.001c-0.116,0.115-0.181,0.27-0.181,0.435c0,0.164,0.064,0.318,0.18,0.435l6.386,6.383            c0.116,0.115,0.27,0.18,0.434,0.18s0.317-0.064,0.434-0.18l6.388-6.383c0.116-0.117,0.181-0.271,0.18-0.436            C395.834,97.036,395.77,96.882,395.654,96.768z"/>        </svg></div>'            };
        })
        .directive('breadcrumbIcon', function () {
            return {
                restrict: 'AE',
                replace: true,
                template: '<span class="breadcrumb-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="14px" height="7.383px" viewBox="381.834 96.701 14 7.383" enable-background="new 381.834 96.701 14 7.383"            xml:space="preserve">       <path fill="#007FBE" d="M395.654,96.768c-0.232-0.232-0.636-0.232-0.868,0l-5.953,5.948l-5.951-5.948            c-0.232-0.232-0.637-0.231-0.867-0.001c-0.116,0.115-0.181,0.27-0.181,0.435c0,0.164,0.064,0.318,0.18,0.435l6.386,6.383            c0.116,0.115,0.27,0.18,0.434,0.18s0.317-0.064,0.434-0.18l6.388-6.383c0.116-0.117,0.181-0.271,0.18-0.436            C395.834,97.036,395.77,96.882,395.654,96.768z"/>        </svg></span>'
            };
        })
        .directive('resetIcon', function () {
            return {
                restrict: 'AE',
                replace: true,
                template: '<div class="action-warning-svg-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="16px" height="14px" viewBox="0 0 16 14" enable-background="new 0 0 16 14" xml:space="preserve"><g>	<g>		<g>			<path fill="#E53B2E" d="M8.982,0c-3.673,0-6.69,2.831-6.988,6.419L1.098,5.617c-0.271-0.242-0.685-0.22-0.929,0.05            c-0.243,0.27-0.22,0.685,0.051,0.927l1.999,1.789C2.343,8.494,2.5,8.551,2.657,8.551c0.158,0,0.314-0.057,0.439-0.168l2-1.789            c0.271-0.242,0.293-0.657,0.05-0.927c-0.244-0.271-0.659-0.294-0.929-0.05L3.31,6.428C3.599,3.56,6.032,1.313,8.982,1.313            c3.145,0,5.702,2.551,5.702,5.686c0,3.136-2.557,5.688-5.702,5.688c-1.464,0-2.855-0.553-3.92-1.561            c-0.225-0.211-0.434-0.441-0.621-0.688c-0.22-0.289-0.632-0.346-0.923-0.125c-0.289,0.219-0.345,0.631-0.125,0.92            c0.23,0.303,0.488,0.588,0.766,0.848C5.466,13.318,7.179,14,8.982,14C12.853,14,16,10.859,16,6.999C16,3.14,12.853,0,8.982,0z"/>    </g></g></g></svg></div>'
            };
        });
} ());
(function () {
    'use strict';

    angular.module ('managementConsole').directive ('noData', noData);

    function noData() {        
        return {
            restrict: 'E',
            scope: {
                noDataFound: '=',
                displayMessage: '='
            },
            template: '<div role="alert" class="raw-alert raw-alert-danger" ng-show="noDataFound">{{displayMessage}}</div>'
        };
    }
} ());
(function () {
    'use strict';

    angular.module('managementConsole').controller('SettingsController', SettingsController);


    function SettingsController($rootScope, $scope, $window, $filter, $uibModal, toastr, settingsService) {
        var vm = this;
        vm.mobileSystemSettings = null;
        vm.isSavingSystemSettings = false;

        vm.notificationTypes = [];
        vm.notificationEmails = [];
        vm.isLoadingNotifications = false;

        vm.isQuestionEntryVisible = false;
        vm.faqQuestionsAnswers = [];
        vm.isLoadingQuestions = false;
        vm.isSavingQuestion = false;

        vm.initModule = function () {
            vm.getNotificationTypes();
            vm.getSettings();
        };

        vm.resetNotificationForm = function () {
            vm.notification.EmailAddress = '';
            vm.notification.NotificationTypeId = '';
            $scope.notificationForm.$setPristine();
            $scope.notificationForm.$setUntouched();
        };

        vm.resetQuestionAnswerForm = function () {
            vm.question.Question = '';
            vm.question.Answer = '';
            $scope.questionForm.$setPristine();
            $scope.questionForm.$setUntouched();
        };

        vm.getNotificationTypes = function () {
            settingsService.getNotificationTypes().then(function (response) {
                vm.notificationTypes = response;
            },
            function (error) {
                toastr.error('getNotificationTypes: ' + error);
            });
        };

        vm.getSettings = function () {
            vm.getMobileSystemSettings();
            vm.getNotificationSettings();
            vm.getQuestionAnswerSettings();
        };

        vm.getMobileSystemSettings = function () {
            settingsService.getMobileSystemSettings().then(function (response) {
                vm.mobileSystemSettings = response;
            },
            function (error) {
                toastr.error('getMobileSystemSettings: ' + error);
            });
        };

        vm.getNotificationSettings = function () {
            vm.isLoadingNotifications = true;
            settingsService.getNotificationSettings().then(function (response) {
                vm.notificationEmails = response;
                vm.isLoadingNotifications = false;
            },
            function (error) {
                toastr.error('getNotificationSettings: ' + error);
                vm.isLoadingNotifications = false;
            });
        };

        vm.getQuestionAnswerSettings = function () {
            vm.isLoadingQuestions = true;
            settingsService.getQuestionAnswerSettings().then(function (response) {
                vm.faqQuestionsAnswers = response;
                vm.isLoadingQuestions = false;
            },
            function (error) {
                toastr.error('getQuestionAnswerSettings: ' + error);
                vm.isLoadingQuestions = false;
            });
        };

        vm.saveSystemSettings = function () {
            if ($scope.settingsForm.$invalid) {
                $scope.settingsForm.$setSubmitted();
                return;
            }
            
            vm.isSavingSystemSettings = true;
            settingsService.saveSystemSettings(vm.mobileSystemSettings)
                    .then(function (response) {
                        vm.isSavingSystemSettings = false;
                        toastr.success('Settings saved successfully');
                    },
                    function (error) {
                        toastr.error(error.data.Message);

                        vm.isSavingSystemSettings = false;
                    });
        };

        vm.addNotificationEmail = function () {
            vm.isSavingNotification = true;
            settingsService.addNotificationEmail(vm.notification)
                    .then(function (response) {
                        vm.notificationEmails.push(response);
                        vm.resetNotificationForm();
                        vm.isSavingNotification = false;

                        toastr.success('Email added successfully');
                    },
                    function (error) {
                        if (error.data) {
                            toastr.error(error.data);
                        }
                        else {
                            toastr.error('Unexpected error occured');
                        }

                        vm.isSavingNotification = false;
                    });
        };

        vm.addQuestionAnswer = function () {
            vm.isSavingQuestion = true;
            settingsService.addQuestionAnswer(vm.question)
                    .then(function (response) {
                        vm.faqQuestionsAnswers.push(response);
                        vm.resetQuestionAnswerForm();
                        vm.isSavingQuestion = false;

                        toastr.success('Question added successfully');
                    },
                    function (error) {
                        toastr.error(error.data.Message);
                        vm.isSavingQuestion = false;
                    });
        };

        vm.editQuestionAnswer = function () {
            vm.isSavingQuestion = true;
            settingsService.editQuestionAnswer($scope.$resolve.params)
                    .then(function (response) {
                        toastr.success('Question saved successfully');
                        vm.isSavingQuestion = false;
                        vm.hideWarning();
                    },
                    function (error) {
                        vm.isSavingQuestion = false;
                        toastr.error('editQuestionAnswer: ' + error);
                    });
        };

        vm.askRemoveNotificationEmail = function (emailId) {
            vm.showWarning("removeNotificationEmail", { emailId: emailId, parentScope: $scope });
        };

        vm.deleteNotificationEmail = function () {
            vm.isLoadingNotifications = true;
            var notificationEmailId = $scope.$resolve.params.emailId;

            settingsService.deleteNotificationEmail(notificationEmailId)
                .then(function (response) {
                    var notificationIndex;
                    var notificationEmail = $filter('filter')(vm.notificationEmails, { Id: notificationEmailId }, true);
                    if (notificationEmail && notificationEmail !== undefined && notificationEmail.length) {
                        notificationIndex = vm.notificationEmails.indexOf(notificationEmail[0]);
                        vm.notificationEmails.splice(notificationIndex, 1);
                        $scope.$resolve.params.parentScope.settingsCtrl.notificationEmails.splice(notificationIndex, 1)
                    }

                    vm.isLoadingNotifications = false;
                    vm.hideWarning();
                    toastr.success('Email deleted successfully');
                },
                function (error) {
                    toastr.error(error.data.Message);
                    vm.isLoadingNotifications = false;
                });
            
        };

        vm.askRemoveQuestionAnswer = function (questionId) {
            vm.showWarning("removeQuestionAnswer", { questionId: questionId, parentScope: $scope });
        };

        vm.deleteQuestionAnswer = function () {
            vm.isLoadingQuestions = true;
            var questionId = $scope.$resolve.params.questionId;

            settingsService.deleteQuestionAnswer(questionId)
                .then(function (response) {
                    var questionIndex;
                    var question = $filter('filter')(vm.faqQuestionsAnswers, { Id: questionId }, true);
                    if (question && question !== undefined && question.length) {
                        questionIndex = vm.faqQuestionsAnswers.indexOf(question[0]);
                        vm.faqQuestionsAnswers.splice(questionIndex, 1);
                        $scope.$resolve.params.parentScope.settingsCtrl.faqQuestionsAnswers.splice(questionIndex, 1)
                    }
                    vm.isLoadingQuestions = false;
                    vm.hideWarning();
                    toastr.success('Question Deleted Successfully');
                },
                function (error) {
                    vm.isLoadingQuestions = false;
                    toastr.error(error.data.Message);
                });            
        };

        vm.showWarning = function (action, params) {
            var templateURL = "";
            switch (action) {
                case "removeNotificationEmail":
                    templateURL = 'app/settings/partials/_removeNotificationEmailMessage.html';
                    break;
                case "editQuestion":
                    templateURL = 'app/settings/partials/_editQuestion.html';
                    break;
                case "removeQuestionAnswer":
                    templateURL = 'app/settings/partials/_removeQAMessage.html';
                    break;
            }

            $rootScope.modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-message-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: templateURL,
                controller: SettingsController,
                controllerAs: 'settingsCtrl',
                resolve: {
                    params: params
                }
            });
        };

        vm.hideWarning = function () {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }
        };

        vm.initModule();
    }
}());
(function () {
    angular.module('managementConsole').factory('settingsService', settingsFactory);

    function settingsFactory($http, $q, CONSTANTS) {
        var settingsService = this;
        var settingsURL = CONSTANTS.API_URL + '/settings';

        settingsService.getNotificationTypes = function () {
            var deferred = $q.defer();

            $http.get(settingsURL + '/notificationTypes', { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        settingsService.getMobileSystemSettings = function () {
            var deferred = $q.defer();

            $http.get(settingsURL + '/mobileSettings', { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        settingsService.getNotificationSettings = function () {
            var deferred = $q.defer();

            $http.get(settingsURL + '/notifications', { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        settingsService.getQuestionAnswerSettings = function () {
            var deferred = $q.defer();

            $http.get(settingsURL + '/questionsAnswers', { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        settingsService.saveSystemSettings = function (systemSettings) {
            var deferred = $q.defer();
            
            //$http.put(settingsURL + '/mobileSettings', systemSettings, { headers: { 'Content-Type': 'application/json' } })
            //  .then(function (response) {
            //      deferred.resolve(response.data);
            //  }).catch(function (response) {
            //      deferred.reject(response);
            //  });
            deferred.resolve();
            return deferred.promise;
        };

        settingsService.addNotificationEmail = function (notificationEmail) {
            var deferred = $q.defer();

            $http.post(settingsURL + '/notifications', notificationEmail, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        settingsService.addQuestionAnswer = function (question) {
            var deferred = $q.defer();

            $http.post(settingsURL + '/questionsAnswers', question, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        settingsService.editQuestionAnswer = function (question) {
            var deferred = $q.defer();

            $http.put(settingsURL + '/questionsAnswers', question, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        settingsService.deleteNotificationEmail = function (notificationEmailId) {
            var deferred = $q.defer();

            $http.delete(settingsURL + '/notifications/' + notificationEmailId, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        settingsService.deleteQuestionAnswer = function (questionId) {
            var deferred = $q.defer();

            $http.delete(settingsURL + '/questionsAnswers/' + questionId, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        return settingsService;
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').directive('release', release).filter('releaseStatusName', function () {
        return function (IsInactive) {
            return IsInactive ? "Released" : "Pending";
        };
    });

    function release($timeout, $state, commonHelperService) {
        function link(scope, elem, attrs) {
        }
        return {
            restrict: 'E',
            replace: true,
            scope: {
                release: '=info',
                deleteRelease: '&',
                disabledDelete: '=deletebtn'
            },
            link: link,
            controller: function ($scope, scheduleService, toastr, $uibModal, $document, $state, $rootScope) {
                $scope.period = $state.params.timeSpanSelected;
                $scope.checkForPermission = $rootScope.checkForPermission;
                $scope.release.ReleaseDate = commonHelperService.transformDateToLocalTime($scope.release.ReleaseDate);
                $scope.navigateToRelease = function (release) {
                    $state.go('mainAuth.addRelease', { id: release.ScheduleId, releaseId: release.Id, period: $scope.period });
                }
            },
            templateUrl: 'app/scheduleRelease/partials/_release.html'
        };
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').directive('schedule', schedule);


    function schedule() {

        function ScheduleController($rootScope, $scope) {
            var vm = this;
            vm.checkForPermission = $rootScope.checkForPermission;

            if ($scope.preSelectedSchedule) {
                $scope.preSelectedSchedule = $scope.preSelectedSchedule[0];
            }

            vm.setScheduleToSeleted = function () {
                $scope.scheduleSelected = $scope.schedule;

                $scope.periodChanged = false;

                if ($scope.getReleases) {
                    $scope.getReleases();
                }
            };

            $scope.editSchedule = function (event) {
                if (!$scope.isArchived) {
                    $scope.edit();
                }

                event.stopPropagation();
            }

            $scope.deleteSchedule = function (event) {
                if (!$scope.isArchived) {
                    $scope.delete();
                }

                event.stopPropagation();
            }
        }

        return {
            restrict: 'E',
            replace: true,
            scope: {
                schedule: '=info',
                scheduleSelected: '=',
                isArchived: '=',
                edit: '&',
                delete: '&',
                getReleases: '&',
                changePeriod: '=',
                preSelectedSchedule: '=?'
            },
            controller: ScheduleController,
            controllerAs: 'scheduleCtrl',
            templateUrl: 'app/scheduleRelease/partials/_schedule.html'
        };
    }

}());
(function () {
    angular.module('managementConsole').factory('scheduleService', scheduleFactory);

    function scheduleFactory($http, $q, CONSTANTS) {
        var scheduleService = this;
        var schedulesURL = CONSTANTS.API_URL + '/Schedules';
        var releaseURL = CONSTANTS.API_URL + '/releases';
        var scheduleReleasesURL = CONSTANTS.API_URL + '/releases/schedule';
        var currentDate = new Date()
        var offSet = Math.abs(currentDate.getTimezoneOffset() / 60);

        function includeWholeEndDay(schedule) {
            var scheduleDate = new Date(schedule.End);
            scheduleDate.setHours(scheduleDate.getHours() + 23);
            scheduleDate.setMinutes(scheduleDate.getMinutes() + 59);
            schedule.End = scheduleDate.toUTCString();
            return schedule;
        }

        scheduleService.getSchedules = function () {
            var deferred = $q.defer();

            $http.get(schedulesURL, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        scheduleService.getSchedule = function (scheduleId) {
            var deferred = $q.defer();

            $http.get(schedulesURL + '/id?id=' + scheduleId, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        scheduleService.getScheduleReleases = function (scheduleId) {
            var deferred = $q.defer();

            $http.get(scheduleReleasesURL + '/' + scheduleId, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        scheduleService.addSchedule = function (schedule) {
            var deferred = $q.defer();
            schedule.timeZoneOffset = offSet;

            //Include one more day in the end
            //var currentSchedule = includeWholeEndDay(schedule);


            $http.post(schedulesURL, schedule, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        scheduleService.updateSchedule = function (schedule) {
            var deferred = $q.defer();
            schedule.timeZoneOffset = offSet;


            //Include one more day in the end
            //var currentSchedule = includeWholeEndDay(schedule);

            $http.put(schedulesURL, schedule, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        scheduleService.deleteSchedule = function (scheduleId) {
            var deferred = $q.defer();

            $http.delete(schedulesURL + '/' + scheduleId, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        scheduleService.deleteRelease = function (releaseId) {
            var deferred = $q.defer();

            $http.delete(releaseURL + '/' + releaseId, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        scheduleService.addRelease = function (release) {
            var deferred = $q.defer();

            $http.post(releaseURL, release, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        }

        scheduleService.editRelease = function (release) {
            var deferred = $q.defer();

            $http.put(releaseURL, release, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        }

        scheduleService.checkReleaseBooks = function (release) {
            var deferred = $q.defer();

            $http.post(releaseURL + '/checkbooks', release, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        return scheduleService;
    }
}());
(function () {
    angular.module('managementConsole').factory('scheduleHelper', scheduleHelper);

    function scheduleHelper() {
        var scheduleHelper = this;

        scheduleHelper.getScheduleFilteredByTime = function (schedules, timeFilter) {
            var history = [],
                currentDate = new Date().setHours(0, 0, 0, 0);
            for (var i = 0; i < schedules.length; i++) {
                var currentSchedule = schedules[i];
                var scheduleDate = new Date(currentSchedule.End).setHours(0, 0, 0, 0);
                if (timeFilter == 'past') {
                    if (scheduleDate < currentDate) {
                        history.push(currentSchedule);
                    }
                }

                if (timeFilter == 'future') {
                    if (scheduleDate >= currentDate) {
                        history.push(currentSchedule);
                    }
                }
            }


            return history;
        }

        scheduleHelper.sortByDate = function (input, propertyToSort) {

            function compare(a, b) {
                if (new Date(a[propertyToSort]) < new Date(b[propertyToSort]))
                    return -1;
                if (new Date(a[propertyToSort]) > new Date(b[propertyToSort]))
                    return 1;
                return 0;
            }

            return input.sort(compare);
        }



        return scheduleHelper;
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole')
        .controller('EnrollmentsController', function () {
            var vm = this;
        });
}());

(function () {
    'use strict';

    angular.module('managementConsole')
        .controller('SessionsController', function () {
            var vm = this;
        });
}());

(function () {
    angular.module('managementConsole').factory('bookService', bookService);

    function bookService($http, $q, CONSTANTS) {
        var bookService = this,
            baseUrl = CONSTANTS.API_URL,
            bookUrl = '/books',
            approveUrl = '/approve',
            search = '/search',
            advancedSearch = '/advanced-search',
            lockUrl = '/lock-unlock',
            reject = '/reject';

        bookService.toggleLockUnlockBooks = function (action, books) {
            var deferred = $q.defer();

            var isLocking = false;
            if (action == 'lock') {
                isLocking = true;
            }

            $http.put(baseUrl + bookUrl + lockUrl + '/' + isLocking.toString(), books, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        bookService.approveBooks = function (books) {
            var deferred = $q.defer();

            $http.put(baseUrl + bookUrl + approveUrl, books, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        bookService.deleteBooks = function (books) {
            var deferred = $q.defer();
            var bookVersionsIds = Object.keys(books).map(function (key) { return books[key]; });

            $http({
                method: 'DELETE',
                url: baseUrl + bookUrl,
                data: bookVersionsIds,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        bookService.rejectBooks = function (books) {
            var deferred = $q.defer();
            if (books !== null) {
                var bookVersionsIds = Object.keys(books).map(function (key) { return books[key]; });
                $http.put(baseUrl + bookUrl + reject, books, { headers: { 'Content-Type': 'application/json' } })
                    .then(function (response) {
                        deferred.resolve(response);
                    }).catch(function (response) {
                        deferred.reject(response);
                    });
            }
            return deferred.promise;
        };

        bookService.searchBookWord = function (keyWords, skip, take, status) {
            var deferred = $q.defer();

            var searchParams = {};
            searchParams.keywords = keyWords;
            searchParams.skip = 0;
            searchParams.take = 10;
            searchParams.status = status || null;

            $http.post(baseUrl + bookUrl + search, searchParams, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        bookService.advancedSearch = function (searchObject) {
            var deferred = $q.defer();

            $http.post(baseUrl + bookUrl + advancedSearch, searchObject, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        bookService.exportToExcel = function (id, defaultFileName) {
            defaultFileName = 'test';
            var self = this;
            var deferred = $q.defer();
            $http.get(baseUrl + bookUrl + '/export/' + id, { responseType: "arraybuffer" }).then(
                function (res) {
                    var blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
                    var a = document.createElement('a');
                    var url = URL.createObjectURL(blob);
                    a.href = url;
                    a.download = "ExportedBooks.xlsx";
                    a.target = '_blank';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }, function (data, status) {
                    var e = /* error */
                        deferred.reject(e);
                });
            return deferred.promise;
        };

        bookService.getBooksPaging = function (bookType, skip, take) {
            var deferred = $q.defer();

            $http.get(baseUrl + '/stats/' + bookType + '/paged/' + skip + '/' + take, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        bookService.getAllStatuses = function () {
            var deferred = $q.defer();

            $http.get(baseUrl + bookUrl + '/statuses', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        return bookService;
    }
}());
//(function () {
//    angular.module('managementConsole').factory('bookHelper', bookHelper);

//    function bookHelper($http, $q, CONSTANTS) {
//        var bookHelper = this;
//        return bookHelper;
//    }
//}());
(function () {
    'use strict';

    function selectAllBooks(collection, booleanValue) {
        for (var i = 0; i < collection.length; i++) {
            collection[i].isSelected = booleanValue;
        }
    }

    function getAllSelectedBooks(collection) {
        var selectedItems = collection.filter(function (item) {
            return item.isSelected == true;
        });

        return selectedItems.length;
    }

    function getCollectionOfSelectedBooks(collection) {
        var selectedItems = collection.filter(function (item) {
            return item.isSelected == true;
        });

        return selectedItems;
    }

    angular.module('managementConsole').controller('BookController', BookController);

    function BookController($state, $rootScope, $window, userInfoService, dashboardService, CONSTANTS, $uibModal, bookService, toastr, $document, $scope, $timeout, subjectService) {
        var vm = this;

        vm.isViewFirstLoad = false;
        vm.searchTypeDescription = '';
        vm.noDataFound = false;

        vm.pendingBooksVisible = $rootScope.checkForPermission('GetPendingBooks');
        vm.approvedBooksVisible = $rootScope.checkForPermission('GetApprovedBooks');
        vm.releasedBooksVisible = $rootScope.checkForPermission('GetReleasedBooks');
        vm.scheduledBooksVisible = $rootScope.checkForPermission('GetScheduledBooks');

        vm.coverUrlFirstPart = CONSTANTS.API_URL + '/books/';
        vm.coverUrlSecondPart = '/thumbs/page-1/jpeg';

        vm.testedSelectAll = false;

        vm.getAllStatuses = function () {
            bookService.getAllStatuses()
                .then(function (res) {
                    vm.statuses = [];
                    for (var i = 0; i < res.data.length; i++) {
                        vm.statuses.push({
                            display: res.data[i].Description,
                            value: res.data[i].Tag
                        });
                    }
                }, function (err) {
                    console.log(err);
                });
        };

        vm.getAllStatuses();
        var typesOfBooksAdded = 0;

        vm.getUserSubjects = function () {
            subjectService.getUserSubjects()
                .then(function (subjects) {
                    vm.subjects = subjects;
                }, function (err) {
                    console.log(err);
                });
        };

        vm.getUserSubjects();

        var coversPerLine = 5,
            coversPerLineCalculatedOnce = false;

        vm.calculateBookCoversPerLine = function () {
            var containerWidth = $('.wrapperBooks').width();

            var currentMargin = 20;
            //value for class book-cover-dashboard
            var bookCoversWidth = 176;
            var booksPerLine = 0;

            while (true) {
                containerWidth -= bookCoversWidth;
                booksPerLine++;
                if (containerWidth < 0) {
                    booksPerLine--;
                    break;
                }

                containerWidth -= currentMargin;

            }

            if (!coversPerLineCalculatedOnce) {
                coversPerLine = booksPerLine;
                coversPerLineCalculatedOnce = true;
            }
            $timeout(function () {
                vm.coversPerLine = booksPerLine;
                $scope.$apply();
            })

        };

        angular
            .element($window)
            .bind('resize', function () {

                vm.calculateBookCoversPerLine();

            });

        vm.getBooksCounts = function () {
            dashboardService
                .getStats()
                .then(function (res) {

                    vm.allBooksInTesting = res.data.InTesting;
                    vm.allApprovedBooks = res.data.Approved;
                    vm.allReleasedBooks = res.data.Released;
                    vm.allScheduledBooks = res.data.Scheduled;
                }, function (err) {
                    console.log(err);
                });
        };
        vm.getBooksCounts();

        vm.bookCoversTesting = [];
        var currentBookPagesTesting = 0;
        var gettingBooksInTesting = false;

        vm.getBooksInTesting = function () {
            if (gettingBooksInTesting) {
                return;
            }
            gettingBooksInTesting = true;
            bookService
                .getBooksPaging('in-testing', coversPerLine * currentBookPagesTesting, coversPerLine)
                .then(function (res) {
                    for (var i = 0; i < res.data.length; i++) {
                        vm
                            .bookCoversTesting
                            .push(res.data[i]);
                    }
                    currentBookPagesTesting++;
                    gettingBooksInTesting = false;

                }, function (err) {
                    gettingBooksInTesting = false;
                    console.log(err);
                });
        };

        vm.bookCoversApproved = [];
        var currentBookPagesApproved = 0;
        var gettingApprovedBooks = false;

        vm.getApprovedBooks = function () {
            if (gettingApprovedBooks) {
                return;
            }
            gettingApprovedBooks = true;
            bookService
                .getBooksPaging('approved', coversPerLine * currentBookPagesApproved, coversPerLine)
                .then(function (res) {
                    for (var i = 0; i < res.data.length; i++) {
                        vm
                            .bookCoversApproved
                            .push(res.data[i]);
                    }
                    currentBookPagesApproved++;
                    gettingApprovedBooks = false;
                }, function (err) {
                    console.log(err);
                    gettingApprovedBooks = false;
                });
        }

        vm.bookCoversScheduled = [];
        var currentBookPagesScheduled = 0;
        var gettingScheduledBooks = false;

        vm.getScheduledBooks = function () {
            if (gettingScheduledBooks) {
                return;
            }
            gettingScheduledBooks = true;
            bookService
                .getBooksPaging('scheduled', coversPerLine * currentBookPagesApproved, coversPerLine)
                .then(function (res) {
                    for (var i = 0; i < res.data.length; i++) {
                        vm
                            .bookCoversScheduled
                            .push(res.data[i]);
                    }
                    currentBookPagesScheduled++;
                    gettingScheduledBooks = false;
                }, function (err) {
                    console.log(err);
                    gettingScheduledBooks = false;
                });
        }

        vm.bookCoversReleased = [];
        var currentBooksPagesReleased = 0;
        var gettingReleasedBooks = false;

        vm.getReleasedBooks = function () {
            if (gettingReleasedBooks) {
                return;
            }
            gettingReleasedBooks = true;
            bookService
                .getBooksPaging('released-books', coversPerLine * currentBooksPagesReleased, coversPerLine)
                .then(function (res) {
                    for (var i = 0; i < res.data.length; i++) {
                        vm
                            .bookCoversReleased
                            .push(res.data[i]);
                    }
                    currentBooksPagesReleased++;
                    gettingReleasedBooks = false;
                }, function (err) {
                    console.log(err);
                    gettingReleasedBooks = false;
                });
        };

        vm.initView = function () {
            $scope
                .$on('$viewContentLoaded', function () {
                    vm.isViewFirstLoad = true;
                });
        };

        vm.clearAllBooksData = function () {
            currentBookPagesTesting = 0;
            currentBookPagesApproved = 0;
            currentBooksPagesReleased = 0;
            currentBookPagesScheduled = 0;

            vm.bookCoversTesting = [];
            vm.bookCoversApproved = [];
            vm.bookCoversReleased = [];
            vm.bookCoversScheduled = [];

            vm.allBooksInTesting = null;
            vm.allApprovedBooks = null;
            vm.allReleasedBooks = null;
            vm.allScheduledBooks = null;

            vm.clearSelectedBooks();
        };

        vm.loadBooks = function (isAdvancedSearch) {
            vm.calculateBookCoversPerLine();
            vm.clearAllBooksData();

            dashboardService
                .getStats()
                .then(function (res) {
                    vm.allBooksInTesting = res.data.InTesting;
                    vm.allApprovedBooks = res.data.Approved;
                    vm.allReleasedBooks = res.data.Released;
                    vm.allScheduledBooks = res.data.Scheduled;


                    vm.getBooksInTesting();
                    vm.getApprovedBooks();
                    vm.getReleasedBooks();
                    vm.getScheduledBooks();

                    if (vm.allBooksInTesting == 0 && vm.allApprovedBooks == 0 && vm.allReleasedBooks == 0 && vm.allScheduledBooks == 0) {
                        vm.noDataFound = true;
                    }
                    else {
                        vm.noDataFound = false;
                    }
                    vm.searchTypeDescription = vm.getSearchTypeDescription(isAdvancedSearch);
                }, function (err) { });

        };

        vm.selectedTestingBooksCount = 0;

        vm.selectAllBooks = function (collection, boolean) {
            switch (collection) {
                case 'testing':
                    selectAllBooks(vm.bookCoversTesting, boolean);
                    vm.selectedTestingBooksCount = getAllSelectedBooks(vm.bookCoversTesting);
                    break;
                case 'isScheduled':
                    selectAllBooks(vm.bookCoversScheduled, boolean);
                    vm.selectedScheduledBooksCount = getAllSelectedBooks(vm.bookCoversScheduled);
                    break;
                case 'scheduled':
                    selectAllBooks(vm.bookCoversApproved, boolean);
                    vm.selectedApprovedBooksCount = getAllSelectedBooks(vm.bookCoversApproved);
                    break;
                case 'released':
                    selectAllBooks(vm.bookCoversReleased, boolean);
                    vm.selectedReleasedBooksCount = getAllSelectedBooks(vm.bookCoversReleased);
                    break;
            }
        };

        vm.toggleBookTesting = function (book) {
            book.isSelected = !book.isSelected;
            if (!book.isSelected) {
                vm.testedSelectAll = false;
            }

            vm.selectedTestingBooksCount = getAllSelectedBooks(vm.bookCoversTesting);

            if (vm.selectedTestingBooksCount == vm.allBooksInTesting) {
                vm.testedSelectAll = true;
            }
        };

        vm.toggleBookIsScheduled = function (book) {
            book.isSelected = !book.isSelected;
            if (!book.isSelected) {
                vm.scheduledAll = false;
            }

            vm.selectedScheduledBooksCount = getAllSelectedBooks(vm.bookCoversScheduled);

            if (vm.selectedScheduledBooksCount == vm.allScheduledBooks) {
                vm.scheduledAll = true;
            }
        };

        vm.toggleBookScheduled = function (book) {
            book.isSelected = !book.isSelected;
            if (!book.isSelected) {
                vm.approvedAll = false;
            }

            vm.selectedApprovedBooksCount = getAllSelectedBooks(vm.bookCoversApproved);

            if (vm.selectedApprovedBooksCount == vm.allApprovedBooks) {
                vm.approvedAll = true;
            }
        };

        vm.toggleBookReleased = function (book) {
            book.isSelected = !book.isSelected;
            if (!book.isSelected) {
                vm.releasedAll = false;
            }

            vm.selectedReleasedBooksCount = getAllSelectedBooks(vm.bookCoversReleased);

            if (vm.selectedReleasedBooksCount == vm.allReleasedBooks) {
                vm.releasedAll = true;
            }
        };

        vm.confirmApproveBooks = function () {
            var allSelectedBooksInTesting = getCollectionOfSelectedBooks(vm.bookCoversTesting);

            var versionsIds = allSelectedBooksInTesting.map(function (item) {
                return item.BookVersionId;
            });

            bookService
                .approveBooks(versionsIds)
                .then(function (res) {
                    if (res.data.length == 0) {
                        toastr.error('No books were affected by this change');
                        return;
                    }
                    console.log("red.data: " + res.data);
                    console.log("vm.bookCoversTesting: " + vm.bookCoversTesting);
                    var newBookCoversApproved = [];

                    for (var i = 0; i < res.data.length; i++) {
                        var currentID = res.data[i];
                        for (var q = 0; q < vm.bookCoversTesting.length; q++) {
                            if (currentID == vm.bookCoversTesting[q].BookVersionId) {
                                vm.bookCoversTesting[q].isSelected = false;
                                vm.bookCoversTesting[q].Status = "Approved";//hotfix
                                vm.bookCoversTesting[q].StatusChangeDate = new Date().toISOString();

                                console.log("pushing");
                                newBookCoversApproved.push(vm.bookCoversTesting[q]);
                                                            
                                console.log("finished pushing");
                                console.log("splicing");
                                vm.bookCoversTesting.splice(q, 1);
                                console.log("finished splicing");

                                //Fix overall count of collections
                                vm.selectedTestingBooksCount -= 1;
                                vm.allBooksInTesting -= 1;
                                vm.allApprovedBooks += 1;
                                vm.selectedScheduledBooksCount += 1;
                                break;
                            }
                        }
                        vm.clearSelectedBooks();
                    }

                    for (var i = 0; i < newBookCoversApproved.length; i++) {                       
                        vm.bookCoversApproved.unshift(newBookCoversApproved[i])
                    }

                    toastr.success('Books approved successfully');

                    //Added by scrumble for design consistancy
                    if (!vm.isFilteringApplied()) { // reload new books to fill blank space
                        gettingBooksInTesting = true;
                        bookService
                            .getBooksPaging('in-testing', (coversPerLine * currentBookPagesTesting) + (coversPerLine - versionsIds.length), versionsIds.length)
                            .then(function (res) {
                                for (var i = 0; i < res.data.length; i++) {
                                    vm.bookCoversTesting.push(res.data[i]);
                                }
                                currentBookPagesTesting++;
                                gettingBooksInTesting = false;

                            }, function (err) {
                                gettingBooksInTesting = false;
                                console.log(err);
                            });
                    }

                }, function (err) {
                    console.log(err);
                });
        };

        vm.isFilteringApplied = function () {
            return vm.searchKeyWordsTags.length > 0 || (vm.bookSearch && Object.keys(vm.bookSearch).length > 0);
        };

        vm.toggleLockBooks = function (action) {
            var lockBook = action == 'lock'
                ? true
                : false;

            var allSelectedBooksForLocking = getCollectionOfSelectedBooks(vm.bookCoversReleased);

            var ids = allSelectedBooksForLocking.map(function (item) {
                return item.BookVersionId;
            });

            bookService
                .toggleLockUnlockBooks(action, ids)
                .then(function (res) {
                    if (res.data.length == 0) {
                        toastr.error('No books were affected by this change');
                        return;
                    }

                    if (lockBook) {
                        toastr.success('Books locked successfully');
                    } else {
                        toastr.success('Books unlocked successfully');
                    }

                    for (var i = 0; i < res.data.length; i++) {
                        var currentID = res.data[i];
                        for (var q = 0; q < vm.bookCoversReleased.length; q++) {
                            if (currentID == vm.bookCoversReleased[q].BookVersionId) {
                                vm.bookCoversReleased[q].IsLocked = lockBook;
                                break;
                            }
                        }
                    }
                    vm.clearSelectedBooks();

                }, function (err) {
                    console.log(err);
                })
        };

        vm.rejectBooks = function () {
            var allRejectedBooks = getCollectionOfSelectedBooks(vm.bookCoversTesting);

            var ids = allRejectedBooks.map(function (item) {
                return item.BookVersionId;
            });

            bookService
                .rejectBooks(ids)
                .then(function (res) {
                    if (res.data.length == 0) {
                        toastr.error('No books were affected by this change!');
                        return;
                    }

                    for (var i = 0; i < res.data.length; i++) {
                        var currentID = res.data[i];
                        for (var q = 0; q < vm.bookCoversTesting.length; q++) {
                            if (currentID == vm.bookCoversTesting[q].BookVersionId) {
                                vm.bookCoversTesting.splice(q, 1);
                                vm.selectedReleasedBooksCount -= 1;
                                vm.allReleasedBooks -= 1;
                                break;
                            }
                        }
                    }

                    toastr.success('Books Rejected successfully');
                    vm.clearSelectedBooks();
                    //Added by scrumble for design consistancy
                    if (!vm.isFilteringApplied()) { // reload new books to fill blank space
                        gettingBooksInTesting = true;
                        bookService
                            .getBooksPaging('in-testing', (coversPerLine * currentBookPagesTesting) + (coversPerLine - ids.length), ids.length)
                            .then(function (res) {
                                for (var i = 0; i < res.data.length; i++) {
                                    vm.bookCoversTesting.push(res.data[i]);
                                }
                                currentBookPagesTesting++;
                                gettingBooksInTesting = false;
                            }, function (err) {
                                console.log(err);
                                gettingBooksInTesting = false;
                            });
                    }
                }, function (err) {
                    console.log(err);
                })
        };
        vm.deleteBooksRequest = function () {
            var allSelectedBooksForDelete = getCollectionOfSelectedBooks(vm.bookCoversReleased);

            var ids = allSelectedBooksForDelete.map(function (item) {
                return item.BookVersionId;
            });

            bookService
                .deleteBooks(ids)
                .then(function (res) {
                    if (res.data.length == 0) {
                        toastr.error('No books were affected by this change!');
                        return;
                    }

                    for (var i = 0; i < res.data.length; i++) {
                        var currentID = res.data[i];
                        for (var q = 0; q < vm.bookCoversReleased.length; q++) {
                            if (currentID == vm.bookCoversReleased[q].BookVersionId) {
                                vm
                                    .bookCoversReleased
                                    .splice(q, 1);
                                vm.selectedReleasedBooksCount -= 1;
                                vm.allReleasedBooks -= 1;
                                break;
                            }
                        }
                    }

                    toastr.success('Books deleted successfully');
                    vm.clearSelectedBooks();
                    //Added by scrumble for design consistancy
                    if (!vm.isFilteringApplied()) { // reload new books to fill blank space
                        gettingReleasedBooks = true;
                        bookService
                            .getBooksPaging('released-books', (coversPerLine * currentBooksPagesReleased) + (coversPerLine - ids.length), ids.length)
                            .then(function (res) {
                                for (var i = 0; i < res.data.length; i++) {
                                    vm.bookCoversReleased.push(res.data[i]);
                                }
                                currentBooksPagesReleased++;
                                gettingReleasedBooks = false;
                            }, function (err) {
                                console.log(err);
                                gettingReleasedBooks = false;
                            });
                    }
                }, function (err) {
                    console.log(err);
                })
        };

        vm.mapSearchResult = function (res) {
            vm.bookCoversTesting = res.filter(function (obj) {
                return obj.Status == 'Pending' || obj.Status == "InTesting";
            })
            vm.allBooksInTesting = vm.bookCoversTesting.length;
            vm.selectedTestingBooksCount = 0;
            vm.testedSelectAll = false

            vm.bookCoversScheduled = res.filter(function (obj) {
                return obj.Status == 'Scheduled';
            })

            vm.allScheduledBooks = vm.bookCoversScheduled.length;
            vm.selectedScheduledBooksCount = 0;
            vm.scheduledAll = false;

            vm.bookCoversApproved = res.filter(function (obj) {
                return obj.Status == 'Approved';
            })
            vm.allApprovedBooks = vm.bookCoversApproved.length;
            vm.selectedApprovedBooksCount = 0;
            vm.approvedAll = false;

            vm.bookCoversReleased = res.filter(function (obj) {
                return obj.Status == 'Released';
            })
            vm.allReleasedBooks = vm.bookCoversReleased.length;
            vm.selectedReleasedBooksCount = 0;
            vm.releasedAll = false;

            if (vm.allBooksInTesting == 0 && vm.allApprovedBooks == 0 && vm.allReleasedBooks == 0 && vm.allScheduledBooks == 0) {
                vm.noDataFound = true;
            }
            else {
                vm.noDataFound = false;
            }
        };

        vm.clearSelectedBooks = function () {
            vm
                .bookCoversReleased
                .forEach(function (obj) {
                    obj.isSelected = false;
                })
            vm
                .bookCoversApproved
                .forEach(function (obj) {
                    obj.isSelected = false;
                })
            vm
                .bookCoversScheduled
                .forEach(function (obj) {
                    obj.isSelected = false;
                })
            vm
                .bookCoversTesting
                .forEach(function (obj) {
                    obj.isSelected = false;
                })
            vm.testedSelectAll = false;
            vm.approvedAll = false;
            vm.releasedAll = false;
            vm.scheduledAll = false;

            vm.selectedTestingBooksCount = 0;
            vm.selectedApprovedBooksCount = 0;
            vm.selectedReleasedBooksCount = 0;
            vm.selectedScheduledBooksCount = 0;
        };

        vm.toggleBookSearch = function () {
            vm.isSearchBoxVisible = !vm.isSearchBoxVisible;
        };

        vm.searchKeyWordsTags = [];

        vm.fixLevelKeyWord = function () {
            var tempkeyWords = angular.copy(vm.keyWords);
            var i;
            for (i = tempkeyWords.length - 1; i >= 0; i--) {

                if (tempkeyWords[i].toLowerCase() === "level") {
                    if (vm.keyWords.length - 1 >= i + 1)
                        vm.keyWords.splice(i, 2, vm.keyWords[i] + ' ' + vm.keyWords[i + 1]);
                }
            }
        }
        vm.searchBySingleKeyWord = function () {
            vm.isViewFirstLoad = false;

            vm.resetSearch('advanced');

            //empty search - search all books
            if (!vm.searchKeyWord || vm.searchKeyWord.length == 0) {
                vm.searchKeyWordsTags = [];

                vm.loadBooks(false);
                return;
            }
            vm.searchKeyWord = vm.searchKeyWord.replace(/\s{2,}/g, ' ').trim();
            vm.keyWords = vm
                .searchKeyWord
                .split(' ');
            vm.fixLevelKeyWord();

            vm.searchKeyWordsTags = angular.copy(vm.keyWords)

            bookService
                .searchBookWord(vm.keyWords)
                .then(function (res) {
                    //check if current search is executed with correct params
                    if (vm.searchKeyWordsTags.length != 0 && (vm.searchKeyWordsTags.length > res.data.Keywords.length)) {
                        return;
                    }

                    vm.mapSearchResult(res.data.Books);
                    var keyWordsMatches = res.data.Keywords;
                    //Determine keyWord tags
                    vm.searchKeyWordsTags = [];
                    for (var i = 0; i < keyWordsMatches.length; i++) {
                        if (vm.keyWords.indexOf(keyWordsMatches[i].Value) != -1) {
                            vm
                                .searchKeyWordsTags
                                .push(keyWordsMatches[i]);
                        }
                    }

                    vm.searchTypeDescription = vm.getSearchTypeDescription(false);

                }, function (err) {

                    console.log(err);
                })
        };

        vm.removeKeyWord = function (index) {
            var existingSearch = vm.searchKeyWord.split(' ');
            existingSearch.splice(index, 1);
            vm.searchKeyWord = existingSearch.join(' ');
            vm.searchKeyWordsTags.splice(index, 1);

            vm.searchBySingleKeyWord();
        };

        vm.advancedSearch = function () {
            vm.isViewFirstLoad = false;

            vm.resetSearch('keyword');

            //empty search - search all books
            if (!vm.bookSearch || Object.keys(vm.bookSearch).length == 0) {
                vm.loadBooks(true);
                return;
            }

            bookService.advancedSearch(vm.bookSearch)
                .then(function (res) {
                    vm.mapSearchResult(res.data);

                    vm.searchTypeDescription = vm.getSearchTypeDescription(true);

                }, function (err) {
                    console.log(err);
                });
        };

        vm.resetSearch = function (resetType) {
            if (resetType == 'all') {
                vm.bookSearch = {};
            }
            if (resetType == 'advanced') {
                var keywordInput = vm.searchKeyWord;
                var keywordsList = vm.searchKeyWordsTags;

                $('[title="Subject"]').find('.bs-searchbox>input').val('');
                $('[title="Status"]').find('.bs-searchbox>input').val('');
                $('[title="Book Level"]').find('.bs-searchbox>input').val('');
                $('.not-match').removeClass('not-match');

                vm.bookSearch = {};
                vm.searchKeyWord = keywordInput;
                vm.searchKeyWordsTags = keywordsList;
            }
            if (resetType == 'keyword') {
                vm.searchKeyWord = '';
                vm.searchKeyWordsTags = [];
            }
        };

        vm.approveBooks = function (parentSelector) {
            var parentElem = parentSelector
                ? angular.element($document[0].querySelector('.container ' + parentSelector))
                : undefined;
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/management/book/views/_modalConfirm.html',
                controller: function ($scope, $uibModalInstance) {
                    $scope.title = 'LMS';
                    $scope.header = 'Approve Books';
                    $scope.confirmAction = 'Are you sure you want to approve the selected book(s)?';
                    $scope.confirmActionSecond = 'If approved, the book(s) will be available for а release.';
                    $scope.actionName = 'Approve';

                    $scope.isWarningModal = true;

                    $scope.ok = function () {
                        vm.confirmApproveBooks();
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                appendTo: parentElem
            });
        };

        vm.lockBooks = function (parentSelector) {
            var parentElem = parentSelector
                ? angular.element($document[0].querySelector('.container ' + parentSelector))
                : undefined;
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/management/book/views/_modalConfirm.html',
                controller: function ($scope, $uibModalInstance) {
                    $scope.title = 'LMS';
                    $scope.header = 'Lock Books';
                    $scope.confirmAction = 'Are you sure you want to lock the selected book(s)?';
                    $scope.confirmActionSecond = 'If locked, the book(s) will be disabled on all devices.';
                    $scope.actionName = 'Lock';

                    //$scope.topBorderColor = 'rgb(229,60,46)';
                    $scope.isWarningModal = true;

                    $scope.ok = function () {
                        vm.toggleLockBooks('lock');
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                appendTo: parentElem
            });
        };

        vm.unlockBooks = function (parentSelector) {
            var parentElem = parentSelector
                ? angular.element($document[0].querySelector('.container ' + parentSelector))
                : undefined;
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/management/book/views/_modalConfirm.html',
                controller: function ($scope, $uibModalInstance) {
                    $scope.title = 'LMS';
                    $scope.header = 'Unlock Books';
                    $scope.confirmAction = 'Are you sure you want to unlock the selected book(s)?';
                    $scope.confirmActionSecond = 'If unlocked, the book(s) will be available on all devices.';
                    $scope.actionName = 'Unlock';

                    //$scope.topBorderColor = 'rgb(229,60,46)';
                    $scope.isWarningModal = true;

                    $scope.ok = function () {
                        vm.toggleLockBooks('unlock');
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                appendTo: parentElem
            });
        };

        vm.showRejectBookPopup = function (parentSelector) {
            var parentElem = parentSelector
                ? angular.element($document[0].querySelector('.container ' + parentSelector))
                : undefined;
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/management/book/views/_modalConfirm.html',
                controller: function ($scope, $uibModalInstance) {
                    $scope.title = 'LMS';
                    $scope.header = 'Reject Books';
                    $scope.confirmAction = 'Are you sure you want to reject the selected book(s)?';
                    //$scope.confirmActionSecond = 'If deleted, the book(s) will be removed from all devices.';
                    $scope.actionName = 'Reject';

                    //$scope.topBorderColor = 'rgb(229,60,46)';
                    $scope.isWarningModal = true;

                    $scope.ok = function () {
                        vm.rejectBooks();
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                appendTo: parentElem
            });
        };

        vm.deleteBooks = function (parentSelector) {
            var parentElem = parentSelector
                ? angular.element($document[0].querySelector('.container ' + parentSelector))
                : undefined;
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/management/book/views/_modalConfirm.html',
                controller: function ($scope, $uibModalInstance) {
                    $scope.title = 'LMS';
                    $scope.header = 'Delete Books';
                    $scope.confirmAction = 'Are you sure you want to delete the selected book(s)?';
                    $scope.confirmActionSecond = 'If deleted, the book(s) will be removed from all devices.';
                    $scope.actionName = 'Delete';

                    //$scope.topBorderColor = 'rgb(229,60,46)';
                    $scope.isWarningModal = true;

                    $scope.ok = function () {
                        vm.deleteBooksRequest();
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                appendTo: parentElem
            });
        };

        vm.seeBookInfo = function (book, parentSelector) {

            var parentElem = parentSelector
                ? angular.element($document[0].querySelector('.container ' + parentSelector))
                : undefined;

            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/management/book/views/_bookInfo.html',
                controller: function ($scope, $uibModalInstance) {

                    $scope.title = 'LMS';
                    $scope.header = 'Book Info';
                    $scope.bookTitle = book.Title;
                    $scope.isbn = book.Identifier;
                    $scope.author = book.Author;
                    $scope.subject = book.Subject;
                    $scope.actionName = 'Continue';
                    $scope.isWarningModal = false;
                    $scope.sizeOnDevice = book.SizeOnDevice;
                    $scope.downloadSize = book.DownloadSize;

                    if (book.StatusChangeDate && book.StatusChangeDate != "" && book.Status) {
                        $scope.bookStatus = book.Status.toLowerCase();
                        $scope.statusSinceDate = new Date(trimEnd(book.StatusChangeDate.toUpperCase(), 'Z') + 'Z').toLocaleString();
                        $scope.statusDatetext = getStatusDateLabel(book.Status.toLowerCase(), book.StatusChangeDate);
                    }

                    $scope.ok = function () {
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                appendTo: parentElem
            });
        };

        function getStatusDateLabel(bookStatus, statusSinceDate) {
            if (statusSinceDate != null && statusSinceDate != "") {
                switch (bookStatus) {
                    case "intesting":
                        return "Published at:";
                    case "approved":
                        return "Approved at:";
                    case "released":
                        return "Released at:"
                    case "scheduled":
                        return "Scheduled at:"
                };
            }
            return "";
        }
        vm.getSearchTypeDescription = function (isAdvancedSearch) {
            return isAdvancedSearch ? 'Advanced search results' : 'Search results';
        };

        function trimEnd(str, trailer) {
            var index = str.lastIndexOf(trailer);
            if (index > -1 && index == str.length - trailer.length) {
                str = str.substring(0, str.length - trailer.length);
                return trimEnd(str, trailer);
            }
            return str;
        }

        vm.showLoadMore = function () {
            return allBooksInTesting > bookCtrl.bookCoversTesting.length && bookCtrl.bookCoversTesting.length != 0;
        };
    }

}());
(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('bookCover', function () {
            return {
                restrict: 'E',
                templateUrl: 'app/management/book/views/_bookCover.html',
                scope: {
                    bookCovers: "=",
                    toggleBook: '&',
                    showBookInfo: '&',
                    bookCoverFirstPart: '@',
                    bookCoverSecondPart: '@',
                    coversPerLine:'='
                },
                controller: function ($scope) {
                    $scope.$watch('coversPerLine', function (newval) {
                    })


                }

            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('bookControls', function () {
            return {
                restrict: 'E',
                templateUrl: 'app/management/book/views/_controls.html',
                scope: {
                    allBooksAreSelected: '=',
                    selectedBooksCount: '=',
                    allBooksCount: '=',
                    booksHeading: '@',
                    bookType:'@'

                },
                controller: function ($scope, bookService) {
                    var bookTypes = {
                        Pending: 1,
                        Approved: 2,
                        Released: 3,
                        Scheduled: 4
                    }

                    $scope.exportToExcel = function () {
                        bookService.exportToExcel(bookTypes[$scope.bookType])
                        .then(function (res) {
                            console.log(res)
                        }, function (err) {
                            console.log(err)
                        })
                    }

                }

            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('deleteSvg', function () {
            return {
                restrict: 'E',
                template: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" viewBox="572.084 36.25 17 17" enable-background="new 572.084 36.25 17 17" xml:space="preserve"> <g> <path fill="rgb(0, 128, 187)" d="M587.985,39.195h-14.803c-0.196,0-0.356-0.16-0.356-0.357c0-0.196,0.16-0.357,0.356-0.357h14.803 c0.197,0,0.356,0.161,0.356,0.357C588.342,39.035,588.183,39.195,587.985,39.195"/> <path fill="rgb(0, 128, 187)" d="M587.985,39.438h-14.803c-0.33,0-0.599-0.269-0.599-0.6c0-0.33,0.269-0.6,0.599-0.6h14.803 c0.33,0,0.599,0.27,0.599,0.6C588.584,39.169,588.315,39.438,587.985,39.438z M573.183,38.724c-0.062,0-0.114,0.052-0.114,0.114 s0.053,0.115,0.114,0.115h14.803c0.062,0,0.114-0.052,0.114-0.115c0-0.062-0.052-0.114-0.114-0.114H573.183z"/> <path fill="rgb(0, 128, 187)" d="M582.775,39.057c-0.212-1.035-1.133-1.787-2.19-1.787c-1.06,0-1.98,0.752-2.19,1.787l-0.698-0.142 c0.278-1.368,1.493-2.358,2.889-2.358c1.395,0,2.608,0.99,2.889,2.357L582.775,39.057z"/> <path fill="rgb(0, 128, 187)" d="M582.587,39.343l-0.05-0.237c-0.188-0.924-1.01-1.594-1.952-1.594c-0.944,0-1.766,0.67-1.953,1.594 l-0.048,0.237l-1.173-0.238l0.048-0.237c0.3-1.479,1.614-2.553,3.126-2.553c1.51,0,2.824,1.072,3.126,2.551l0.048,0.238 L582.587,39.343z M577.993,38.729l0.224,0.045c0.316-1.025,1.276-1.747,2.368-1.747c1.09,0,2.05,0.722,2.367,1.747l0.225-0.047 c-0.34-1.13-1.394-1.928-2.592-1.928C579.385,36.799,578.331,37.598,577.993,38.729z"/> <path fill="rgb(0, 128, 187)" d="M585.395,52.943h-9.62c-0.55,0-1.027-0.471-1.062-1.049c-0.246-4.119-0.493-8.243-0.738-12.364 c-0.012-0.196,0.14-0.364,0.335-0.377c0.21-0.017,0.365,0.139,0.377,0.336c0.244,4.121,0.492,8.243,0.738,12.364 c0.014,0.205,0.173,0.377,0.35,0.377h9.62c0.176,0,0.336-0.172,0.35-0.379c0.245-4.119,0.491-8.242,0.74-12.362 c0.012-0.197,0.183-0.343,0.378-0.336c0.195,0.013,0.345,0.181,0.334,0.377c-0.249,4.123-0.496,8.245-0.741,12.364 C586.419,52.475,585.944,52.943,585.395,52.943"/> <path fill="rgb(0, 128, 187)" d="M585.395,53.186h-9.62c-0.677,0-1.263-0.572-1.304-1.277l-0.738-12.363 c-0.02-0.328,0.232-0.613,0.562-0.633c0.001,0,0.003,0,0.004,0c0.361,0,0.612,0.242,0.631,0.563l0.738,12.362 c0.005,0.086,0.068,0.15,0.107,0.15h9.62c0.033,0,0.102-0.059,0.108-0.152c0.244-4.119,0.49-8.24,0.739-12.361 c0.019-0.316,0.285-0.564,0.607-0.564c0.354,0.021,0.606,0.305,0.59,0.633c-0.249,4.125-0.496,8.246-0.742,12.365 C586.653,52.613,586.068,53.186,585.395,53.186z M574.341,39.395c-0.08,0.004-0.128,0.059-0.123,0.121l0.737,12.365 c0.026,0.451,0.395,0.82,0.819,0.82h9.62c0.424,0,0.791-0.369,0.818-0.822c0.245-4.117,0.492-8.24,0.741-12.363 c0.004-0.062-0.044-0.117-0.106-0.12c-0.063,0-0.118,0.048-0.121,0.107c-0.249,4.122-0.495,8.243-0.74,12.362 c-0.021,0.336-0.287,0.607-0.592,0.607h-9.62c-0.305,0-0.57-0.27-0.591-0.605l-0.74-12.363 C574.441,39.453,574.412,39.395,574.341,39.395z"/> <path fill="rgb(0, 128, 187)" d="M577.88,50.326c-0.188,0-0.345-0.148-0.356-0.338l-0.477-8.499c-0.01-0.197,0.14-0.365,0.336-0.377 c0.188-0.025,0.365,0.14,0.377,0.337l0.476,8.5c0.012,0.195-0.14,0.363-0.337,0.375C577.893,50.326,577.885,50.326,577.88,50.326" /> <path fill="rgb(0, 128, 187)" d="M577.88,50.568c-0.316,0-0.579-0.248-0.599-0.564l-0.477-8.501c-0.018-0.329,0.235-0.612,0.564-0.633 c0.002,0,0.004,0,0.006,0c0.35,0,0.607,0.253,0.628,0.563l0.475,8.502c0.02,0.328-0.234,0.611-0.565,0.631L577.88,50.568z M577.421,41.352c-0.088,0.006-0.135,0.061-0.132,0.125l0.477,8.5c0.003,0.059,0.053,0.105,0.114,0.105v0.244l0.002-0.244 c0.066-0.004,0.115-0.057,0.111-0.119l-0.476-8.5C577.515,41.404,577.461,41.352,577.421,41.352z"/> <path fill="rgb(0, 128, 187)" d="M583.288,50.326c-0.005,0-0.013,0-0.019-0.002c-0.197-0.012-0.348-0.18-0.336-0.375l0.475-8.5 c0.01-0.197,0.176-0.363,0.376-0.337c0.195,0.012,0.347,0.18,0.335,0.377l-0.475,8.499 C583.634,50.178,583.477,50.326,583.288,50.326"/> <path fill="rgb(0, 128, 187)" d="M583.288,50.568l-0.059-0.006c-0.133-0.006-0.28-0.076-0.387-0.195c-0.107-0.119-0.16-0.273-0.151-0.434 l0.474-8.498c0.018-0.318,0.271-0.568,0.577-0.568l0.074,0.004c0.312,0.02,0.564,0.303,0.545,0.632l-0.475,8.499 C583.869,50.32,583.606,50.568,583.288,50.568z M583.765,41.354c-0.071,0-0.111,0.051-0.114,0.108l-0.475,8.499 c-0.004,0.055,0.054,0.117,0.108,0.121l0.004,0.244v-0.244c0.062,0,0.111-0.047,0.114-0.105l0.475-8.501 c0.004-0.063-0.045-0.118-0.107-0.122C583.768,41.354,583.766,41.354,583.765,41.354z"/> <path fill="rgb(0, 128, 187)" d="M580.585,50.326c-0.197,0-0.357-0.16-0.357-0.357v-8.501c0-0.196,0.16-0.355,0.357-0.355 c0.196,0,0.357,0.159,0.357,0.355v8.501C580.942,50.166,580.781,50.326,580.585,50.326"/> <path fill="rgb(0, 128, 187)" d="M580.585,50.568c-0.33,0-0.6-0.27-0.6-0.6v-8.501c0-0.329,0.27-0.599,0.6-0.599s0.6,0.27,0.6,0.599v8.501 C581.185,50.299,580.915,50.568,580.585,50.568z M580.585,41.354c-0.063,0-0.114,0.051-0.114,0.113v8.501 c0,0.125,0.229,0.125,0.229,0v-8.501C580.699,41.405,580.648,41.354,580.585,41.354z"/> </g> </svg> '


            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('svgDropdown', function () {
            return {
                restrict: 'E',
                template: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="7.383px" viewBox="381.834 81.867 14 7.383" enable-background="new 381.834 81.867 14 7.383" xml:space="preserve"> <path fill="#40B4E5" d="M395.654,81.934c-0.232-0.232-0.636-0.232-0.868,0l-5.953,5.948l-5.951-5.948 c-0.232-0.232-0.637-0.231-0.867-0.001c-0.116,0.115-0.181,0.27-0.181,0.435c0,0.164,0.064,0.318,0.18,0.435l6.386,6.383 c0.116,0.115,0.27,0.18,0.434,0.18s0.317-0.064,0.434-0.18l6.388-6.383c0.116-0.117,0.181-0.271,0.18-0.436 C395.834,82.202,395.77,82.048,395.654,81.934z"/> </svg> '

            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('exportExcel', function () {
            return {
                restrict: 'E',
                template: '<svg version="1.1" style="width:20px;height:20px" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="13.703px" height="16.4px" viewBox="573.795 69.884 13.703 16.4" enable-background="new 573.795 69.884 13.703 16.4" xml:space="preserve"> <g> <path fill="#0080BB" d="M579.103,81.304c-0.073,0.099-0.103,0.221-0.084,0.344c0.02,0.123,0.085,0.23,0.185,0.304 c0.08,0.057,0.175,0.088,0.271,0.088c0.148,0,0.288-0.072,0.374-0.191l3.268-4.487c0.006-0.009,0.004-0.021,0.009-0.029 c0.046-0.071,0.079-0.151,0.079-0.242c0-0.092-0.034-0.173-0.08-0.244c-0.005-0.009-0.003-0.02-0.009-0.027l-3.266-4.488 c-0.144-0.197-0.448-0.245-0.644-0.103c-0.101,0.071-0.167,0.18-0.187,0.302c-0.02,0.123,0.01,0.245,0.083,0.345l2.731,3.753 h-7.532c-0.255,0-0.463,0.208-0.463,0.463s0.208,0.463,0.463,0.463h7.532L579.103,81.304z"/> <path fill="#0080BB" d="M587.329,70.572c0-0.27-0.219-0.488-0.487-0.488h-11.955c-0.269,0-0.488,0.219-0.488,0.488 c0,0.269,0.22,0.487,0.488,0.487h11.467v9.657h-3.904c-0.269,0-0.487,0.219-0.487,0.487v3.904h-6.588v-3.904 c0-0.269-0.219-0.487-0.487-0.487s-0.488,0.219-0.488,0.487v4.392c0,0.27,0.22,0.488,0.488,0.488h7.562 c0.131,0,0.254-0.051,0.346-0.143l4.389-4.391l0,0c0.033-0.033,0.057-0.075,0.08-0.117c0.038-0.07,0.065-0.146,0.065-0.229V70.572z M582.938,84.419v-2.727h2.727L582.938,84.419z"/> </g> </svg> ',
                controller: function ($scope,$rootScope) {                    
                    $scope.permissionCheck = function (input) {
                        return $rootScope.checkForPermission(input);
                    };
                }

            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('infoIcon', function () {
            return {
                restrict: 'E',
                template: '<div class="action-svg-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="531.584 12 16 16" enable-background="new 531.584 12 16 16" xml:space="preserve"> <path fill="#0080BB" d="M539.584,12c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S543.995,12,539.584,12z M539.584,26.517 c-3.594,0-6.516-2.924-6.516-6.517c0-3.594,2.922-6.516,6.516-6.516c3.593,0,6.517,2.922,6.517,6.516 C546.101,23.593,543.177,26.517,539.584,26.517z"/> <g> <g> <path fill="#0080BB" d="M539.584,18c-0.552,0-1,0.448-1,1v5c0,0.552,0.448,1,1,1s1-0.448,1-1v-5 C540.584,18.448,540.136,18,539.584,18z M539.584,17c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S539.032,17,539.584,17z"/> </g> </g> </svg></div>'

            };
        });
})();

(function () {
	'use strict';
	angular.module('managementConsole')
		.directive('lazyLoad', ['$http', function ($http) {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					const observer = new IntersectionObserver(loadImg)
					const img = angular.element(element)[0];
					observer.observe(img)

					function loadImg(changes) {
						changes.forEach(function (change) {
							if (change.intersectionRatio > 0) {
								var url = element.attr('img-http-src');
								element.attr('img-http-src', '');

								if (url != '') {
									$http.get(url, { responseType: 'arraybuffer' })
										.then(function (response) {
											var blob = new Blob(
												[response.data],
												{ type: response.headers('Content-Type') }
											);
											var objectURL = URL.createObjectURL(blob);
											change.target.src = objectURL;
										});
								}
							}
						})
					}
				}
			}
		}])
})();
(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('lockSvg', function () {
            return {
                restrict: 'E',
                template: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" viewBox="604.001 12 16 16" enable-background="new 604.001 12 16 16" xml:space="preserve"> <g> <path fill="#0080BB" d="M617.979,18.177h-1.052v-1.328c0-2.717-2.211-4.928-4.928-4.928s-4.928,2.211-4.928,4.928v1.328h-1.051 c-0.733,0-1.328,0.596-1.328,1.328v7.088c0,0.732,0.595,1.328,1.328,1.328h11.958c0.731,0,1.329-0.596,1.329-1.328v-7.088 C619.309,18.772,618.711,18.177,617.979,18.177z M608.4,16.849c0-1.984,1.615-3.6,3.6-3.6s3.599,1.615,3.599,3.6v1.328H608.4 V16.849z M617.979,26.593h-11.958v-7.088h11.958V26.593z"/> <path fill="#0080BB" d="M611.335,23.373v1.559h1.329v-1.558c0.428-0.236,0.72-0.685,0.72-1.208c0-0.764-0.619-1.384-1.384-1.384 c-0.766,0-1.384,0.62-1.384,1.384C610.616,22.688,610.908,23.138,611.335,23.373z"/> </g> </svg> '


            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('rejectSvg', function () {
            return {
                restrict: 'E',
                template: '<svg version="1.1" style="width:20px;height:20px" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22 22"  xml: space = "preserve" > <style type="text/css"> .st0{fill: #E53C2E;} </style> <g><g transform="translate(0,-952.36218)"><g><path class="st0" d="M8.9,971.7H1.7c-0.4,0-0.8-0.4-0.8-0.8v-16.8c0-0.4,0.3-0.7,0.6-0.8h16.9c0.4,0,0.8,0.4,0.8,0.8v6.5h-1v-6.3 H1.9v16.4h7V971.7z M1.9,954.1L1.9,954.1L1.9,954.1z" /></g></g><g><path class="st0" d="M11.8,11.3c-0.3,0-0.5,0.5-0.3,0.8l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.5,0,0.6c0.2,0.2,0.5,0.2,0.6,0l4.1-4.1 l4.1,4.1c0.2,0.2,0.5,0.2,0.6,0c0.2-0.2,0.2-0.5,0-0.6l-4.1-4.1L21,12c0.3-0.2,0-0.8-0.3-0.8c-0.1,0-0.2,0.1-0.3,0.1l-4.1,4.1 l-4.1-4.1C12.1,11.3,11.9,11.3,11.8,11.3L11.8,11.3z" /></g></g></svg> '

            };
        });
})();
(function () {
    'use strict';

    angular
        .module('managementConsole')
        .directive('selectAll', function () {
            return {
                restrict: 'E',
                templateUrl: 'app/management/book/views/_selectAll.html',
                scope: {
                    ngModel: "=",
                    changeSelect: '&',
                    selectorOf: '@',
                    selectLabel: '@'
                },
                require: 'ngModel'

            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('tickSvg', function () {
            return {
                restrict: 'E',
                template: '<svg version="1.1" style="width:20px;height:20px" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="14px" viewBox="381.834 13 14 14" enable-background="new 381.834 13 14 14" xml:space="preserve"> <path fill="#0580BB" d="M395.635,14.162c-0.225-0.184-0.587-0.146-0.767,0.076l-8.493,10.356l-3.6-3.779 c-0.2-0.21-0.563-0.22-0.772-0.02c-0.105,0.1-0.165,0.236-0.169,0.383c-0.003,0.146,0.051,0.284,0.151,0.389l4.023,4.226 c0.103,0.107,0.246,0.169,0.395,0.169h0.019h0.005c0.155-0.007,0.301-0.08,0.399-0.2l8.885-10.832 C395.901,14.697,395.866,14.353,395.635,14.162z"/> </svg> '

            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('unlockSvg', function () {
            return {
                restrict: 'E',
                template: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" viewBox="628.001 12 16 16" enable-background="new 628.001 12 16 16" xml:space="preserve"> <g> <path fill="#0080BB" d="M641.633,18.24h-8.903v-1.134c0-1.804,1.467-3.272,3.271-3.272c1.063,0,2.063,0.523,2.678,1.398 l0.034,0.051h1.681l-0.077-0.168c-0.778-1.682-2.472-2.768-4.315-2.768c-2.623,0-4.757,2.135-4.757,4.759v1.134h-0.874 c-0.754,0-1.368,0.613-1.368,1.368v6.675c0,0.755,0.614,1.369,1.368,1.369h11.264c0.754,0,1.368-0.614,1.368-1.369v-6.675 C643.001,18.854,642.387,18.24,641.633,18.24z M641.515,19.727v6.439h-11.027v-6.439H641.515z"/> <path fill="#0080BB" d="M635.257,23.318v1.519h1.488v-1.518c0.419-0.26,0.677-0.716,0.677-1.205c0-0.783-0.639-1.421-1.422-1.421 c-0.782,0-1.42,0.638-1.42,1.421C634.58,22.604,634.838,23.06,635.257,23.318z"/> </g> </svg> '


            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('batteryLow', function () {
            return {
                restrict: 'E',
                template: '<?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24.001px" height="13.959px" viewBox="1004.968 44.243 24.001 13.959" enable-background="new 1004.968 44.243 24.001 13.959" xml:space="preserve"> <g> <path fill="#F3755F" d="M1027.947,47.521c-0.376,0-0.689,0.212-0.867,0.514v-2.77c0-0.565-0.455-1.021-1.021-1.021h-20.068 c-0.562,0-1.021,0.456-1.021,1.021v11.916c0,0.565,0.459,1.021,1.021,1.021h20.068c0.566,0,1.021-0.456,1.021-1.021v-2.77 c0.178,0.302,0.491,0.514,0.867,0.514c0.566,0,1.021-0.457,1.021-1.021v-5.361C1028.969,47.978,1028.514,47.521,1027.947,47.521z M1025.037,56.16h-18.025v-9.875h18.025V56.16z"/> <path fill="#F3755F" d="M1009.896,54.925c0.564,0,1.021-0.457,1.021-1.021v-5.361c0-0.564-0.457-1.021-1.021-1.021 s-1.021,0.457-1.021,1.021v5.361C1008.875,54.468,1009.332,54.925,1009.896,54.925z"/> </g> </svg> ',
                controller: function ($scope, $rootScope) {
                   
                }

            };
        });
})();


(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('batteryAverage', function () {
            return {
                restrict: 'E',
                template: '<?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24.001px" height="13.959px" viewBox="958.593 44.243 24.001 13.959" enable-background="new 958.593 44.243 24.001 13.959" xml:space="preserve"> <g> <path fill="#FFCD5A" d="M981.572,47.521c-0.376,0-0.689,0.212-0.867,0.514v-2.77c0-0.565-0.455-1.021-1.021-1.021h-20.068 c-0.562,0-1.021,0.456-1.021,1.021v11.916c0,0.565,0.459,1.021,1.021,1.021h20.068c0.566,0,1.021-0.456,1.021-1.021v-2.77 c0.178,0.302,0.491,0.514,0.867,0.514c0.566,0,1.021-0.457,1.021-1.021v-5.361C982.594,47.978,982.139,47.521,981.572,47.521z M978.662,56.16h-18.025v-9.875h18.025V56.16z"/> <path fill="#FFCD5A" d="M963.521,54.925c0.564,0,1.021-0.457,1.021-1.021v-5.361c0-0.564-0.457-1.021-1.021-1.021 s-1.021,0.457-1.021,1.021v5.361C962.5,54.468,962.957,54.925,963.521,54.925z"/> <path fill="#FFCD5A" d="M967.607,54.925c0.564,0,1.021-0.457,1.021-1.021v-5.361c0-0.564-0.457-1.021-1.021-1.021 c-0.566,0-1.021,0.457-1.021,1.021v5.361C966.586,54.468,967.041,54.925,967.607,54.925z"/> </g> </svg> ',
                controller: function ($scope, $rootScope) {

                }

            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole')
        .directive('batteryHigh', function () {
            return {
                restrict: 'E',
                template: '<?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24.001px" height="13.959px" viewBox="913.093 44.243 24.001 13.959" enable-background="new 913.093 44.243 24.001 13.959" xml:space="preserve"> <g> <path fill="#016836" d="M936.072,47.521c-0.376,0-0.689,0.212-0.867,0.514v-2.77c0-0.565-0.455-1.021-1.021-1.021h-20.068 c-0.562,0-1.021,0.456-1.021,1.021v11.916c0,0.565,0.459,1.021,1.021,1.021h20.068c0.566,0,1.021-0.456,1.021-1.021v-2.77 c0.178,0.302,0.491,0.514,0.867,0.514c0.566,0,1.021-0.457,1.021-1.021v-5.361C937.094,47.978,936.639,47.521,936.072,47.521z M933.162,56.16h-18.025v-9.875h18.025V56.16z"/> <path fill="#016836" d="M918.021,54.925c0.564,0,1.021-0.457,1.021-1.021v-5.361c0-0.564-0.457-1.021-1.021-1.021 S917,47.978,917,48.542v5.361C917,54.468,917.457,54.925,918.021,54.925z"/> <path fill="#016836" d="M922.107,54.925c0.564,0,1.021-0.457,1.021-1.021v-5.361c0-0.564-0.457-1.021-1.021-1.021 c-0.566,0-1.021,0.457-1.021,1.021v5.361C921.086,54.468,921.541,54.925,922.107,54.925z"/> <path fill="#016836" d="M926.191,54.925c0.566,0,1.021-0.457,1.021-1.021v-5.361c0-0.564-0.455-1.021-1.021-1.021 c-0.564,0-1.02,0.457-1.02,1.021v5.361C925.172,54.468,925.627,54.925,926.191,54.925z"/> </g> </svg> ',
                controller: function ($scope, $rootScope) {

                }

            };
        });
})();

(function () {
    'use strict';

    angular.module('managementConsole').directive('device', device);

    function device(commonHelperService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                device: '=info'
            },
            templateUrl: 'app/management/device/partials/_device.html',
            controller: function ($scope) {             
                $scope.device.LastLogin = commonHelperService.transformDateToLocalTime($scope.device.LastLogin);
            }
        };
    }

}());
(function () {
    'use strict';

    angular.module('managementConsole').directive('deviceBattery', deviceBattery);

    function deviceBattery() {
        function link(scope, elem, attrs) {
            scope.batteryClass = "";

            function updateBatteryStatusView() {
                if (scope.batteryStatus) {
                    if (scope.batteryStatus <= 20) {
                        scope.batteryClass = "battery-status-red";
                    } else {
                        if (scope.batteryStatus > 20 && scope.batteryStatus < 50) {
                            scope.batteryClass = "battery-status-yellow";
                        }
                        else {
                            scope.batteryClass = "battery-status-green";
                        }
                    }
                }
            }  

            scope.$watch('batteryStatus', function () {
                updateBatteryStatusView();
            });
        }

        return {
            restrict: 'E',
            replace: true,
            scope: {
                batteryStatus: '@',
            },
            link: link,
            templateUrl: 'app/management/device/partials/_deviceBattery.html'
        };
    }

}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('DeviceController', DeviceController);

    function DeviceController($scope, $state, $filter, $q, $timeout, toastr, deviceService, userInfoService, userService, chartOptionService) {
        var vm = this;
        

        vm.slickLoaded = true;// This is used as hack for the slick carousel for dynamic data loading.
        vm.slickConfig = {
            autoplay: false,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: true,
            method: {},
            event: {},
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
            }]
        };
        
        // Hold all advanced search controls get requests
        vm.statisticsRequestsList = [];
        vm.statisticWidgetVisible = false;
        vm.timeoutBeforeShowingStatistics = 500;// This a hack in case the statistics was hidden, go to other module, come back to this screen and then click stat icon ==> slick will load correctly
        vm.chartColors = chartOptionService.chartColors;
        vm.deviceUsageByOSVersionData = {};
        vm.deviceUsageByBrandData = {};
        vm.deviceUsageByResolutionData = {};

        // Hold all advanced search controls get requests
        vm.searchRelatedRequestsList = [];

        vm.maxItemsPerLoad = 4;

        vm.isSearching = false;
        vm.showKeywords = false;
        vm.noDataFound = false;

        vm.isAdvancedSearch = false;
        vm.searchTypeDescription = '';
        vm.searchCriteria = { ToSelect: vm.maxItemsPerLoad };
        vm.searchCriteriaBackup = { ToSelect: vm.maxItemsPerLoad };
        vm.searchPredefinedKeywords = ['Grade 01', 'Grade 02', 'Grade 03', 'Grade 04', 'Grade 05', 'Grade 06', 'Grade 07', 'Grade 08', 'Grade 09', 'Grade 10', 'Grade 11', 'Grade 12', 'Grade 13', 'Grade 98', 'Grade K1', 'Grade K2', 'Grade K3', 'Grade NU'];

        vm.deviceStatus = [];
        vm.deviceTypes = [];
        vm.userSchools = [];
        vm.statisticsUserSchools = [];
        vm.deviceSearchResults = { devices: [], visibleDevicesItems: vm.maxItemsPerLoad };

        vm.initModule = function () {
            vm.searchRelatedRequestsList.push(vm.getDeviceStatus());
            vm.searchRelatedRequestsList.push(vm.getDeviceTypes());
            vm.searchRelatedRequestsList.push(vm.getUserRelatedSchoolsGradesSections());

            if ($state.params) {
                if ($state.params.deviceSearchResults) {
                    vm.deviceSearchResults = $state.params.deviceSearchResults;
                }
                if ($state.params.searchCriteriaBackup) {
                    var searchCriteriaBackupHolder = $state.params.searchCriteriaBackup;
                    vm.searchTypeDescription = vm.getSearchTypeDescription(searchCriteriaBackupHolder.IsAdvancedSearch);

                    // When all data is loaded in advanced search dropdowns set the selected criteria
                    $q.all(vm.searchRelatedRequestsList).then(function () {
                        vm.searchCriteria = searchCriteriaBackupHolder;
                        vm.searchCriteriaBackup = searchCriteriaBackupHolder;

                        if (vm.searchCriteria.Keyword) {
                            vm.showKeywords = true;
                        }
                    });
                }

                $state.params = null;
            }
            else {
                vm.resetSearch('all');
            }
        };

        vm.showHideStatisticsWidget = function () {
            vm.statisticWidgetVisible = !vm.statisticWidgetVisible;
            vm.timeoutBeforeShowingStatistics = vm.statisticWidgetVisible ? 3000 : 500;
            userInfoService.setDeviceStatisticsView(vm.statisticWidgetVisible);
        }

        function getLabels(obj){
            var labels = [];
            for (var prop in obj) {
                labels.push(prop);
            }
            return labels;
        }

        function getValues(obj) {
            var values = [];
            for (var prop in obj) {
                values.push(obj[prop]);
            }
            return values;
        }
        var options = jQuery.extend(true, {}, chartOptionService.pieOptions);

        deviceService.getStatistics()
        .then(function (res) {
          //ADD OS Version
            var osVersionLabels = getLabels(res.AndroidVersion);
            var osVersionValues = getValues(res.AndroidVersion);
          
            vm.deviceUsageByOSVersionData = {
                labels: osVersionLabels,
                datasets: {
                    data: osVersionValues,
                    options: options
                }
            };

            vm.deviceUsageByOSVersionData.datasets.options.title.text = 'Usage by Android Version';

            var schoolProvided = '';
            if (res.Schools.length == 0) {
                 schoolProvided = 'Not assigned to a school';
            } else {
                 schoolProvided = res.Schools.join(', ');          
            }

            vm.androidVersionStatsSchool = schoolProvided;
            vm.brandStatsSchool = schoolProvided;
            vm.resolutionStatsSchool = schoolProvided;

            //ADD Brand
            var brandLabels = getLabels(res.Brand);
            var brandValues = getValues(res.Brand);

            vm.deviceUsageByBrandData = {
                labels: brandLabels,
                datasets: {
                    data: brandValues,
                    options: options
                }
            };
            

            $timeout(function () {
                vm.deviceUsageByBrandData.datasets.options.title.text = 'Usage by Brand';
                $scope.$apply()
            })
            //Add Resolution
            var resolutionLevels = getLabels(res.Resolution);
            var resolutionValues = getValues(res.Resolution);

            vm.deviceUsageByResolutionData = {
                labels: resolutionLevels,
                datasets: {
                    data: resolutionValues,
                    options: options
                }
            };

            $timeout(function () {
                vm.deviceUsageByResolutionData.datasets.options.title.text = 'Usage by Resolution';
                $scope.$apply()
            })

            

            
        }, function (err) {
            console.log(err);
        })

        vm.getDeviceStatistics = function () {
            vm.slickLoaded = false;

          //  vm.statisticsRequestsList.push(vm.getDevicesUsageGroupedByOSVersion());
          //  vm.statisticsRequestsList.push(vm.getDevicesUsageGroupedByBrand());
          //  vm.statisticsRequestsList.push(vm.getDevicesUsageGroupedByResolution());

            var isWidgetVisible = userInfoService.getDeviceStatisticsView();
            if (isWidgetVisible === undefined || isWidgetVisible === null) {
                isWidgetVisible = true;
            }
            else {
                isWidgetVisible = JSON.parse(isWidgetVisible);
            }
            userInfoService.setDeviceStatisticsView(isWidgetVisible);
            vm.statisticWidgetVisible = isWidgetVisible;

            $q.all(vm.statisticsRequestsList).then(function () {
                $timeout(function () {
                    vm.slickLoaded = true;
                }, vm.timeoutBeforeShowingStatistics);
            });
        }

        //vm.getDevicesUsageGroupedByOSVersion = function () {
        //    var promise = deviceService.getDevicesUsageStatistics(vm.androidVersionStatsSchool, 1);

        //    promise.then(function (response) {
        //        var options = jQuery.extend(true, {}, chartOptionService.pieOptions);
        //        options.title.text = response.title;

        //        vm.deviceUsageByOSVersionData = {
        //            labels: response.labels,
        //            datasets: {
        //                data: response.data,
        //                options: options
        //            }
        //        };
        //    },
        //    function (error) {
                
        //    });

        //   return promise;
        //};

        //vm.getDevicesUsageGroupedByBrand = function () {
        //    var promise = deviceService.getDevicesUsageStatistics(vm.brandStatsSchool, 2);

        //    promise.then(function (response) {
        //        var options = jQuery.extend(true, {}, chartOptionService.pieOptions);
        //        options.title.text = response.title;

        //        vm.deviceUsageByBrandData = {
        //            labels: response.labels,
        //            datasets: {
        //                data: response.data,
        //                options: options
        //            }
        //        };
        //    },
        //    function (error) {
                
        //    });

        //    return promise;
        //};

        //vm.getDevicesUsageGroupedByResolution = function () {
        //    var promise = deviceService.getDevicesUsageStatistics(vm.resolutionStatsSchool, 3);

        //    promise.then(function (response) {
        //        var options = jQuery.extend(true, {}, chartOptionService.pieOptions);
        //        options.title.text = response.title;

        //        vm.deviceUsageByResolutionData = {
        //            labels: response.labels,
        //            datasets: {
        //                data: response.data,
        //                options: options
        //            }
        //        };
        //    },
        //    function (error) {
                
        //    });

        //    return promise;
        //};

        //vm.updateChart = function (type, school) {
            //if (type == 'UsageByAndroidVersion') {
            //    vm.androidVersionStatsSchool = school;
            //    vm.getDevicesUsageGroupedByOSVersion();
            //}
        //    if (type == 'UsageByBrand') {
        //        vm.brandStatsSchool = school;
        //        vm.getDevicesUsageGroupedByBrand();
        //    }
        //    if (type == 'UsageByResolution') {
        //        vm.resolutionStatsSchool = school;
        //        vm.getDevicesUsageGroupedByResolution();
        //    }
        //};

        vm.resetSearch = function (resetType) {
            if (resetType == 'all') {
                vm.searchCriteria = { ToSelect: vm.maxItemsPerLoad };
            }
            if (resetType == 'advanced') {
                var keywordInput = vm.searchCriteria.Keyword;
                var keywordsList = vm.searchCriteria.Keywords;

                $('[title="Type"]').find('.bs-searchbox>input').val('');
                $('[title="Status"]').find('.bs-searchbox>input').val('');
                $('[title="School"]').find('.bs-searchbox>input').val('');
                $('[title="Grade"]').find('.bs-searchbox>input').val('');
                $('.not-match').removeClass('not-match');

                vm.searchCriteria = { ToSelect: vm.maxItemsPerLoad };
                vm.searchCriteria.Keyword = keywordInput;
                vm.searchCriteria.Keywords = keywordsList;
            }
            if (resetType == 'keyword') {
                vm.searchCriteria.Keyword = '';
                vm.searchCriteria.Keywords = [];
            }
        };

        vm.showHideAdvancedSearch = function () {
            vm.isSearchBoxVisible = !vm.isSearchBoxVisible;
        };

        vm.getDeviceStatus = function () {
            var promise = deviceService.getDeviceStatus();

            promise.then(function (response) {
                vm.deviceStatus = response;
            },
            function (error) {
                
            });

            return promise;
        };

        vm.getDeviceTypes = function () {
            var promise = deviceService.getDeviceTypes();

            promise.then(function (response) {
                vm.deviceTypes = response;
            },
            function (error) {
              
            });

            return promise;
        };

        vm.getUserRelatedSchoolsGradesSections = function () {
            var promise = userService.getUserRelatedSchoolsGradesSections();

            promise.then(function (response) {
                vm.userSchools = response;

                if (vm.userSchools.length == 1) {
                   // vm.androidVersionStatsSchool = vm.userSchools[0];
                   // vm.brandStatsSchool = vm.userSchools[0];
                  //  vm.resolutionStatsSchool = vm.userSchools[0];
                }

                vm.getDeviceStatistics();
            },
            function (error) {
                
            });

            return promise;
        };

        vm.getDevices = function (isAdvancedSearch) {
            vm.showKeywords = false;
            vm.isSearching = true;

            vm.searchCriteria.IsAdvancedSearch = isAdvancedSearch;
            if (!vm.isSearchBoxVisible) {
                vm.resetSearch('advanced');

                if (!vm.searchCriteria.Keywords) {
                    vm.searchCriteria.Keywords = [];
                }
            }
            else {
                vm.resetSearch('keyword');
            }

            vm.searchCriteriaBackup = vm.searchCriteria;

            deviceService.getDevices(vm.searchCriteria).then(function (response) {
                if (response !== undefined && response.Devices) {
                    vm.deviceSearchResults.devices = response.Devices;
                    vm.deviceSearchResults.visibleDevicesItems = vm.maxItemsPerLoad;

                    vm.searchCriteria.Keywords = response.DeviceSearch.Keywords;
                    vm.showKeywords = true;
                    vm.noDataFound = vm.deviceSearchResults.devices.length > 0 ? false : true;
                }
                else {
                    vm.noDataFound = true;
                }
                vm.searchTypeDescription = vm.getSearchTypeDescription(vm.searchCriteria.IsAdvancedSearch);
                vm.isSearching = false;
            },
            function (error) {
                vm.deviceSearchResults.devices = [];
                vm.showKeywords = true;
                vm.noDataFound = true;
                vm.isSearching = false;
            });
        };

        vm.getMoreDevices = function () {
            vm.isSearching = true;
            vm.searchCriteriaBackup.ToSkip = vm.deviceSearchResults.visibleDevicesItems;

            deviceService.getDevices(vm.searchCriteriaBackup).then(function (response) {
                vm.deviceSearchResults.devices.splice(vm.deviceSearchResults.devices.length - 1, 1);// Remove the last item that is used to identifiy if "Load More" should be visible or not
                vm.deviceSearchResults.devices = vm.deviceSearchResults.devices.concat(response.Devices);

                vm.deviceSearchResults.visibleDevicesItems = vm.deviceSearchResults.visibleDevicesItems + vm.maxItemsPerLoad;

                vm.searchCriteriaBackup.ToSkip = 0;
                vm.isSearching = false;
            },
            function (error) {
               
                vm.showKeywords = true;
                vm.noDataFound = true;
                vm.isSearching = false;
            });
        };

        vm.getSearchTypeDescription = function (isAdvancedSearch) {
            return isAdvancedSearch ? 'Advanced search results' : 'Search results';
        };

        $scope.$watch(function () { return vm.searchCriteria.SchoolId; }, function () {
            if (vm.searchCriteria.SchoolId === undefined || vm.searchCriteria.SchoolId === null) {
                vm.schoolGrades = [];

                vm.searchCriteria.GradeId = null;
            }
            else {
                var school = $filter('filter')(vm.userSchools, { Id: vm.searchCriteria.SchoolId }, true);

                if (school && school !== undefined && school.length) {
                    vm.schoolGrades = school[0].Class
                }
            }
        });

  
        vm.initModule();
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('DeviceDetailsController', DeviceDetailsController);

    function DeviceDetailsController($rootScope, $scope, $state, $filter, $uibModal, toastr, deviceService, userService, commonHelperService, userRolesConstant) {
        var vm = this;
        vm.deviceId = 0;
        vm.device = null;
        vm.deviceSearchResults = null;
        vm.searchCriteriaBackup = null;
        vm.isLoadingOnInit = false;
        vm.isLoading = false;

        vm.removeUserFromDevice = false;
        vm.manageDevice = false;
        vm.removeUserDeviceLinkMethod = null;
        vm.userRolesConstant = userRolesConstant;

        vm.initModule = function () {
            vm.removeUserFromDevice = $rootScope.checkForPermission('RemoveUserFromDevice');
            vm.manageDevice = $rootScope.checkForPermission('ManageDevice');
            console.log(vm.manageDevice)

            if ($state.params) {
                if ($state.params.deviceId) {
                    vm.deviceId = $state.params.deviceId;

                    vm.getDeviceInfo();
                }
                if ($state.params.deviceSearchResults) {
                    vm.deviceSearchResults = $state.params.deviceSearchResults;
                }
                if ($state.params.searchCriteriaBackup) {
                    vm.searchCriteriaBackup = $state.params.searchCriteriaBackup;
                }
            }
        };

        vm.getDeviceInfo = function () {
            vm.isLoadingOnInit = true;

            deviceService.getDeviceInfo(vm.deviceId).then(function (response) {
                var lastUserLogin = response.LastLogin;

                response.LastLogin = commonHelperService.transformDateToLocalTime(response.LastLogin);
                response.FirstLogin = commonHelperService.transformDateToLocalTime(response.FirstLogin)


                vm.device = response;
        
                vm.isLoadingOnInit = false;
            },
                function (error) {
                    toastr.error('getDeviceInfo: ' + error);
                    vm.isLoadingOnInit = false;
                });
        };

        vm.askChangeDeviceStatus = function () {
            vm.showWarning("disableDevice", { ConfirmAction: vm.disableDevice, ConfirmActionParams: null });
        };

        vm.disableDevice = function () { vm.changeDeviceStatus(true); };

        vm.changeDeviceStatus = function (status) {
            vm.isLoading = true;

            deviceService.updateDeviceStatus( vm.deviceId,  status ).then(function () {
                vm.device.DeviceStatus = status ? 1 : 0;

                // Update the search result to reflect the change when the user is back to search search screen
                var device = $filter('filter')(vm.deviceSearchResults.devices, { Id: parseInt(vm.deviceId) }, true);
                var deviceIndex = 0;

                if (device && device !== undefined && device.length) {
                    deviceIndex = vm.deviceSearchResults.devices.indexOf(device[0]);
                    vm.deviceSearchResults.devices[deviceIndex].DeviceStatus = status ? 1 : 0;
                }

                vm.isLoading = false;
                toastr.success('Device is ' + (status ? 'disabled' : 'enabled') + ' sucessfully');
            },
                function (error) {
                    vm.isLoading = false;
                    toastr.error('changeDeviceStatus: ' + error);
                });
        };

        vm.askRemoveAssignedUser = function (userId) {
            vm.showWarning("unassignDeviceUser", { ConfirmAction: vm.removeAssignedUser, ConfirmActionParams: { UserId: userId, deviceId: vm.deviceId } });
        };

        vm.removeAssignedUser = function (params) {
            vm.isLoading = true;

            userService.removePairedDevice(params.UserId, params.deviceId).then(function (response) {
                var userIndex;
                var deviceUser = $filter('filter')(vm.device.Users, { Id: params.UserId }, true);
                if (deviceUser && deviceUser !== undefined && deviceUser.length) {
                    userIndex = vm.device.Users.indexOf(deviceUser[0]);
                    vm.device.Users.splice(userIndex, 1);
                    vm.hideWarning();
                }

                vm.isLoading = false;
                toastr.success('User unassigned successfully');
            },
                function (error) {
                    vm.isLoading = false;
                    toastr.error('removeAssignedUser: ' + error);
                });
        };

        vm.showWarning = function (action, params) {
            var templateURL = "";
            switch (action) {
                case "disableDevice":
                    templateURL = 'app/management/device/partials/_disableMessage.html';
                    break;
                case "unassignDeviceUser":
                    templateURL = 'app/management/device/partials/_removeAssignedUserMessage.html';
                    break;
            }

            $rootScope.modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-message-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: templateURL,
                controller: 'ModalController as vm',
                resolve: {
                    params: params
                }
            });
        };

        vm.hideWarning = function () {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }
        };

        vm.initModule();
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').filter('deviceTypeIconFilter', deviceTypeIconFilter);

    function deviceTypeIconFilter() {
        function typeIcon(typeId) {
            var typeImg = "";

            switch (typeId) {
                case 1:
                    typeImg = "desktop-device.svg";
                    break;
                case 0:
                case 2:
                    typeImg = "tablet-device.svg";
                    break;
                case 3:
                    typeImg = "mobile-device.svg";
                    break;
            }
            return typeImg;
        }

        return typeIcon;
    }
}());
(function () {
    angular.module('managementConsole').factory('deviceService', deviceFactory);

    function deviceFactory($http, $q, $filter, CONSTANTS) {
        var deviceService = this;
        var deviceURL = CONSTANTS.API_URL + '/devices';

        deviceService.getDeviceStatus = function () {
            var deferred = $q.defer();

            deferred.resolve([{ Id: 1, Description: 'Disabled' }, { Id: 0, Description: 'Enabled' }]);

            return deferred.promise;
        };

        deviceService.getDeviceTypes = function () {
            var deferred = $q.defer();

            $http.get(deviceURL + '/types ', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        deviceService.getDevices = function (searchCriteria) {
            var deferred = $q.defer();

            $http.post(deviceURL + '/search', searchCriteria, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        deviceService.getDeviceInfo = function (deviceId) {
            var deferred = $q.defer();

            $http.get(deviceURL + '/' + deviceId + '/details', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        deviceService.updateDevice = function (device) {
            var deferred = $q.defer();

            $http.put(deviceURL, device, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        deviceService.updateDeviceStatus = function (deviceId, isDisabled) {
            var deferred = $q.defer();

            $http.get(deviceURL + '/update-status/' + deviceId + '/' + isDisabled, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    if (response.data != null && response.data) {
                        deferred.resolve(response.data);
                    } else {
                        deferred.reject(response.data);
                    }
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        deviceService.getDevicesUsageStatistics = function (school, groupBy) {
            var deferred = $q.defer();
            var chartTitle = '';

            switch (groupBy) {
                case 1:
                    chartTitle = 'Usage by Android Version';
                    break;
                case 2:
                    chartTitle = 'Usage by Brand';
                    break;
                case 3:
                    chartTitle = 'Usage by Resolution';
                    break;
            }

            $http.get(deviceURL + '/statistics/' + (school != undefined && school != null ? school.Id : -1) + '/' + groupBy, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    var statisticsDataList = { title: chartTitle, labels: [], data: [] };

                    angular.forEach(response.data, function (value, key) {
                        statisticsDataList.labels.push(value.Name);
                        statisticsDataList.data.push(value.Value);
                    });

                    deferred.resolve(statisticsDataList);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };


        deviceService.getStatistics = function () {
            var deferred = $q.defer();


            $http.get(deviceURL + '/statistics/', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        return deviceService;
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('RoleController', RoleController);

    function RoleController($scope, $filter, toastr, roleService, userInfoService) {
        var vm = this;
        vm.roles = [];
        vm.selectedRole = 0;
        vm.permissions = [];

        vm.initModule = function () {
            vm.getRoles();
        };

        vm.resetRoleForm = function () {
            vm.newRole = null;
            $scope.roleForm.$setPristine();
            $scope.roleForm.$setUntouched();
        };

        vm.getRoles = function () {
            roleService.getRoles().then(function (response) {
                var currentRole = userInfoService.getItem('role');

                var currentRoleMatch = response.filter(function (obj) {
                   return obj.Name == currentRole;
                })
                var isSdpRole = currentRoleMatch[0].IsSDPRole;

                vm.roles = response.filter(function (obj) {
                    return obj.IsSDPRole == isSdpRole;
                })
                vm.getPermissions();
            },
            function (error) {
                toastr.error('getRoles: ' + error);
            });
        };

        vm.getPermissions = function () {
            roleService.getPermissions().then(function (response) {
                vm.permissions = response;

                if (vm.roles.length > 0) {
                    vm.selectedRole = vm.roles[0];
                }
            },
            function (error) {
                toastr.error('getPermissions: ' + error);
            });
        };

        vm.initModule();
    }
}());
(function () {
    angular.module('managementConsole').factory('roleService', roleFactory);

    function roleFactory($http, $q, $filter, CONSTANTS) {
        var roleService = this;
        var roleURL = CONSTANTS.API_URL + '/roles';

        roleService.getRoles = function () {
            var deferred = $q.defer();

            $http.get(roleURL, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        roleService.getCMSRoles = function () {
            var deferred = $q.defer();

            $http.get(roleURL + '/cms', { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        roleService.getPermissions = function () {
            var deferred = $q.defer();

            $http.get(roleURL + '/permissions', { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        roleService.addRole = function (role) {
            var deferred = $q.defer();

            $http.post(roleURL, role, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        roleService.saveRolePermissions = function (rolePermissions) {
            var deferred = $q.defer();

            $http.post(roleURL + '/rolePermissions', rolePermissions, { headers: { 'Content-Type': 'application/json' } })
              .then(function (response) {
                  deferred.resolve(response.data);
              }).catch(function (response) {
                  deferred.reject(response);
              });

            return deferred.promise;
        };

        roleService.roleHasPermission = function (role, permissionId) {
            return role.RolePermissions.includes(permissionId);
        }
        
        return roleService;
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('UserController', UserController);

    function UserController($scope, $state, $filter, $q, toastr, userService, roleService, subjectService, userRolesConstant, userInfoService) {
        var vm = this;

        vm.loggedInUserRoleId = userInfoService.getUserRoleId();           
        // Hold all advanced search controls get requests
        vm.searchRelatedRequestsList = [];

        vm.maxItemsPerLoad = 4;

        vm.isUserEntryVisible = false;
        vm.isSavingUser = false;

        vm.isSearching = false;
        vm.showKeywords = false;
        vm.noDataFound = false;

        vm.isAdvancedSearch = false;
        vm.searchTypeDescription = '';
        vm.searchCriteria = { Take: vm.maxItemsPerLoad };
        vm.levelsBackup = null;
        vm.searchCriteriaBackup = { Take: vm.maxItemsPerLoad };
        vm.searchPredefinedKeywords = ['Grade 01', 'Grade 02', 'Grade 03', 'Grade 04', 'Grade 05', 'Grade 06', 'Grade 07', 'Grade 08', 'Grade 09', 'Grade 10', 'Grade 11', 'Grade 12', 'Grade 13', 'Grade 98', 'Grade K1', 'Grade K2', 'Grade K3', 'Grade NU', 'Level J', 'Level G', 'Level D', 'Level A', 'Level B', 'Level C', 'Level E', 'Level F', 'Level H', 'Level I', 'Level K', 'Level L', 'Level M', 'Level N', 'Level O', 'Level P', 'Level Q', 'Level S', 'Level X', 'Level R'];

        vm.genders = [];
        vm.roles = [];
        vm.cmsAvailableRoles = [];
        vm.userStatus = [];
        vm.userSchools = [];
        vm.selectedSchool = null;

        vm.rolesWithUsers = [];
        vm.isSDPRole = true;
        vm.canLogInToMobileBookshelf = true;

        vm.user = {};
        vm.user.AllowedDevices = 1;
        vm.ShowSubjectAssignmentSection = false;
        vm.availableSubjects = [];
        vm.userRolesConstant = userRolesConstant;
        
        vm.initModule = function () {
            vm.getGenders();
            vm.getCMSRoles();
            vm.getSubjects();
            vm.searchRelatedRequestsList.push(vm.getAllRoles());
            vm.searchRelatedRequestsList.push(vm.getAllUserStatus());
            vm.searchRelatedRequestsList.push(vm.getUserSchools());

            if ($state.params) {
                if ($state.params.userSearchResults) {
                    vm.rolesWithUsers = $state.params.userSearchResults;
                }
                if ($state.params.searchCriteriaBackup) {
                    var searchCriteriaBackupHolder = $state.params.searchCriteriaBackup;
                    vm.searchTypeDescription = vm.getSearchTypeDescription(searchCriteriaBackupHolder.IsAdvancedSearch);

                    // When all data is loaded in advanced search dropdowns set the selected criteria
                    $q.all(vm.searchRelatedRequestsList).then(function () {
                        vm.searchCriteria = searchCriteriaBackupHolder;
                        vm.searchCriteriaBackup = searchCriteriaBackupHolder;

                        if (vm.searchCriteria.Keyword) {
                            vm.showKeywords = true;
                        } else {
                            vm.levelsBackup = searchCriteriaBackupHolder.Levels;
                        }
                    });
                }

                $state.params = null;
            }
            else {
                vm.resetSearch('all');
            }
        };

        vm.resetNewUserForm = function () {
            vm.user = {};
            vm.canLogInToMobileBookshelf = true;
            $scope.newUserForm.$setPristine();
            $scope.newUserForm.$setUntouched();
        };

        vm.resetSearch = function (resetType) {
            if (resetType == 'all') {
                vm.searchCriteria = { Take: vm.maxItemsPerLoad };
            }
            if (resetType == 'advanced') {
                var keywordInput = vm.searchCriteria.Keyword;
                var keywordsList = vm.searchCriteria.Keywords;

                $('[title="Role"]').find('.bs-searchbox>input').val('');
                $('[title="Status"]').find('.bs-searchbox>input').val('');
                $('[title="School"]').find('.bs-searchbox>input').val('');
                $('[title="Grade"]').find('.bs-searchbox>input').val('');
                $('[title="Section"]').find('.bs-searchbox>input').val('');
                $('.not-match').removeClass('not-match');

                vm.searchCriteria = { Take: vm.maxItemsPerLoad };
                vm.searchCriteria.Keyword = keywordInput;
                vm.searchCriteria.Keywords = keywordsList;
            }
            if (resetType == 'keyword') {
                vm.searchCriteria.Keyword = '';
                vm.searchCriteria.Keywords = [];
            }
        };

        vm.showHideAdvancedSearch = function () {
            vm.isSearchBoxVisible = !vm.isSearchBoxVisible;
        };

        vm.getGenders = function () {
            userService.getGenders().then(function (response) {
                vm.genders = response;
            });
        };

        vm.getCMSRoles = function () {
            userService.getCMSRoles().then(
                function (response) {
                    vm.cmsAvailableRoles = response;                    
                });
        };

        vm.getAllRoles = function () {
            var promise = userService.getRolesOnly();

            promise.then(function (response) {
                vm.roles = response;
            });

            return promise;
        };

        vm.getAllUserStatus = function () {
            var promise = userService.getAllUserStatus();

            promise.then(function (response) {
                vm.userStatus = response;
            });

            return promise;
        };

        vm.getUserSchools = function () {
            return userService.getUserSchoolsData().then(
                function (schoolsData) {
                    vm.userSchools = schoolsData;
                },
                function (error) {
                    console.error(error);
                });
        };

        vm.getUsers = function (isAdvancedSearch) {
            vm.isSearching = true;
            vm.showKeywords = false;
            vm.isAdvancedSearch = isAdvancedSearch;

            vm.searchCriteria.Skip = 0;
            vm.searchCriteria.IsAdvancedSearch = isAdvancedSearch;
            if (!vm.isSearchBoxVisible) {
                vm.resetSearch('advanced');

                if (!vm.searchCriteria.Keywords) {
                    vm.searchCriteria.Keywords = [];
                }
            }
            else {
                vm.resetSearch('keyword');
            }

            vm.searchCriteriaBackup = vm.searchCriteria;

            userService.getUsers(vm.isAdvancedSearch, vm.searchCriteria, vm.maxItemsPerLoad).then(function (response) {
                if (response !== undefined && response.roles !== undefined) {
                    vm.rolesWithUsers = response.roles;

                    vm.searchCriteria.Keywords = response.keywords;
                    vm.noDataFound = vm.rolesWithUsers.length > 0 ? false : true;
                    vm.showKeywords = true;
                }
                else {
                    vm.rolesWithUsers = [];
                    vm.noDataFound = true;
                }
                vm.searchTypeDescription = vm.getSearchTypeDescription(vm.searchCriteria.IsAdvancedSearch);
                vm.isSearching = false;
            },
                function (error) {
                    vm.isSearching = false;
                    vm.noDataFound = true;
                    vm.showKeywords = true;
                });
        };

        vm.getMoreUsersPerRole = function (selectedRole) {
            vm.isSearching = true;

            vm.searchCriteriaBackup.RoleId = selectedRole.id;
            vm.searchCriteriaBackup.Skip = selectedRole.visibleUsersItems;

            userService.getUsers(vm.isAdvancedSearch, vm.searchCriteriaBackup, vm.maxItemsPerLoad).then(function (response) {
                var role = $filter('filter')(vm.rolesWithUsers, { id: selectedRole.id }, true);
                var roleIndex = 0;
                if (role && role !== undefined && role.length && response.roles.length > 0) {
                    roleIndex = vm.rolesWithUsers.indexOf(role[0]);
                    vm.rolesWithUsers[roleIndex].users.splice(vm.rolesWithUsers[roleIndex].users.length - 1, 1);// Remove the last item that is used to identifiy if "Load More" should be visible or not
                    vm.rolesWithUsers[roleIndex].users = vm.rolesWithUsers[roleIndex].users.concat(response.roles[0].users);
                }

                selectedRole.visibleUsersItems = selectedRole.visibleUsersItems + vm.maxItemsPerLoad;

                vm.searchCriteriaBackup.RoleId = 0;
                vm.searchCriteriaBackup.Skip = 0;

                vm.isSearching = false;
            },
                function (error) {
                    vm.isSearching = false;
                });
        };

        vm.checkRoleSpecificPermissions = function (role) {
            vm.canLogInToMobileBookshelf = roleService.roleHasPermission(role, 28);
            //if (!vm.canLogInToMobileBookshelf) {
            //    vm.user.AllowedDevices = 1;
            //}
            //else {
            //    vm.user.AllowedDevices = null;
            //}
        };

        vm.addUser = function () {
            vm.isSavingUser = true;

            userService.addUser(vm.user).then(
                function () {
                    toastr.success('User created successfully');
                    vm.isSavingUser = false;
                    vm.resetNewUserForm();
                },
                function (error) {
                    toastr.error(error.data);
                    vm.isSavingUser = false;
                });
        };

        vm.getSearchTypeDescription = function (isAdvancedSearch) {
            return isAdvancedSearch ? 'Advanced search results' : 'Search results';
        };

        vm.getSubjects = function () {
            subjectService.getAllSubjects().then(
                function (subjects) {
                    vm.availableSubjects = subjects == null ? [] : subjects;
                });
        };

        vm.isSubjectSelected = function (subject) {
            var retVal = false;
            if (vm.user && vm.user.AssignedSubjects) {
                var filteredSubject = $filter('filter')(vm.user.AssignedSubjects, { Id: subject.Id }, true);
                if (filteredSubject && filteredSubject.length>0) {
                    retVal = true;
                }
            }
            return retVal;
        };

        $scope.$watch(function () { return vm.searchCriteria.RoleId; }, function () {
            if (vm.searchCriteria.RoleId === undefined || vm.searchCriteria.RoleId === null) {
                vm.isSDPRole = true;

                vm.searchCriteria.SchoolExternalId = null;
                vm.searchCriteria.SchoolName = null;

            } else {
                var role = $filter('filter')(vm.roles, { Id: vm.searchCriteria.RoleId }, true);

                if (role && role !== undefined && role.length) {
                    vm.isSDPRole = role[0].IsSDPRole;
                }
            }
        });

        $scope.$watch(function () { return vm.searchCriteria.SchoolExternalId; }, function () {
            if (vm.searchCriteria.SchoolExternalId) {
                var filteredSchools = $filter('filter')(vm.userSchools, { SchoolSDPId: vm.searchCriteria.SchoolExternalId }, true);
                if (filteredSchools && filteredSchools.length > 0) {
                    vm.selectedSchool = filteredSchools[0];
                }
            }
            else {
                vm.selectedSchool = null;
            }
            vm.searchCriteria.Levels = [];
            if (vm.levelsBackup) {
                vm.searchCriteria.Levels = vm.levelsBackup;
                vm.levelsBackup = null;
            }
        });

        $scope.$watch(
            function () { return vm.user.RoleId; },
            function () {
                if (vm.user && vm.user.RoleId) {
                    var selectedRole = $filter('filter')(vm.cmsAvailableRoles, { Id: vm.user.RoleId }, true);
                    if (selectedRole != null && selectedRole.length > 0) {
                        vm.ShowSubjectAssignmentSection = selectedRole[0].IsCategorizedBySubject;
                        vm.user.HasAllSubjects = false;
                    }
                } else {
                    vm.ShowSubjectAssignmentSection = false;
                    vm.user.HasAllSubjects = null;
                    vm.user.AssignedSubjects = [];
                }
            });

        $scope.$watch(
            function () { return vm.user.AllowedDevices; },
            function () {
                if (vm.user.AllowedDevices == null) {
                    vm.user.AllowedDevices = 0;
                }
            });

        $scope.$watch(
            function () { return vm.user.HasAllSubjects; },
            function () {
                if (vm.user && vm.user.HasAllSubjects) {
                    vm.user.AssignedSubjects = vm.availableSubjects;
                }
            });

        vm.initModule();
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole').controller('UserDetailsController', UserDetailsController);

    function UserDetailsController($rootScope, $scope, $state, $filter, $timeout, $uibModal, uiGridConstants, toastr, userService, roleService, managePasswordService, commonHelperService, subjectService) {
        var vm = this;

        vm.isSavingUser = false;
        vm.userId = 0;
        vm.user = {};
        vm.userSearchResults = null;
        vm.searchCriteriaBackup = null;
        vm.isUserNameAvailable = false;
        vm.roles = [];
        vm.userPairedDevices = [];
        vm.isLoadingPairedDevices = false;
        vm.userBooksStatistics = null;
        vm.isLoadingUserBooksStatistics = false;
        vm.canLogInToMobileBookshelf = true;


        vm.addUserFieldsRequired = $rootScope.checkForPermission('AddUser');
        vm.manageDevicePermission = $rootScope.checkForPermission('ManageUserDevice');

        vm.ShowSubjectAssignmentSection = false;
        vm.availableSubjects = [];

        vm.initModule = function () {
            $scope.devicesGridOptions = {
                enableFiltering: false,
                rowTemplate: getRowTemplate(),
                enableColumnMenus: false,
                columnDefs: [
                    {
                        field: 'Id',
                        displayName: ' ',
                        cellTemplate: '<div eks-icon class="action-warning-svg-icon" ng-click="grid.appScope.askRemovePairedDevice(row.entity.Id)"></div>',
                        width: 50,
                        visible: $rootScope.checkForPermission('ManageUserDevice')
                    },
                    { name: 'Name' },
                    //{ name: 'MacAddress', displayName: 'MAC Address' },
                    { name: 'UUID', displayName: 'UUID' },
                    { name: 'LastLogin', cellFilter: 'date:\'MMMM dd, yyyy - hh:mm a\'' },
                    { name: 'AppVersion', displayName: 'Downloaded App Version' }
                ],
                onRegisterApi: function (gridApi) {
                    $scope.gridApi = gridApi;
                }
            };
            if ($state.params) {
                if ($state.params.userId) {
                    vm.userId = $state.params.userId;
                    vm.initData();
                }
                if ($state.params.userSearchResults) {
                    vm.userSearchResults = $state.params.userSearchResults;
                }
                if ($state.params.searchCriteriaBackup) {
                    vm.searchCriteriaBackup = $state.params.searchCriteriaBackup;
                }
            }
        };

        vm.initData = function () {
            userService.getRolesOnly().then(function (response) {
                vm.roles = response;
                subjectService.getAllSubjects().then(
                    function (subjects) {
                        vm.availableSubjects = subjects == null ? [] : subjects;
                        vm.getUserById();
                    });
            });
        };

        vm.getUserById = function () {
            userService.getUserById(vm.userId).then(function (response) {
                vm.user = response;
                vm.getPairedDevices();
                userService.getUserDownloads(vm.userId)
                    .then(function (res) {
                        vm.userDownloads = res;
                        console.log(res);
                    }, function (err) {
                        console.log(err);
                    });

            },
                function (error) {
                    toastr.error('getUserById: ' + error);
                });
        };

        vm.getPairedDevices = function () {
            vm.isLoadingPairedDevices = true;
            userService.getPairedDevices(vm.user.Id).then(function (response) {

                //Fix wrong time format
                for (var i = 0; i < response.length; i++) {
                    var device = response[i];
                    if (device.FirstLogin) {
                        device.FirstLogin = commonHelperService.transformDateToLocalTime(device.FirstLogin);
                    }

                    if (device.LastLogin) {
                        device.LastLogin = commonHelperService.transformDateToLocalTime(device.LastLogin);
                    }
                }

                vm.userPairedDevices = response;

                $scope.devicesGridOptions.data = vm.userPairedDevices;

                vm.isLoadingPairedDevices = false;
            },
                function (error) {
                    vm.isLoadingPairedDevices = false;
                    toastr.error('getPairedDevices: ' + error);
                });
        };

        vm.getUserNameAvailability = function () {
            if (vm.user.Username.trim() != '') {
                userService.getUserNameAvailability(vm.user.Id, vm.user.Username).then(function (response) {
                    vm.isUserNameAvailable = true;
                },
                    function (error) {
                        vm.isUserNameAvailable = false;
                        toastr.error(vm.user.Username + ' is not available');
                    });
            }
        };

        vm.checkRoleSpecificPermissions = function (role) {
            vm.canLogInToMobileBookshelf = roleService.roleHasPermission(role, 28);
            if (!vm.canLogInToMobileBookshelf) {
                vm.user.AllowedDevices = 1;
            }
        };

        $scope.askRemovePairedDevice = function (deviceId) {
            vm.showWarning("removeUserDevice", { ConfirmAction: vm.removePairedDevice, ConfirmActionParams: { UserId: vm.user.Id, deviceId: deviceId } });
        };

        vm.removePairedDevice = function (params) {
            vm.isSavingUser = true;

            userService.removePairedDevice(params.UserId, params.deviceId).then(function (response) {
                var deviceIndex;
                var userDevice = $filter('filter')(vm.userPairedDevices, { Id: params.deviceId }, true);
                if (userDevice && userDevice !== undefined && userDevice.length) {
                    deviceIndex = vm.userPairedDevices.indexOf(userDevice[0]);
                    vm.userPairedDevices.splice(deviceIndex, 1);
                    vm.hideWarning();
                }

                vm.isSavingUser = false;
                toastr.success('Paired device removed successfully');
            },
                function (error) {
                    vm.isSavingUser = false;
                    toastr.error('removePairedDevice: ' + error);
                });
        };

        vm.saveUser = function () {
            $scope.userInfoForm.$setSubmitted();
            if ($scope.userInfoForm.$valid || (vm.user.IsSDPUser && vm.manageDevicePermission)) {
                vm.updateUser();
            }
        };

        vm.updateUser = function () {

            vm.isSavingUser = true;

            if (!vm.addUserFieldsRequired && vm.manageDevicePermission) {
                userService.updateUserDevices(vm.user)
                    .then(function (res) {
                        vm.isSavingUser = false;
                        toastr.success('Devices updated successfully');
                    }, function (err) {
                        vm.isSavingUser = false;
                        console.log(err.data);
                    });
                return;
            }

            userService.updateUser(vm.user).then(function (response) {
                var filteredUser = null;// Used to break the forEach iteration once the user is found in list.

                if (!vm.user.IsSDPUser) {
                    angular.forEach(vm.userSearchResults, function (value, key) {
                        if (filteredUser != null) {
                            return;
                        }
                        var user = $filter('filter')(vm.userSearchResults[key].users, { Id: parseInt(vm.user.Id) }, true);
                        var userIndex = 0;
                        if (user && user !== undefined && user.length) {
                            userIndex = vm.userSearchResults[key].users.indexOf(user[0]);

                            vm.userSearchResults[key].users[userIndex].FirstName = vm.user.FirstName;
                            vm.userSearchResults[key].users[userIndex].MiddleName = vm.user.MiddleName;
                            vm.userSearchResults[key].users[userIndex].LastName = vm.user.LastName;

                            filteredUser = vm.userSearchResults[key].users[userIndex];

                            if (filteredUser.RoleId !== vm.user.RoleId) {
                                vm.userSearchResults[key].users.splice(userIndex, 1);
                            }
                        }
                    });

                    // If user role is changed then move it to the correspondant role object
                    if (filteredUser != null && filteredUser.RoleId !== vm.user.RoleId) {
                        var newRole = $filter('filter')(vm.roles, { Id: parseInt(vm.user.RoleId) }, true);

                        filteredUser.RoleId = vm.user.RoleId;
                        if (newRole && newRole !== undefined && newRole.length) {
                            filteredUser.RoleName = newRole[0].Name;
                        }

                        var role = $filter('filter')(vm.userSearchResults, { id: parseInt(filteredUser.RoleId) }, true);
                        var roleIndex = 0;
                        if (role && role !== undefined && role.length) {
                            roleIndex = vm.userSearchResults.indexOf(role[0]);
                            vm.userSearchResults[roleIndex].users.push(filteredUser);
                        }
                        else {
                            // If the role is not existing in list of results, and the search criteria is not set to specific role then create a new one
                            if (vm.searchCriteriaBackup.roleId === 0 && newRole && newRole !== undefined && newRole.length) {
                                vm.userSearchResults.push({
                                    id: newRole[0].Id,
                                    name: newRole[0].Name,
                                    users: [],
                                    visibleUsersItems: 4
                                });

                                vm.userSearchResults[vm.userSearchResults.length - 1].users.push(filteredUser);
                            }
                        }
                    }
                }

                vm.isSavingUser = false;
                toastr.success('User saved successfully');
            },
                function (error) {
                    vm.isSavingUser = false;
                    toastr.error('updateUser: ' + error.data);
                });
        };

        vm.askChangeUserStatus = function () {
            vm.showWarning("changeUserStatus", { ConfirmAction: vm.disableUser, ConfirmActionParams: null });
        };
        vm.disableUser = function () { vm.changeUserStatus(1); };

        vm.changeUserStatus = function (status) {
            vm.isSavingUser = true;
            vm.user.IsDisabled = status;

            userService.updateUser(vm.user).then(function (response) {

                vm.user.Status = status;

                // Update the search result to reflect the change when the user is back to search search screen
                var userIndex = 0;

                angular.forEach(vm.userSearchResults, function (value, key) {
                    var user = $filter('filter')(vm.userSearchResults[key].users, { Id: parseInt(vm.user.Id) }, true);

                    if (user && user !== undefined && user.length) {
                        userIndex = vm.userSearchResults[key].users.indexOf(user[0]);
                        vm.userSearchResults[key].users[userIndex].IsDisabled = status;
                    }
                });

                vm.isSavingUser = false;
                toastr.success('User is ' + (status ? 'disabled' : 'enabled') + ' sucessfully');
            },
                function (error) {
                    vm.isSavingUser = false;
                    toastr.error('updateUser: ' + error);
                });
        };

        vm.showWarning = function (action, params) {
            var templateURL = "";
            switch (action) {
                case "changeUserStatus":
                    templateURL = 'app/management/user/partials/_disableMessage.html';
                    break;
                case "removeUserDevice":
                    templateURL = 'app/management/user/partials/_pairedDeviceMessage.html';
                    break;
            }

            $rootScope.modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-message-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: templateURL,
                controller: 'ModalController as vm',
                resolve: {
                    params: params
                }
            });
        };

        vm.hideWarning = function () {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }
        };

        vm.resetPassword = function (username) {
            managePasswordService.forgotPassword(username).then(
                function (res) {
                    toastr.success("Reset password email sent to the user");
                },
                function (err) {
                    toastr.error("An error occurred. Please try again.");
                }
            );
        };

        vm.isSubjectSelected = function (subject) {
            var retVal = false;
            if (vm.user && vm.user.AssignedSubjects) {
                var filteredSubject = $filter('filter')(vm.user.AssignedSubjects, { Id: subject.Id }, true);
                if (filteredSubject && filteredSubject.length > 0) {
                    retVal = true;
                }
            }
            return retVal;
        };

        $scope.$watch(function () { return vm.user.RoleId; }, function () {
            var role = $filter('filter')(vm.roles, { Id: vm.user.RoleId }, true);
            if (role && role !== undefined && role.length > 0) {
                vm.checkRoleSpecificPermissions(role[0]);
                vm.ShowSubjectAssignmentSection = role[0].IsCategorizedBySubject;
                if (!role[0].IsCategorizedBySubject) {
                    vm.user.AssignedSubjects = [];
                    vm.user.HasAllSubjects = null;
                }
            }
        });

        $scope.$watch(
            function () { return vm.user.HasAllSubjects; },
            function () {
                if (vm.user && vm.user.HasAllSubjects) {
                    vm.user.AssignedSubjects = vm.availableSubjects;
                }
            });


        $scope.$watch(
            function () { return vm.user.AllowedDevices; },
            function () {
                if (vm.user.AllowedDevices == null) {
                    vm.user.AllowedDevices = 0;
                }
            });

        $scope.rowDblClick = function (row) {
            window.location.href = window.location.origin + "/MC/ManagementConsole/device-details/" + row.entity.Id;
        };
        vm.initModule();

        function getRowTemplate() {
            return '<div ng-dblclick="grid.appScope.rowDblClick(row)" style="cursor:pointer;" >' +
                '  <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name"  class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }"  ui-grid-cell></div>' +
                '</div>';
        }
    }
}());
(function(){
    'use strict';

    angular.module('managementConsole').filter('avatarFilter', avatarFilter);

    function avatarFilter() {
        function avatar(gender) {
            var avatarImg = "";

            switch (gender) {
                case 0:
                    avatarImg = "default-avatar.svg";
                    break;
                case 1:
                    avatarImg = "female-avatar.svg";
                    break;
                case 2:
                    avatarImg = "male-avatar.svg";
                    break;
            }
            return avatarImg;
        }

        return avatar;
    }
}());
angular.module('managementConsole')

    .directive('statusConnected', function () {
        return {
            restrict: 'E',
            template: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"width="24.691px" height="18.431px" viewBox="670.379 40.535 24.691 18.431" enable-background="new 670.379 40.535 24.691 18.431"xml:space="preserve"><g><path fill="#016836" d="M682.749,47.778c-0.504,0-1.01,0.192-1.395,0.578c-0.77,0.77-0.77,2.019,0,2.789c0.385,0.385,0.891,0.577,1.395,0.577c0.506,0,1.01-0.192,1.395-0.577c0.771-0.771,0.77-2.02,0-2.789C683.759,47.971,683.255,47.778,682.749,47.778L682.749,47.778z"/><g><path fill="#016836" d="M690.028,58.966c-0.275,0-0.549-0.113-0.748-0.335c-0.367-0.412-0.33-1.044,0.082-1.412c2.246-2.001,3.484-4.652,3.484-7.467s-1.238-5.468-3.486-7.47c-0.412-0.368-0.449-1-0.082-1.412c0.369-0.412,1.002-0.446,1.412-0.082c2.68,2.388,4.156,5.571,4.156,8.964s-1.477,6.574-4.154,8.961C690.503,58.882,690.265,58.966,690.028,58.966L690.028,58.966z"/></g><g><path fill="#016836" d="M686.231,55.708c-0.275,0-0.549-0.113-0.746-0.335c-0.369-0.412-0.332-1.044,0.08-1.411c1.27-1.133,1.969-2.627,1.969-4.21s-0.699-3.079-1.969-4.212c-0.414-0.367-0.449-0.999-0.082-1.411c0.369-0.413,1.002-0.447,1.412-0.081c1.701,1.517,2.639,3.543,2.639,5.704s-0.936,4.186-2.639,5.702C686.706,55.624,686.468,55.708,686.231,55.708L686.231,55.708z"/></g><g><path fill="#016836" d="M675.419,58.966c-0.236,0-0.473-0.084-0.664-0.254c-2.678-2.386-4.152-5.567-4.152-8.96s1.477-6.576,4.154-8.963c0.412-0.367,1.043-0.332,1.412,0.081c0.367,0.412,0.332,1.044-0.082,1.411c-2.246,2.003-3.484,4.656-3.484,7.471s1.238,5.466,3.482,7.468c0.414,0.367,0.449,0.999,0.082,1.411C675.97,58.853,675.694,58.966,675.419,58.966L675.419,58.966z"/></g><g><path fill="#016836" d="M679.218,55.708c-0.236,0-0.475-0.084-0.664-0.254c-1.703-1.517-2.639-3.542-2.639-5.702c0-2.161,0.938-4.188,2.641-5.705c0.41-0.365,1.041-0.331,1.412,0.082c0.367,0.412,0.33,1.044-0.082,1.412c-1.271,1.132-1.971,2.628-1.971,4.211s0.699,3.077,1.969,4.21c0.412,0.367,0.449,0.999,0.08,1.411C679.767,55.595,679.493,55.708,679.218,55.708L679.218,55.708z"/></g></g></svg>',
            replace: true,
            scope: {
                svgGreyed:'='
            }
        };
    });
angular.module('managementConsole')

    .directive('statusDisabled', function () {
        return {
            restrict: 'E',
            template: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"width="25px" height="25px" viewBox="752.125 40.278 25 25" enable-background="new 752.125 40.278 25 25" xml:space="preserve"><path fill="#F7A291" d="M764.625,40.278c-6.903,0-12.5,5.597-12.5,12.5s5.597,12.5,12.5,12.5s12.5-5.597,12.5-12.5S771.528,40.278,764.625,40.278z M764.625,44.075c1.666,0,3.221,0.446,4.559,1.21l-11.547,12.968c-1.253-1.495-2.007-3.399-2.007-5.475C755.63,47.972,759.657,44.075,764.625,44.075z M764.625,61.481c-1.666,0-3.221-0.446-4.559-1.21l11.547-12.968c1.253,1.495,2.007,3.399,2.007,5.475C773.62,57.585,769.593,61.481,764.625,61.481z"/></svg>',
            replace: true,
            scope: {
                svgGreyed:'='
            }
        };
    });
angular.module('managementConsole')

    .directive('statusDisconnected', function () {
        return {
            restrict: 'E',
            template: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"width="25px" height="25px" viewBox="711.958 40.278 25 25" enable-background="new 711.958 40.278 25 25" xml:space="preserve"><g><path fill="#80C6EA" d="M724.458,40.278c-6.903,0-12.5,5.597-12.5,12.5s5.597,12.5,12.5,12.5s12.5-5.597,12.5-12.5S731.361,40.278,724.458,40.278z M724.458,61.481c-4.968,0-8.995-3.896-8.995-8.703s4.027-8.703,8.995-8.703s8.995,3.896,8.995,8.703S729.426,61.481,724.458,61.481z"/><circle fill="#80C6EA" cx="724.458" cy="52.778" r="3.388"/></g></svg>',
            replace: true,
            scope: {
                svgGreyed:'='
            }
        };
    });
(function () {
    'use strict';

    angular.module('managementConsole').directive('user', user);

    function user($timeout, $state, userRolesConstant) {
        function link(scope, elem, attrs, ctrl) {
            scope.userLevel = scope.user.Levels.join(", ");
        }
        function UserController($scope) {

            var vm = this;
            vm.userRolesConstant = userRolesConstant;
            vm.deleteUser = function () {
                if ($scope.delete) {
                    $scope.delete();
                }
            }

            vm.userLevel = "";
        }
        return {
            restrict: 'E',
            replace: true,
            scope: {
                user: '=info',
                roleId: '=roleId',
                delete: '&?'
            },
            link: link,
            controller: UserController,
            controllerAs: 'userCtrl',
            templateUrl: 'app/management/user/partials/_user.html'
        };
    }

}());
(function () {
    'use strict';

    angular.module('managementConsole').directive('userEmailAvailableValidator', userEmailAvailableValidator);

    function userEmailAvailableValidator($q, $timeout, toastr) {
        function link(scope, elem, attrs, ctrl) {
            ctrl.$validators.emailUnique = function (modelValue, viewValue) {
                if (!modelValue) {
                    ctrl.$setValidity('emailUnique', true);
                    return true;
                }

                var localUserId = scope.userId || -1;
                                
                scope.emailCtrl.isEmailUnique(localUserId, ctrl.$viewValue).then(function (response) {
                    $timeout(function () {
                        ctrl.$setValidity('emailUnique', response);
                        return response;
                    },1000);
                },
                function (error) { 
                    ctrl.$setValidity('emailUnique', false);
                    return false;
                });

                // Set valid to true until api check has been done
                ctrl.$setValidity('emailUnique', true);
                return true;
            }
        }

        function EmailController($q, toastr, userService) {
            var vm = this;

            vm.isEmailUnique = function (userId, email) {
                var deferred = $q.defer();
                if (email.trim() != '') {
                    userService.getEmailAvailability(userId, email).then(function (response) {
                        if (response !== undefined) {
                            deferred.resolve(response);
                        }
                        else {
                            deferred.reject(false);
                        }
                    },
                    function (error) {
                        deferred.reject(error);
                    });
                }

                return deferred.promise;
            };

        }

        return {
            require: 'ngModel',
            scope:{
                userId: '@?'
            },
            link: link,
            controller: EmailController,
            controllerAs: 'emailCtrl'
        };
    }

}());
(function () {
    'use strict';

    angular.module('managementConsole').directive('usernameAvailableValidator', usernameAvailableValidator);

    function usernameAvailableValidator($q, $timeout, toastr) {
        function link(scope, elem, attrs, ctrl) {
            ctrl.$validators.usernameUnique = function (modelValue, viewValue) {
                if (!modelValue) {
                    ctrl.$setValidity('usernameUnique', true);
                    return true;
                }

                var localUserId = scope.userId || -1;

                scope.usernameCtrl.isUsernameUnique(localUserId, ctrl.$viewValue).then(function (response) {
                    $timeout(function () {
                        ctrl.$setValidity('usernameUnique', response);
                        return response;
                    }, 1000);
                },
                function (error) {
                    ctrl.$setValidity('usernameUnique', false);
                    return false;
                });

                // Set valid to true until api check has been done
                ctrl.$setValidity('usernameUnique', true);
                return true;
            }
        }

        function UsernameController($q, toastr, userService) {
            var vm = this;

            vm.isUsernameUnique = function (userId, username) {
                var deferred = $q.defer();
                if (username.trim() != '') {
                    userService.getUserNameAvailability(userId, username).then(function (response) {
                        if (response !== undefined) {
                            deferred.resolve(response);
                        }
                        else {
                            deferred.reject(false);
                        }
                    },
                    function (error) {
                        deferred.reject(error);
                    });
                }

                return deferred.promise;
            };

        }

        return {
            require: 'ngModel',
            scope: {
                userId: '@?'
            },
            link: link,
            controller: UsernameController,
            controllerAs: 'usernameCtrl'
        };
    }

}());
(function () {
    angular.module('managementConsole').factory('userService', userFactory);

    function userFactory($http, $q, $filter, CONSTANTS, roleService) {
        var userService = this;
        var userURL = CONSTANTS.API_URL + '/users',
            rolesURL = CONSTANTS.API_URL + '/roles/corporate-roles-names',
            schoolsURL = CONSTANTS.API_URL + '/schools';

        userService.getMyInfo = function () {
            var deferred = $q.defer();

            $http.get(userURL + '/me', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getGenders = function () {
            var deferred = $q.defer();

            deferred.resolve([{ Id: 1, Description: 'Female' }, { Id: 2, Description: 'Male' }]);

            return deferred.promise;
        };

        userService.getCMSRoles = function () {
            var deferred = $q.defer();

            roleService.getCMSRoles().then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getAllRoles = function () {
            var deferred = $q.defer();

            roleService.getRoles().then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getAllUserStatus = function () {
            var deferred = $q.defer();

            deferred.resolve([{ Id: 1, Description: 'Disabled' }, { Id: 0, Description: 'Enabled' }]);

            return deferred.promise;
        };

        userService.getUserRelatedSchoolsGradesSections = function () {
            var deferred = $q.defer();

            $http.get(userURL + '/schools', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getUserSchoolsData = function () {
            var deferred = $q.defer();

            $http.get(schoolsURL + '/schools-by-user', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getUsers = function (isAdvancedSearch, searchCriteria, visibleUsersItems) {
            var deferred = $q.defer();
            var searchMethod = isAdvancedSearch ? 'advanced-search' : 'search';
            $http.post(userURL + '/' + searchMethod, searchCriteria, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    var usersByRole = [];

                    if (response !== undefined) {
                        if (response.data.Users === undefined || response.data.Users.length === 0) {
                            response.data.Users = [];
                        }
                        else {
                            // Group users by role property (id and name)
                            usersByRole = response.data.Users.groupUsersBy({ id: 'RoleId', name: 'RoleName' }, visibleUsersItems);
                        }
                    }

                    deferred.resolve({ roles: usersByRole, keywords: response.data.Keywords });
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getPairedDevices = function (userId) {
            var deferred = $q.defer();

            $http.get(userURL + '/' + userId + '/devices', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getUserNameAvailability = function (userId, username) {
            var deferred = $q.defer();

            $http.post(userURL + '/userNameAvailable', { 'userId': userId, 'username': username }, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    var data = JSON.parse(response.data)
                    deferred.resolve(data.isUnique);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getEmailAvailability = function (userId, email) {
            var deferred = $q.defer();

            $http.post(userURL + '/emailAddressAvailable', { 'userId': userId, 'emailAddress': email }, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    var data = JSON.parse(response.data);
                    deferred.resolve(data.isUnique);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.addUser = function (user) {
            var deferred = $q.defer();

            $http.post(userURL, user, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.updateUser = function (user) {
            var deferred = $q.defer();

            $http.put(userURL, user, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.removePairedDevice = function (userId, deviceId) {
            var deferred = $q.defer();

            $http.delete(userURL + '/' + userId + '/devices/' + deviceId, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getUserById = function (userId) {
            var deferred = $q.defer();
            $http.get(userURL + '/' + userId, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.updateUserDevices = function (user) {
            var deferred = $q.defer();
            $http.put(userURL + '/' + 'allowed-devices', user, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getUserDownloads = function (userId) {
            var deferred = $q.defer();
            $http.get(userURL + '/' + 'student-books/' + userId, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        userService.getRolesOnly = function () {
            var deferred = $q.defer();
            $http.get(rolesURL, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        };

        /**
         * Group array of user objects by given object where object consists of id and name properties description
         * @param groupByObject: object to group by ({id: id property description, name: name property description})
         * @param visibleUsersItems: number of user objects per group
         */
        Array.prototype.groupUsersBy = function (groupByObject, visibleUsersItems) {
            return this.reduce(function (usersGroups, user) {
                var propValue = user[groupByObject.name];
                var propValueAdded = false;

                // Add the user to its related group
                if (usersGroups.length > 0) {
                    angular.forEach(usersGroups, function (value, key) {
                        if (usersGroups[key].name == propValue) {
                            usersGroups[key].users.push(user);
                            propValueAdded = true;
                            return;
                        }
                    });
                }

                if (!propValueAdded) {
                    // Init the grouped results array
                    if (!usersGroups.length) {
                        usersGroups = [];
                    }

                    var users = [];
                    users.push(user);

                    usersGroups.push({ id: user[groupByObject.id], name: propValue, users: users, visibleUsersItems: visibleUsersItems });
                }

                return usersGroups;
            }, {});
        };

        return userService;
    }
}());
(function () {
    'use strict';

    angular.module('managementConsole')
        .controller('DownloadDetailsController', function () {
            var vm = this;
        });
}());

(function () {
    'use strict';

    angular.module('managementConsole')
        .controller('DownloadsListController', function () {
            var vm = this;
        });
}());

angular.module("managementConsole").run(["$templateCache", function($templateCache) {$templateCache.put("app/manage-password/change-password.html","<div class=\"header-state\">Change Password</div><div class=\"main-content\"><no-data no-data-found=\"true\" display-message=\"\'Please note that the password is case sensitive\'\"></no-data><section><div class=\"row\"><div class=\"form-group col-md-4\"><label for=\"new-pass\" class=\"required input-label\">Old Password</label> <input type=\"password\" name=\"old-pass\" ng-model=\"changePass.oldPassword\" class=\"form-control\" placeholder=\"Old Password\" input-clear=\"\"></div><div class=\"form-group col-md-4\"><label for=\"new-pass\" class=\"required input-label\">New Password</label> <input type=\"password\" name=\"new-pass\" ng-model=\"changePass.newPassword\" class=\"form-control\" placeholder=\"New Password\" input-clear=\"\"></div><div class=\"form-group col-md-4\"><label for=\"confirm-new-pass\" class=\"required input-label\">Confirm New Password</label> <input type=\"password\" name=\"confirm-new-pass\" ng-model=\"changePass.confirmPassword\" class=\"form-control\" placeholder=\"Confirm New Password\" input-clear=\"\"></div></div></section><div class=\"footer-actions text-right\"><button type=\"submit\" class=\"btn button-blue\" ng-disabled=\"!changePass.validatePass()\" ng-click=\"changePass.changePassword()\">Save</button></div></div>");
$templateCache.put("app/manage-password/res-password.html","<header class=\"app-header\"><h1>SABIS<sup class=\"sabis-registered-trademark\">&reg;</sup> Digital Platform</h1></header><div class=\"header-state\">{{managePassCtrl.title}}</div><div class=\"main-content\"><no-data no-data-found=\"true\" display-message=\"managePassCtrl.displayedMessage\"></no-data><section><div class=\"row\"><div class=\"form-group col-md-4\" ng-show=\"managePassCtrl.isValid\"><label for=\"new-pass\" class=\"required input-label\">{{managePassCtrl.newPassText}}</label> <input type=\"password\" name=\"new-pass\" ng-model=\"managePassCtrl.password\" class=\"form-control\" placeholder=\"{{managePassCtrl.newPassText}}\" input-clear=\"\"></div><div class=\"form-group col-md-4\" ng-show=\"managePassCtrl.isValid\"><label for=\"confirm-new-pass\" class=\"required input-label\">{{managePassCtrl.confirmPassText}}</label> <input type=\"password\" name=\"confirm-new-pass\" ng-model=\"managePassCtrl.confirmPassword\" class=\"form-control\" placeholder=\"{{managePassCtrl.confirmPassText}}\" input-clear=\"\"></div></div></section><div class=\"footer-actions text-right\" ng-show=\"managePassCtrl.isValid\"><button type=\"submit\" class=\"btn button-blue\" ng-disabled=\"!managePassCtrl.validatePass()\" ng-click=\"managePassCtrl.resetPassword()\">Save</button></div></div>");
$templateCache.put("app/common/partials/_searchKeywords.html","<div class=\"{{keywordClass}}\"><ul><li ng-repeat=\"keyword in keywords\" ng-class=\"{\'has-no-results\': !keyword.HasResult}\">{{keyword.Value}} <a borderless-eks-icon=\"\" href=\"#\" class=\"keyword-remove\" ng-click=\"removeKeyword(keyword.Id)\"></a></li></ul></div>");
$templateCache.put("app/common/partials/custom-grid.template.html","<style>\r\n    .headers-grid-wrapper {\r\n        color: white;\r\n        background-color: #7B6D65;\r\n        height: 30px;\r\n    }\r\n\r\n    .small-column-grid {\r\n        width: 30px;\r\n        float: left;\r\n        border-right: 1px solid white;\r\n        padding: 5px;\r\n        height: 100%;\r\n    }\r\n\r\n    .big-column-grid {\r\n        width: calc((100% - (30.1px)) / 5);\r\n        float: left;\r\n        border-right: 1px solid white;\r\n        padding: 5px;\r\n        height: 100%;\r\n        position: relative;\r\n        line-height: 19px;\r\n    }\r\n\r\n        .big-column-grid:last-child {\r\n            border-right: 0;\r\n        }\r\n\r\n    .first-grid-row {\r\n        background-color: white;\r\n    }\r\n\r\n    .second-grid-row {\r\n        background-color: rgb(248, 244, 243);\r\n    }\r\n\r\n    .data-custom-grid {\r\n        color: rgb(159, 151, 148);\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .selected-row {\r\n        background-color: rgb(0, 129, 187) !important;\r\n        color: white !important;\r\n    }\r\n\r\n    input:focus {\r\n        outline-color: transparent !important;\r\n    }\r\n\r\n    .custom-grid-wrapper {\r\n        max-height: 500px;\r\n        overflow-y: auto;\r\n        border: 1px solid #e3dbd3;\r\n    }\r\n\r\n    .arrow-grid {\r\n        position: absolute;\r\n        right: 10px;\r\n    }\r\n\r\n    .checkbox, .checkbox-white {\r\n        padding: 3px 0 0 3px !important;\r\n    }\r\n</style><div class=\"full-width text-center custom-grid-wrapper\"><div class=\"full-width headers-grid-wrapper\"><div ng-if=\"isRowSelectable==true\" class=\"inline-block small-column-grid\"><div class=\"checkbox-white\"><label><input name=\"checkAll\" type=\"checkbox\" ng-model=\"allItemsSelected.checked\" ng-change=\"toggleAllItems()\"> <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=\"inline-block big-column-grid\" ng-repeat=\"header in headerNames\" ng-click=\"changeOrderCriteria(headerValues[$index],header)\">{{header}} <img class=\"pull-right arrow-grid\" src=\"../../assets/images/upArrow.png\" ng-if=\"ascendingFilter && header==selectedHeader\"> <img class=\"pull-right arrow-grid\" src=\"../../assets/images/downArrow.png\" ng-if=\"!ascendingFilter && header==selectedHeader\"></div></div><div class=\"full-width text-center\" ng-repeat=\"book in gridData | filter:customFilter | orderBy:orderCriteria:false:orderByCriteria\" style=\"height:30px\" ng-class=\"{\'first-grid-row\':$index%2==0,\'second-grid-row\':$index%2!=0}\"><div ng-if=\"isRowSelectable\" class=\"inline-block small-column-grid data-custom-grid\" ng-class=\"[{\'selected-row\':book.isSelected},{\'checkbox-white\':book.isSelected}]\"><div class=\"checkbox\"><label><input name=\"checkRow\" type=\"checkbox\" ng-model=\"book.isSelected\" ng-change=\"onSelectionChange()\" ng-disabled=\"book.isDisabled\"> <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=\"inline-block big-column-grid data-custom-grid\" ng-class=\"{\'selected-row\':book.isSelected&&isRowSelectable}\">{{book.Identifier}}</div><div class=\"inline-block big-column-grid data-custom-grid\" ng-class=\"{\'selected-row\':book.isSelected&&isRowSelectable}\">{{book.Title}}</div><div class=\"inline-block big-column-grid data-custom-grid\" ng-class=\"{\'selected-row\':book.isSelected&&isRowSelectable}\">{{book.Subject}}</div><div class=\"inline-block big-column-grid data-custom-grid\" ng-class=\"{\'selected-row\':book.isSelected&&isRowSelectable}\">{{(book.VersionNumber) ? book.VersionNumber : book.BookVersionNumber}}</div><div class=\"inline-block big-column-grid data-custom-grid\" ng-class=\"{\'selected-row\':book.isSelected&&isRowSelectable}\">{{ book.StatusChangeDate}}</div></div></div>");
$templateCache.put("app/dashboard/partials/_approvedBooks.html","<div class=\"books-container container-book-covers\" ng-init=\"dashboardCtrl.getApprovedBooks()\"><div class=\"full-width\"><img class=\"book-cover-dashboard\" ng-repeat=\"book in dashboardCtrl.bookCovers track by $index\" http-src=\"{{dashboardCtrl.coverUrlFirstPart +book.Identifier+\'/\' +book.VersionNumber+\'/\'+ book.CoverFileName+\'/\'+book.CoverFileExtension+\'/\'+book.IsEncrypted}}\" style=\"margin-right:2%\"></div><div class=\"text-center load-more-section\"><a href=\"#\" class=\"full-width\" ng-if=\"dashboardCtrl.allBooksInTesting > dashboardCtrl.bookCovers.length\" ng-click=\"dashboardCtrl.addMoreBookCovers()\">Load More</a></div></div>");
$templateCache.put("app/dashboard/partials/_booksTesting.html","<div class=\"books-container container-book-covers\" ng-init=\"dashboardCtrl.getBooksInTesting()\"><div class=\"full-width\"><img class=\"book-cover-dashboard\" ng-repeat=\"book in dashboardCtrl.bookCovers track by $index\" http-src=\"{{dashboardCtrl.coverUrlFirstPart + book.Identifier+\'/\' +book.VersionNumber+\'/\'+ book.CoverFileName+\'/\'+book.CoverFileExtension+\'/\'+book.IsEncrypted}}\" style=\"margin-right:2%\"></div><div class=\"text-center load-more-section\"><a href=\"#\" class=\"full-width\" ng-if=\"dashboardCtrl.allBooksInTesting > dashboardCtrl.bookCovers.length\" ng-click=\"dashboardCtrl.addMoreBookCovers()\">Load More</a></div></div>");
$templateCache.put("app/dashboard/partials/_releasedBooks.html","<div class=\"books-container container-book-covers\" ng-init=\"dashboardCtrl.getReleasedBooks(0)\"><div class=\"text-left full-width\">{{dashboardCtrl.allReleases[0].name}} | {{dashboardCtrl.allReleases[0].date | date : \'MMMM dd yyyy - HH:mm a\'}}</div><div class=\"full-width\"><img class=\"book-cover-dashboard\" ng-repeat=\"book in dashboardCtrl.bookCovers track by $index\" http-src=\"{{dashboardCtrl.coverUrlFirstPart + book.Identifier+\'/\' +book.VersionNumber+\'/\'+ book.CoverFileName+\'/\'+book.CoverFileExtension+\'/\'+book.IsEncrypted}}\" style=\"margin-right:2%\"></div><div class=\"text-center load-more-section\"><a href=\"#\" class=\"full-width\" ng-if=\"dashboardCtrl.allBooksReleased > dashboardCtrl.bookCovers.length\" ng-click=\"dashboardCtrl.addMoreBookCovers()\">Load More</a></div></div>");
$templateCache.put("app/dashboard/views/dashboard.html","<div class=\"header-state\">Dashboard</div><div class=\"main-content\"><div></div><div ng-init=\"dashboardCtrl.getStatsForBooks();dashboardCtrl.getReleasedBooks(0)\"><uib-accordion close-others=\"oneAtATime\" ng-show=\"dashboardCtrl.booksStatisticsVisible\"><div style=\"position:relative\" uib-accordion-group=\"\" class=\"panel-books\" ng-click=\"dashboardCtrl.togglePanel()\" is-open=\"dashboardCtrl.booksPanelOpen\"><uib-accordion-heading class=\"white-text\"><div class=\"white-text\">Books<plus-icon class=\"pull-right\" ng-show=\"!dashboardCtrl.booksPanelOpen\"></plus-icon><minus-icon class=\"pull-right\" ng-show=\"dashboardCtrl.booksPanelOpen\"></minus-icon></div></uib-accordion-heading><div class=\"row\" style=\"text-align:center\"><div class=\"inline-block col-xs-3 col-sm-3 grey-background-books width-31-percent\" ng-show=\"dashboardCtrl.pendingBooksVisible\" ng-click=\"dashboardCtrl.setActiveTab(\'mainAuth.dashboard.booksTesting\')\" style=\"margin:1%;\" ui-sref=\"mainAuth.dashboard.booksTesting\" ng-class=\"{\'active-tab-books\':$state.current.name==\'mainAuth.dashboard.booksTesting\'}\"><div>TO BE TESTED</div><div class=\"orange-box\">{{dashboardCtrl.bookStats.booksInTesting}}</div></div><div class=\"inline-block col-xs-3 col-sm-3 grey-background-books width-31-percent\" ng-show=\"dashboardCtrl.approvedBooksVisible\" ng-click=\"dashboardCtrl.setActiveTab(\'mainAuth.dashboard.booksApproved\')\" style=\"margin:1%;\" ui-sref=\"mainAuth.dashboard.booksApproved\" ng-class=\"{\'active-tab-books\':$state.current.name==\'mainAuth.dashboard.booksApproved\'}\">TO BE SCHEDULED<div class=\"orange-box\">{{dashboardCtrl.bookStats.booksApproved}}</div></div><div class=\"inline-block col-xs-3 col-sm-3 grey-background-books width-31-percent\" ng-show=\"dashboardCtrl.releasedBooksVisible\" ng-click=\"dashboardCtrl.setActiveTab(\'mainAuth.dashboard.releasedBooks\')\" style=\"margin:1%;\" ui-sref=\"mainAuth.dashboard.releasedBooks\" ng-class=\"{\'active-tab-books\':$state.current.name==\'mainAuth.dashboard.releasedBooks\'}\">RECENTLY RELEASED<div class=\"orange-box\">{{dashboardCtrl.allBooksReleased}}</div></div></div><div class=\"row\" ui-view=\"\"></div></div></uib-accordion><label ng-hide=\"dashboardCtrl.booksStatisticsVisible\">Welcome to the eBook management console</label></div></div>");
$templateCache.put("app/layout/partials/_sideMenu.html","<ul class=\"cms-side-menu\"><li ng-repeat=\"menuItem in menuItems\" class=\"menu-item\" ng-show=\"menuItem.stateVisible\"><div ng-switch=\"menuItem.subTabs.length > 0\"><a ui-sref-active=\"active\" ui-sref=\"{{menuItem.stateName}}\" ng-switch-when=\"false\" ng-click=\"collapseAllSubItems()\"><div ng-include=\"menuItem.icon\"></div><span>{{menuItem.text}}</span></a> <a href=\"#\" ng-switch-when=\"true\" ng-click=\"menuItem.tabActive = !menuItem.tabActive;\" ng-class=\"{active: $state.includes(menuItem.stateName)}\"><div ng-include=\"menuItem.icon\"></div><span class=\"main-text-menu\">{{menuItem.text}}</span></a></div><ul><li ng-repeat=\"subMenuItem in menuItem.subTabs\" ng-show=\"subMenuItem.stateVisible && (menuItem.tabActive || $state.includes(menuItem.stateName))\" class=\"sub-menu-item animate-show-hide\"><a ui-sref-active=\"active\" ui-sref=\"{{subMenuItem.stateName}}\" ng-class=\"{\'active\': relatedState == subMenuItem.stateName}\"><span>{{subMenuItem.text}}</span></a></li></ul></li><li class=\"menu-item\"><a href=\"#\" ng-click=\"logout()\">Logout</a></li></ul>");
$templateCache.put("app/layout/views/_default.html","<header class=\"app-header\"><h1>SABIS<sup class=\"sabis-registered-trademark\">&reg;</sup> Digital Platform</h1></header><header class=\"sabis-app-header\"><div class=\"container\"><img src=\"/assets/images/sabis-logo.svg\" alt=\"SABIS&reg;\" title=\"SABIS&reg;\"></div></header><section class=\"app-default-content\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-6\"><h3>Welcome to the</h3><h2>SABIS<sup class=\"sabis-registered-trademark\">&reg;</sup> Digital Platform</h2><p>This dynamic platform has been designed for you to access the wide range of SABIS<sup class=\"sabis-registered-trademark\">&reg;</sup> operational and academic components, as well as useful school information.</p></div></div><div class=\"row\"><div class=\"col-md-6 login-controls\"><div ui-view=\"\"></div></div></div></div></section><footer class=\"app-footer\">&copy;{{layoutCtrl.currentYear}} SABIS<sup class=\"sabis-registered-trademark\">&reg;</sup></footer>");
$templateCache.put("app/layout/views/main.html","<div ng-if=\"layoutCtrl.isHeaderAndMenuVisible\"><header class=\"app-header\"><a href=\"#\" hamburger-icon=\"\" ng-click=\"layout.menuActive = !layout.menuActive\" class=\"app-header-menu-nav-button\" ng-class=\"{\'selected\': layout.menuActive}\"></a><hr ng-class=\"{\'nav-button-seperator-active\': layout.menuActive}\"><h1>CMS</h1></header><section class=\"container-fluid app-main-content\" ng-class=\"{\'container-sidemenu-active\': layout.menuActive}\"><div class=\"row\"><div class=\"col-xs-4 col-sm-3 col-md-2 side-container\" ng-show=\"layout.menuActive\"><nav><div class=\"first-menu-item\"><div class=\"row\"><div class=\"col-md-3 col-sm-3 col-xs-3 account-avatar-container\"><img ng-src=\"assets/images/{{layout.me.Gender | avatarFilter}}\" ng-show=\"layout.me.Gender !== undefined\" class=\"img-circle\"></div><div class=\"col-md-9 col-sm-9 col-xs-9\"><a href=\"#\" ng-click=\"layout.accountLinksVisible = !layout.accountLinksVisible\"><h2>{{layout.me.FirstName + \' \' + layout.me.LastName}} <span class=\"caret\" ng-class=\"{\'caret-active\': layout.accountLinksVisible}\"></span></h2><h3>{{layout.me.Department}}</h3></a></div></div><div class=\"row account-menu-items\" ng-show=\"layout.accountLinksVisible && layout.changePassVisible\"><div class=\"col-md-12\"><ul><li><a ui-sref=\"mainAuth.changePassword\">Change Password</a></li></ul></div></div></div><cms-side-menu menu-items=\"layout.menuItems\" logout=\"layout.logoutUser()\"></cms-side-menu></nav></div><div ui-view=\"\" class=\"col-xs-8 col-sm-9 col-md-10 main-container\" ng-class=\"{\'full-width\': !layout.menuActive }\"></div></div></section></div>");
$templateCache.put("app/management/views/management.html","<div ui-view=\"\"></div>");
$templateCache.put("app/scheduleRelease/partials/_addRelease.html","<style>\r\n    .red-border {\r\n        border: 1px solid #e53c2e !important;\r\n    }\r\n</style><div class=\"header-state\"><div><span class=\"back-link\" ng-click=\"addReleaseCtrl.navigateBack()\">{{addReleaseCtrl.currentScheduleName}}</span><breadcrumb-icon></breadcrumb-icon>{{addReleaseCtrl.releaseAction}} <a href=\"#\" eks-icon=\"\" class=\"pull-right archive-icon\" ng-click=\"addReleaseCtrl.navigateBack()\"></a></div></div><div class=\"main-content\"><div class=\"form-with-action-bar\"><section><div class=\"section-header\"><h1>Release Details</h1></div><div class=\"row\"><div class=\"col-md-4 form-group\"><label class=\"input-label\">Release Name</label> <input name=\"releaseName\" ng-class=\"{\'red-border\':addReleaseCtrl.releaseNameInvalid && (!addReleaseCtrl.releaseName ||addReleaseCtrl.releaseName.length==0)}\" class=\"form-control\" type=\"text\" ng-disabled=\"addReleaseCtrl.release.IsInactive\" ng-model=\"addReleaseCtrl.releaseName\" input-clear=\"\" maxlength=\"100\"></div><div class=\"col-md-4 form-group\"><label class=\"input-label\">Date</label><div class=\"datepicker-container\"><input type=\"text\" name=\"releaseDate\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"addReleaseCtrl.dateSelected\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"altInputFormats\" show-button-bar=\"false\" ng-disabled=\"addReleaseCtrl.release.IsInactive\" input-clear=\"\"><hr><button type=\"button\" class=\"btn button-calendar\" ng-class=\"{\'button-calendar-selected\': popup1.opened}\" ng-click=\"open1()\"><div ng-include=\"\'assets/images/date-picker.svg\'\"></div></button></div></div><div class=\"col-md-4 form-group\"><label class=\"input-label\">Time</label> <input type=\"time\" style=\"padding:6px 12px!important\" ng-class=\"{\'red-border\':addReleaseCtrl.releaseTimeInvalid && !addReleaseCtrl.time}\" class=\"form-control\" name=\"input\" ng-model=\"addReleaseCtrl.time\" placeholder=\"HH:mm\" ng-disabled=\"addReleaseCtrl.release.IsInactive\" required=\"\"></div></div></section><hr class=\"section-seperator\"><section><div ng-if=\"!addReleaseCtrl.release.IsInactive\" class=\"btn-group release-view-option\"><button type=\"button\" class=\"btn button-blue inactive-button-btngroup\" disabled=\"disabled\">Release by Schools</button> <button type=\"button\" class=\"btn button-blue\">Release By Code</button></div><div ng-if=\"!addReleaseCtrl.release.IsInactive\" class=\"form-group\"><label class=\"input-label\">Code</label> <input name=\"isbnCode\" type=\"text\" ng-model=\"addReleaseCtrl.chosenISBN\" class=\"form-control\" placeholder=\"Insert Code\" input-clear=\"\"></div><div class=\"form-group\"><label class=\"input-label\">Books</label><custom-grid grid-data=\"addReleaseCtrl.books\" chosen-filter-criteria=\"addReleaseCtrl.chosenISBN\" header-names=\"addReleaseCtrl.headerNames\" header-values=\"addReleaseCtrl.headerValues\" filter-criteria-name=\"Identifier\" is-row-selectable=\"!addReleaseCtrl.release.IsInactive\" is-disabled=\"addReleaseCtrl.books.isDisabled\"></custom-grid></div><div style=\"visibility:hidden\" ng-click=\"addReleaseCtrl.toggleAllCells();\" id=\"selectAllBooks\"></div></section><div class=\"footer-actions text-right\" ng-if=\"!addReleaseCtrl.release.IsInactive\" ng-show=\"checkForPermission(\'AddRelease\')\"><form><button class=\"btn button-blue\" ng-click=\"addReleaseCtrl.submitRelease()\">{{addReleaseCtrl.confirmAdd}}</button></form></div></div></div>");
$templateCache.put("app/scheduleRelease/partials/_editSchedule.html","<div class=\"model-content-blue\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-10\"><span class=\"modal-message-title\">Edit Schedule</span></div><div class=\"col-md-2 col-sm-2 col-xs-2 text-right\"><a borderless-eks-icon=\"\" href=\"#\" class=\"modal-close\" ng-click=\"scheduleReleaseCtrl.hideWarning()\"></a></div></div></div><form name=\"editScheduleForm\" id=\"editScheduleForm\" ng-submit=\"editScheduleForm.$valid && scheduleReleaseCtrl.updateSchedule()\" novalidate=\"\"><div class=\"modal-body\" id=\"modal-body\"><div class=\"form-group\" ng-class=\"{\'has-error\' : (editScheduleForm.$submitted || editScheduleForm.scheduleName.$touched) && editScheduleForm.scheduleName.$error.required }\"><div><label class=\"required input-label\" for=\"scheduleName\">Schedule Name</label></div><input name=\"scheduleName\" type=\"text\" id=\"scheduleNameTextBox\" ng-model=\"scheduleReleaseCtrl.scheduleToUpdate.Name\" class=\"form-control\" required=\"\" input-clear=\"\"></div><div class=\"row\"><div class=\"col-md-6 form-group\" ng-class=\"{\'has-error\' : (editScheduleForm.$submitted || editScheduleForm.startDate.$touched) && editScheduleForm.startDate.$error.required}\"><div><label class=\"required input-label\" for=\"startDate\">Start Date</label></div><div class=\"datepicker-container\"><input type=\"text\" name=\"startDate\" class=\"form-control\" uib-datepicker-popup=\"{{scheduleReleaseCtrl.format}}\" ng-model=\"scheduleReleaseCtrl.scheduleToUpdate.Start\" is-open=\"scheduleReleaseCtrl.startDateOpened.opened\" datepicker-options=\"scheduleReleaseCtrl.dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"scheduleReleaseCtrl.altInputFormats\" show-button-bar=\"false\" required=\"\" input-clear=\"\"><hr><button type=\"button\" class=\"btn button-calendar\" ng-class=\"{\'button-calendar-selected\': scheduleReleaseCtrl.startDateOpened.opened}\" ng-click=\"scheduleReleaseCtrl.openStartDate()\"><div ng-include=\"\'assets/images/date-picker.svg\'\"></div></button></div></div><div class=\"col-md-6 form-group\" ng-class=\"{\'has-error\' : (editScheduleForm.$submitted || editScheduleForm.endDate.$touched) && editScheduleForm.endDate.$error.required}\"><div><label class=\"required input-label\" for=\"endDate\">End Date</label></div><div class=\"datepicker-container\"><input type=\"text\" name=\"endDate\" class=\"form-control\" uib-datepicker-popup=\"{{scheduleReleaseCtrl.format}}\" ng-model=\"scheduleReleaseCtrl.scheduleToUpdate.End\" is-open=\"scheduleReleaseCtrl.endDateOpened.opened\" datepicker-options=\"scheduleReleaseCtrl.dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"scheduleReleaseCtrl.altInputFormats\" show-button-bar=\"false\" required=\"\" input-clear=\"\"><hr><button type=\"button\" class=\"btn button-calendar\" ng-class=\"{\'button-calendar-selected\': scheduleReleaseCtrl.endDateOpened.opened}\" ng-click=\"scheduleReleaseCtrl.openEndDate()\"><div ng-include=\"\'assets/images/date-picker.svg\'\"></div></button></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn button-blue button-left-space\" ng-disabled=\"scheduleReleaseCtrl.isSavingSchedule\">Save</button></div></form></div>");
$templateCache.put("app/scheduleRelease/partials/_release.html","<div class=\"release-box\"><h1><span class=\"box-title\">{{release.Name}}</span></h1><p>{{release.ReleaseDate | date : \'MMMM dd, yyyy - hh:mm a\'}}</p><span ng-class=\"{\'success\' : release.IsInactive, \'pending\' : !release.IsInactive}\" class=\"release-status\">{{release.IsInactive | releaseStatusName}}</span> <a view-icon=\"\" class=\"schedule-release-action release-view\" ng-if=\"period==\'past\' || release.IsInactive\" ng-click=\"navigateToRelease(release)\"></a>&nbsp; <a edit-icon=\"\" class=\"schedule-release-action release-edit\" ng-if=\"!release.IsInactive && period!=\'past\' && checkForPermission(\'AddRelease\')\" ng-class=\"{\'schedule-release-action-disabled\': release.IsInactive}\" ng-click=\"navigateToRelease(release)\"></a>&nbsp; <a delete-icon=\"\" class=\"schedule-release-action release-delete\" ng-if=\"!release.IsInactive && period!=\'past\' && checkForPermission(\'DeleteRelease\') && !disabledDelete\" ng-class=\"{\'schedule-release-action-disabled\': release.IsInactive}\" ng-click=\"deleteRelease({releaseToDelete:release})\"></a></div>");
$templateCache.put("app/scheduleRelease/partials/_schedule.html","<div class=\"schedule-box\" ng-class=\"{\'schedule-box-selected\': (scheduleSelected && scheduleSelected.Id == schedule.Id) || (preSelectedSchedule==schedule && !scheduleSelected) }\" ng-click=\"scheduleCtrl.setScheduleToSeleted()\"><h1><span class=\"box-title\">{{schedule.Name}}</span></h1><span class=\"box-info schedule-date\">{{schedule.Start | date : \'MMMM dd, yyyy\'}} - {{schedule.End | date : \'MMMM dd, yyyy\'}}</span> <span class=\"box-info schedule-date-abbr\">{{schedule.Start | date : \'MMM dd, yyyy\'}} - {{schedule.End | date : \'MMM dd, yyyy\'}}</span> <span edit-icon=\"\" ng-click=\"editSchedule($event)\" ng-if=\"scheduleCtrl.checkForPermission(\'AddRelease\')\" ng-hide=\"isArchived\" class=\"schedule-release-action schedule-edit\"></span>&nbsp; <span delete-icon=\"\" ng-click=\"deleteSchedule($event)\" ng-if=\"scheduleCtrl.checkForPermission(\'DeleteRelease\')\" ng-hide=\"isArchived\" class=\"schedule-release-action schedule-delete\"></span></div>");
$templateCache.put("app/scheduleRelease/views/releases.html","<style>\r\n    .visibility-hidden {\r\n        visibility: hidden;\r\n    }\r\n</style><section class=\"section-header\"><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-6\" ng-class=\"{\'visibility-hidden\':scheduleReleaseCtrl.periodChanged && releases.length==0 }\"><h1>Releases</h1></div><div class=\"col-md-6 col-sm-6 col-xs-6 text-right\" ng-click=\"scheduleReleaseCtrl.sendToAddRelease()\" ng-if=\"$state.params.timeSpanSelected==\'future\' && checkForPermission(\'AddRelease\')\"><a href=\"#\" class=\"content-add-button\">Add Release <i add-icon=\"\"></i></a></div></div></section><div class=\"col-md-4 col-sm-6 col-xs-12 release-box-col\" ng-repeat=\"release in releases track by $index\"><release info=\"release\" deletebtn=\"disabledDelete[$index]\" delete-release=\"deleteRelease(releaseToDelete)\"></release></div><no-data no-data-found=\"releases.length == 0 && !scheduleReleaseCtrl.periodChanged && selectedSchedule\" display-message=\"\'No releases yet for the selected Schedule\'\"></no-data>");
$templateCache.put("app/scheduleRelease/views/scheduleRelease.html","<div class=\"header-state\">{{scheduleReleaseCtrl.currentStateName}} <a href=\"#\" class=\"pull-right archive-icon\" ng-if=\"scheduleReleaseCtrl.currentPeriod==\'future\'\" ng-click=\"scheduleReleaseCtrl.changePeriod(\'past\')\"><img src=\"assets/images/svgIcons/archiveReleaseScheduling.svg\"></a> <a href=\"#\" eks-icon=\"\" class=\"pull-right archive-icon\" ng-if=\"scheduleReleaseCtrl.currentPeriod==\'past\'\" ng-click=\"scheduleReleaseCtrl.changePeriod(\'future\')\"></a></div><div class=\"main-content schedule-release-content\"><div class=\"schedules\"><section><div class=\"section-header\"><div class=\"row section-header-titles-row\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><div uib-dropdown=\"\" class=\"section-dropdown\" is-open=\"scheduleReleaseCtrl.dropdownActive\"><a href=\"#\" id=\"schedulesList\" uib-dropdown-toggle=\"\" ng-click=\"scheduleReleaseCtrl.test()\">Schedules&nbsp;<div ng-include=\"\'assets/images/dropdown-arrow.svg\'\"></div></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"schedulesList\"><li><input type=\"text\" name=\"searchSchedule\" placeholder=\"Keyword...\" class=\"search-text\" ng-model=\"scheduleReleaseCtrl.schedulesListFilter\" ng-click=\"$event.stopPropagation()\" input-clear=\"\"></li><li class=\"scrollable-list-item\"><ul><li ng-repeat=\"schedule in scheduleReleaseCtrl.schedules | filter:scheduleReleaseCtrl.schedulesListFilter\"><a href=\"#\" ng-click=\"scheduleReleaseCtrl.schedulesListSelectedChanged(schedule)\">{{schedule.Name}} <span class=\"description\">{{schedule.Start | date : \'MMMM dd yyyy\'}} - {{schedule.End | date : \'MMMM dd yyyy\'}}</span></a></li></ul></li></ul></div></div><div class=\"col-md-6 col-sm-6 col-xs-6 text-right\" ng-if=\"scheduleReleaseCtrl.currentPeriod==\'future\' && checkForPermission(\'AddRelease\')\"><a href=\"#\" class=\"content-add-button\" ng-class=\"{\'section-header-event-selected\': scheduleReleaseCtrl.isScheduleEntryVisible}\" ng-click=\"scheduleReleaseCtrl.isScheduleEntryVisible = !scheduleReleaseCtrl.isScheduleEntryVisible\">Add Schedule<i add-icon=\"\"></i></a></div></div><form name=\"scheduleForm\" id=\"scheduleForm\" class=\"section-header-form\" ng-show=\"scheduleReleaseCtrl.currentPeriod == \'future\' && scheduleReleaseCtrl.isScheduleEntryVisible\" ng-submit=\"scheduleForm.$valid && scheduleReleaseCtrl.addSchedule()\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (scheduleForm.$submitted || scheduleForm.scheduleName.$touched) && scheduleForm.scheduleName.$error.required }\"><div><label class=\"required input-label\" for=\"scheduleName\">Schedule Name</label></div><input name=\"scheduleName\" type=\"text\" id=\"scheduleNameTextBox\" ng-model=\"scheduleReleaseCtrl.scheduleModel.Name\" class=\"form-control\" required=\"\" input-clear=\"\"></div><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (scheduleForm.$submitted || scheduleForm.startDate.$touched) && scheduleForm.startDate.$error.required}\"><div><label class=\"required input-label\" for=\"startDate\">Start Date</label></div><div class=\"datepicker-container\"><input type=\"text\" name=\"startDate\" class=\"form-control\" uib-datepicker-popup=\"{{scheduleReleaseCtrl.format}}\" ng-model=\"scheduleReleaseCtrl.scheduleModel.Start\" is-open=\"scheduleReleaseCtrl.startDateOpened.opened\" datepicker-options=\"scheduleReleaseCtrl.dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"scheduleReleaseCtrl.altInputFormats\" show-button-bar=\"false\" required=\"\" input-clear=\"\"><hr><button type=\"button\" class=\"btn button-calendar\" ng-class=\"{\'button-calendar-selected\': scheduleReleaseCtrl.startDateOpened.opened}\" ng-click=\"scheduleReleaseCtrl.openStartDate()\"><div ng-include=\"\'assets/images/date-picker.svg\'\"></div></button></div></div><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (scheduleForm.$submitted || scheduleForm.endDate.$touched) && scheduleForm.endDate.$error.required}\"><div><label class=\"required input-label\" for=\"endDate\">End Date</label></div><div class=\"datepicker-container\"><input type=\"text\" name=\"endDate\" class=\"form-control\" uib-datepicker-popup=\"{{scheduleReleaseCtrl.format}}\" ng-model=\"scheduleReleaseCtrl.scheduleModel.End\" is-open=\"scheduleReleaseCtrl.endDateOpened.opened\" datepicker-options=\"scheduleReleaseCtrl.dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"scheduleReleaseCtrl.altInputFormats\" show-button-bar=\"false\" required=\"\" input-clear=\"\"><hr><button type=\"button\" class=\"btn button-calendar\" ng-class=\"{\'button-calendar-selected\': scheduleReleaseCtrl.endDateOpened.opened}\" ng-click=\"scheduleReleaseCtrl.openEndDate()\"><div ng-include=\"\'assets/images/date-picker.svg\'\"></div></button></div></div></div><div class=\"row\"><div class=\"col-md-12 form-group text-right\"><button type=\"submit\" class=\"btn button-blue button-left-space\" ng-disabled=\"scheduleReleaseCtrl.isSaving\">Save</button></div></div></form></div></section><slick ng-if=\"scheduleReleaseCtrl.slickLoaded\" settings=\"scheduleReleaseCtrl.slickConfig\" ng-class=\"{\'schedule-selected\': scheduleReleaseCtrl.selectedSchedule != null}\"><div ng-repeat=\"schedule in scheduleReleaseCtrl.schedules\" ng-click=\"scheduleReleaseCtrl.setActiveSchedule(schedule)\"><div ng-click=\"scheduleReleaseCtrl.selectScheduleEdit(schedule)\"><schedule info=\"schedule\" is-archived=\"scheduleReleaseCtrl.currentPeriod==\'past\'\" schedule-selected=\"scheduleReleaseCtrl.selectedSchedule\" edit=\"scheduleReleaseCtrl.askEditSchedule(schedule)\" delete=\"scheduleReleaseCtrl.deleteSchedule(schedule.Id)\" change-period=\"scheduleReleaseCtrl.periodChanged\" get-releases=\"scheduleReleaseCtrl.getScheduleReleases(schedule.Id)\" pre-selected-schedule=\"scheduleReleaseCtrl.scheduleSelected\"></schedule><div class=\"selected-schedule-arrow\"></div></div></div><div ng-repeat=\"fakeSchedule in scheduleReleaseCtrl.fakeSchedules\"><div class=\"schedule-fake-container\"><schedule info=\"fakeSchedule\" is-archived=\"scheduleReleaseCtrl.currentPeriod==\'past\'\" edit=\"\" schedule-selected=\"false\" delete=\"\" get-releases=\"\"></schedule><div class=\"selected-schedule-arrow\"></div></div></div></slick><no-data no-data-found=\"scheduleReleaseCtrl.schedules.length == 0 && !scheduleReleaseCtrl.isLoading\" display-message=\"\'No schedules yet\'\"></no-data></div><div ui-view=\"releases\" class=\"releases\" ng-if=\"scheduleReleaseCtrl.selectedSchedule && checkForPermission(\'GetReleases\')\"></div></div>");
$templateCache.put("app/school-management/enrollments/enrollments.template.html","<h1>Enrollments</h1>");
$templateCache.put("app/school-management/sessions/sessions.template.html","<h1>Sessions</h1>");
$templateCache.put("app/settings/partials/_editQuestion.html","<div class=\"model-content-blue\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-10\"><span class=\"modal-message-title\">Edit Question</span></div><div class=\"col-md-2 col-sm-2 col-xs-2 text-right\"><a borderless-eks-icon=\"\" href=\"#\" class=\"modal-close\" ng-click=\"settingsCtrl.hideWarning()\"></a></div></div></div><form name=\"editQuestionForm\" id=\"editQuestionForm\" ng-submit=\"editQuestionForm.$valid && settingsCtrl.editQuestionAnswer()\" novalidate=\"\" isolated-form=\"\"><div class=\"modal-body\" id=\"modal-body\"><div class=\"form-group\" ng-class=\"{\'has-error\': (editQuestionForm.$submitted || editQuestionForm.questionTitle.$touched) && editQuestionForm.questionTitle.$error.required}\"><label class=\"required input-label\" for=\"questionTitle\">Question</label> <textarea name=\"questionTitle\" cols=\"25\" rows=\"3\" class=\"form-control\" placeholder=\"Add question here\" ng-model=\"$resolve.params.Question\" required=\"\" input-clear=\"\"></textarea></div><div class=\"form-group\" ng-class=\"{\'has-error\': (editQuestionForm.$submitted || editQuestionForm.questionAnswer.$touched) && editQuestionForm.questionAnswer.$error.required}\"><label class=\"required input-label\" for=\"questionAnswer\">Answer</label> <textarea name=\"questionAnswer\" cols=\"25\" rows=\"3\" class=\"form-control\" placeholder=\"Add answer here\" ng-model=\"$resolve.params.Answer\" required=\"\" input-clear=\"\"></textarea></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn button-blue\" ng-disabled=\"settingsCtrl.isSavingQuestion\">Save</button></div></form></div>");
$templateCache.put("app/settings/partials/_removeNotificationEmailMessage.html","<div class=\"model-content-red\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-10\"><span class=\"modal-message-title\">Remove notification email</span></div><div class=\"col-md-2 col-sm-2 col-xs-2 text-right\"><a borderless-eks-icon=\"\" href=\"#\" class=\"modal-close\" ng-click=\"settingsCtrl.hideWarning()\"></a></div></div></div><div class=\"modal-body\" id=\"modal-body\">Are you sure you want to remove the selected notification email?</div><div class=\"modal-footer\"><button class=\"btn button-red\" type=\"button\" ng-click=\"settingsCtrl.deleteNotificationEmail()\" ng-disabled=\"settingsCtrl.isLoadingNotifications\">Remove</button></div></div>");
$templateCache.put("app/settings/partials/_removeQAMessage.html","<div class=\"model-content-red\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-10\"><span class=\"modal-message-title\">Remove question</span></div><div class=\"col-md-2 col-sm-2 col-xs-2 text-right\"><a borderless-eks-icon=\"\" href=\"#\" class=\"modal-close\" ng-click=\"settingsCtrl.hideWarning()\"></a></div></div></div><div class=\"modal-body\" id=\"modal-body\">Are you sure you want to remove the question?</div><div class=\"modal-footer\"><button class=\"btn button-red\" type=\"button\" ng-click=\"settingsCtrl.deleteQuestionAnswer()\" ng-disabled=\"settingsCtrl.isLoadingQuestions\">Remove</button></div></div>");
$templateCache.put("app/settings/views/settings.html","<div class=\"header-state\">Settings</div><div class=\"main-content\"><div name=\"settingsForm\" ng-form=\"\" class=\"form-with-action-bar\" ng-model=\"settingsCtrl.mobileSystemSettings\"><section><div class=\"section-header\"><h1>Book Settings</h1></div><div class=\"checkbox\"><label><input name=\"readableOnline\" type=\"checkbox\" ng-model=\"settingsCtrl.mobileSystemSettings.ReadableOnline\" ng-checked=\"settingsCtrl.mobileSystemSettings.ReadableOnline\"> <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span> <span class=\"cr-label\">Readable Online</span></label></div></section><hr class=\"section-seperator\"><section><div class=\"section-header\"><h1>User Settings</h1></div><div class=\"row\"><div class=\"col-md-4 user-settings-form-group\" ng-class=\"{\'has-error\': (settingsForm.$submitted || settingsForm.exipryDate.$touched) && settingsForm.exipryDate.$error.required}\"><label class=\"required input-label\" for=\"scheduleName\">Offline Login Expiry Date (days)</label> <input name=\"exipryDate\" type=\"number\" class=\"form-control\" id=\"expiryDateTextBox\" placeholder=\"In days\" min=\"0\" max=\"2147483647\" ng-model=\"settingsCtrl.mobileSystemSettings.ExpiryHours\" required=\"\"></div><div class=\"col-md-4\" ng-class=\"{\'has-error\': (settingsForm.$submitted || settingsForm.sessionTimeout.$touched) && settingsForm.sessionTimeout.$error.required}\"><label class=\"required input-label\" for=\"scheduleName\">Session Timeout (minutes)</label> <input name=\"sessionTimeout\" type=\"number\" class=\"form-control\" id=\"timeOutTextBox\" placeholder=\"In minutes\" min=\"0\" max=\"2147483647\" ng-model=\"settingsCtrl.mobileSystemSettings.SessionTimeout\" required=\"\"></div></div></section><hr class=\"section-seperator\"><section><div class=\"section-header\"><h1>Notification Settings</h1></div><div class=\"notification-box\"><form name=\"notificationForm\" id=\"notificationForm\" ng-submit=\"notificationForm.$valid && settingsCtrl.addNotificationEmail()\" novalidate=\"\" isolated-form=\"\"><div class=\"row\"><div class=\"col-md-5 form-group\" ng-class=\"{\'has-error\': (notificationForm.$submitted || notificationForm.email.$touched) && (notificationForm.email.$error.required || notificationForm.email.$error.email)}\"><label class=\"required input-label\" for=\"email\">E-mail Address</label> <input name=\"email\" type=\"email\" id=\"emailTextBox\" class=\"form-control\" maxlength=\"200\" placeholder=\"example@domain.com\" ng-model=\"settingsCtrl.notification.EmailAddress\" required=\"\" input-clear=\"\"> <span class=\"help-block\" ng-show=\"notificationForm.email.$error.email\">This is not a valid email</span></div><div class=\"col-md-5 form-group\" ng-class=\"{\'has-error\': (notificationForm.$submitted || notificationForm.notificationType.$touched) && notificationForm.notificationType.$error.required}\"><label ng-if=\"(notificationForm.$submitted || notificationForm.notificationType.$touched) && notificationForm.notificationType.$error.required\" class=\"required input-label\" for=\"notificationType\">Notification Type - Error</label> <label ng-if=\"!((notificationForm.$submitted || notificationForm.notificationType.$touched) && notificationForm.notificationType.$error.required)\" class=\"required input-label\" for=\"notificationType\">Notification Type</label><ol id=\"notificationTypeList\" name=\"notificationType\" class=\"nya-bs-select form-control app-dropdown\" ng-model=\"settingsCtrl.notification.NotificationTypeId\" title=\"Select type\" live-search=\"true\" required=\"\" dropdown-clear-selection=\"\"><li nya-bs-option=\"type in settingsCtrl.notificationTypes\" data-value=\"type.NotificationTypeId\"><a>{{ type.Description }}</a></li></ol></div><div class=\"col-md-2 form-group text-right\"><button type=\"submit\" class=\"btn button-blue\" ng-disabled=\"settingsCtrl.isSavingNotification\">Add</button></div></div><div class=\"row\"><div class=\"col-md-5 notification-info-line\" ng-repeat=\"email in settingsCtrl.notificationEmails\"><a eks-icon=\"\" href=\"#\" class=\"action-warning-svg-icon notification-remove-action\" ng-click=\"settingsCtrl.askRemoveNotificationEmail(email.Id)\"></a> <span class=\"notification-email\">{{email.EmailAddress}}</span> <span class=\"notification-email-type pull-right\">{{email.NotificationType.Description}}</span></div></div><no-data no-data-found=\"settingsCtrl.notificationEmails.length == 0 && !settingsCtrl.isLoadingNotifications\" display-message=\"\'No emails yet\'\"></no-data></form></div></section><hr class=\"section-seperator\"><section><div class=\"section-header\"><h1>FAQ</h1></div><div class=\"row\"><div class=\"form-group col-md-4\" ng-class=\"{\'has-error\': settingsForm.tutorialVideoURL.$error.url}\"><label class=\"input-label\" for=\"tutorialVideoURL\">Tutorial Video URL</label> <input name=\"tutorialVideoURL\" type=\"url\" id=\"videoURLTextBox\" placeholder=\"http://www.example.com\" class=\"form-control\" ng-model=\"settingsCtrl.mobileSystemSettings.VideoTutorialURL\" input-clear=\"\"> <span class=\"help-block\" ng-show=\"settingsForm.tutorialVideoURL.$error.url\">This is not a valid URL</span></div></div><div class=\"row section-header-titles-row text-right\"><a href=\"#\" class=\"content-add-button\" ng-class=\"{\'section-header-event-selected\': settingsCtrl.isQuestionEntryVisible}\" ng-click=\"settingsCtrl.isQuestionEntryVisible = !settingsCtrl.isQuestionEntryVisible\">Add Question +</a></div><form name=\"questionForm\" id=\"questionForm\" class=\"section-header-form\" ng-show=\"settingsCtrl.isQuestionEntryVisible\" ng-class=\"{\'faq-entry\': settingsCtrl.isQuestionEntryVisible}\" ng-submit=\"questionForm.$valid && settingsCtrl.addQuestionAnswer()\" novalidate=\"\" isolated-form=\"\"><div class=\"row\"><div class=\"col-md-6 form-group\" ng-class=\"{\'has-error\': (questionForm.$submitted || questionForm.questionTitle.$touched) && questionForm.questionTitle.$error.required}\"><label class=\"required input-label\" for=\"questionTitle\">Question</label> <textarea name=\"questionTitle\" cols=\"25\" rows=\"3\" class=\"form-control\" placeholder=\"Add question here\" ng-model=\"settingsCtrl.question.Question\" required=\"\" input-clear=\"\"></textarea></div><div class=\"col-md-6 form-group\" ng-class=\"{\'has-error\': (questionForm.$submitted || questionForm.questionAnswer.$touched) && questionForm.questionAnswer.$error.required}\"><label class=\"required input-label\" for=\"questionAnswer\">Answer</label> <textarea name=\"questionAnswer\" cols=\"25\" rows=\"3\" class=\"form-control\" placeholder=\"Add answer here\" ng-model=\"settingsCtrl.question.Answer\" required=\"\" input-clear=\"\"></textarea></div></div><div class=\"row\"><div class=\"col-md-12 form-group text-right\"><button type=\"submit\" class=\"btn button-blue\" ng-disabled=\"settingsCtrl.isSavingQuestion\">Add</button></div></div></form><div class=\"row faq-question-row\"><div class=\"col-md-4\"><label class=\"input-label\">Questions</label></div></div><div class=\"row\"><div class=\"col-md-4\" ng-repeat=\"qa in settingsCtrl.faqQuestionsAnswers\"><div class=\"faq-question-box\"><h2>{{qa.Question}}</h2><p>{{qa.Answer}}</p><div class=\"box-actions\"><a edit-icon=\"\" ng-click=\"settingsCtrl.showWarning(\'editQuestion\', qa)\"></a> <a delete-icon=\"\" ng-click=\"settingsCtrl.askRemoveQuestionAnswer(qa.Id)\"></a></div></div></div></div><no-data no-data-found=\"settingsCtrl.faqQuestionsAnswers.length == 0 && !settingsCtrl.isLoadingQuestions\" display-message=\"\'No questions created yet\'\"></no-data></section><div class=\"footer-actions text-right\"><button type=\"submit\" class=\"btn button-blue\" ng-disabled=\"settingsCtrl.isSavingSystemSettings || !checkForPermission(\'ManageSettings\')\" ng-click=\"settingsCtrl.saveSystemSettings()\">Save</button></div></div></div>");
$templateCache.put("app/management/book/views/_advancedSearch.html","<style>\r\n    .btn-book-management:focus{\r\n        background-color:#0080bb;\r\n    }\r\n</style><div class=\"advanced-search\"><form role=\"form\" ng-submit=\"bookCtrl.searchBySingleKeyWord()\"><div class=\"input-group\"><div class=\"input-group-btn\"><a href=\"#\" class=\"button-advanced\" ng-click=\"bookCtrl.toggleBookSearch()\" ng-class=\"{\'button-advanced-activated\': bookCtrl.isSearchBoxVisible}\">Advanced Search <i dropdown-arrow-icon=\"\"></i></a></div><input type=\"search\" name=\"keywordSearch\" class=\"form-control search-text\" placeholder=\"keyword....\" ng-model=\"bookCtrl.searchKeyWord\" ng-disabled=\"bookCtrl.isSearchBoxVisible\" input-clear=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn button-blue btn-book-management\" ng-disabled=\"bookCtrl.isSearchBoxVisible\">Search</button></span></div></form><div class=\"search-keywords-tags\"><ul><li ng-repeat=\"searchTag in bookCtrl.searchKeyWordsTags track by $index\" ng-class=\"{\'has-no-results\': !searchTag.HasResult}\"><span>{{searchTag.Value}}</span><div class=\"keyword-remove action-svg-icon\" borderless-eks-icon=\"\" href=\"#\" ng-click=\"bookCtrl.removeKeyWord($index)\"></div></li></ul></div><div class=\"advanced-search-content-form\" ng-show=\"bookCtrl.isSearchBoxVisible\" outside-click=\"bookCtrl.isSearchBoxVisible = false\" ignore-for=\"button-advanced button-advanced-activated,action-svg-icon\"><div class=\"arrow\"></div><form id=\"searchForm\" ng-submit=\"bookCtrl.advancedSearch(); bookCtrl.toggleBookSearch();\"><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-6 filters-header\">Filter by:</div><div class=\"col-md-6 col-sm-6 col-xs-6 text-right\"><a href=\"#\" class=\"reset-search\" ng-click=\"bookCtrl.resetSearch(\'advanced\')\"><i reset-icon=\"\"></i>Reset</a></div></div><div class=\"row\"><div class=\"col-md-4 form-group\"><input name=\"searchFirstName\" type=\"text\" class=\"form-control\" placeholder=\"Title\" ng-model=\"bookCtrl.bookSearch.Title\" input-clear=\"\"></div><div class=\"col-md-4 form-group\"><input name=\"searchMiddleName\" type=\"text\" class=\"form-control\" placeholder=\"ISBN\" ng-model=\"bookCtrl.bookSearch.Identifier\" input-clear=\"\"></div><div class=\"col-md-4 form-group\"><input name=\"searchLastName\" type=\"text\" class=\"form-control\" placeholder=\"Author\" ng-model=\"bookCtrl.bookSearch.Author\" input-clear=\"\"></div></div><div class=\"row\"><div class=\"col-md-4 form-group\"><ol class=\"nya-bs-select form-control app-dropdown\" ng-model=\"bookCtrl.bookSearch.SubjectId\" title=\"Subject\" size=\"10\" live-search=\"true\" dropdown-clear-selection=\"\"><li nya-bs-option=\"subject in bookCtrl.subjects\" data-value=\"subject.Id\"><a>{{ subject.Name }}</a></li></ol></div><div class=\"col-md-4 form-group\" ng-hide=\"true\"><ol name=\"searchSchool\" class=\"nya-bs-select form-control app-dropdown\" ng-model=\"bookCtrl.bookSearch.level\" title=\"Book Level\" size=\"10\" live-search=\"true\" dropdown-clear-selection=\"\"></ol></div><div class=\"col-md-4 form-group\"><ol name=\"searchGrade\" class=\"nya-bs-select form-control app-dropdown\" ng-model=\"bookCtrl.bookSearch.BookStatus\" title=\"Status\" size=\"10\" live-search=\"true\" dropdown-clear-selection=\"\"><li nya-bs-option=\"status in bookCtrl.statuses\" data-value=\"status.value\"><a>{{ status.display }}</a></li></ol></div></div><button type=\"submit\" class=\"btn btn-block button-blue\">Search</button></form></div></div>");
$templateCache.put("app/management/book/views/_bookCover.html","<style>\r\n    .margin-right-0 {\r\n        margin-right: 0 !important;\r\n    }\r\n</style><div class=\"wrapperBooks\"><div class=\"inline-block book-cover-dashboard\" ng-class=\"{\'active-book-border\':book.isSelected,\'margin-right-0\':($index+1)%coversPerLine==0}\" style=\"margin-right:20px;height:275px!important;margin-left:-4px\" ng-repeat=\"book in bookCovers\"><div ng-click=\"toggleBook({book:book})\" style=\"position:relative;height:242px;\"><img style=\"max-width:100%!important;margin-top:0!important;height:242px;\" class=\"book-image-width\" lazy-load=\"\" img-http-src=\"{{bookCoverFirstPart + book.Identifier+\'/\' +book.VersionNumber+\'/\'+ book.CoverFileName+\'/\'+book.CoverFileExtension+\'/\'+book.IsEncrypted}}\"><div class=\"overlay-div\" ng-if=\"book.IsLocked\"><div class=\"lock-book\"><img src=\"assets/images/locked.png\"></div></div></div><div class=\"thumbnail-info-menu\"><info-icon ng-click=\"showBookInfo({book:book})\"></info-icon></div></div></div>");
$templateCache.put("app/management/book/views/_bookInfo.html","<div class=\"model-content-blue\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-10\"><span class=\"modal-message-title\">{{header}}</span></div><div class=\"col-md-2 col-sm-2 col-xs-2 text-right\"><a borderless-eks-icon=\"\" href=\"#\" class=\"modal-close\" ng-click=\"cancel()\"></a></div></div></div><div class=\"modal-body\" id=\"modal-body\">Title: {{bookTitle}}<br><br>ISBN: {{isbn}}<br><br>Author: {{author}}<br><br>Subject: {{subject}}<br><br>{{statusDatetext}} {{statusSinceDate | date : \'MMMM dd, yyyy hh:mm:ss\'}}<br><br>Download Size: {{downloadSize | byteSizeToString}}<br><br>Size on Device: {{sizeOnDevice | byteSizeToString}}</div></div><script>\r\n\r\n</script>");
$templateCache.put("app/management/book/views/_controls.html","<div class=\"inline-block books-selection-count\" ng-show=\"allBooksAreSelected || selectedBooksCount >0\">&nbsp;-&nbsp;&nbsp;selected {{selectedBooksCount}} of {{allBooksCount}}</div><a href=\"#\" class=\"inline-block pull-right\" style=\"margin-top:-3px!important\" uib-popover=\"Export to Excel\" popover-class=\"popover-hint\" popover-placement=\"bottom-right\" popover-trigger=\"\'mouseenter\'\" ng-show=\"permissionCheck(\'ExportBooks\')\" ng-click=\"exportToExcel()\"><export-excel></export-excel></a>");
$templateCache.put("app/management/book/views/_modalConfirm.html","<div ng-class=\"{\'model-content-red\': isWarningModal, \'model-content-blue\': !isWarningModal}\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-10\"><span class=\"modal-message-title\">{{header}}</span></div><div class=\"col-md-2 col-sm-2 col-xs-2 text-right\"><a borderless-eks-icon=\"\" href=\"#\" class=\"modal-close\" ng-click=\"cancel()\"></a></div></div></div><div class=\"modal-body\" id=\"modal-body\">{{confirmAction}}<br><br>{{confirmActionSecond}}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn\" ng-class=\"{\'button-red\': isWarningModal, \'button-blue\': !isWarningModal}\" ng-click=\"ok()\">{{actionName}}</button></div></div>");
$templateCache.put("app/management/book/views/_selectAll.html","<div class=\"checkbox-large inline-block\"><label><input type=\"checkbox\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" ng-model=\"ngModel\" ng-change=\"changeSelect({selector:selectorOf,boolean:ngModel})\"> <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span> <span class=\"cr-label\">{{selectLabel}}</span></label></div>");
$templateCache.put("app/management/book/views/book.html","<div class=\"header-state\">Book Management</div><div class=\"main-content books-container\" ng-init=\"bookCtrl.initView()\"><div><div ng-include=\"\'app/management/book/views/_advancedSearch.html\'\"></div></div><section class=\"details-section\"><span role=\"alert\" class=\"raw-alert action-default-info\" ng-show=\"bookCtrl.isViewFirstLoad\">Run a search to view results</span> <span role=\"alert\" class=\"raw-alert action-info\">{{bookCtrl.searchTypeDescription}}</span><div class=\"details-group\" ng-show=\"bookCtrl.pendingBooksVisible\"><div class=\"container-action-icons\"><select-all ng-model=\"bookCtrl.testedSelectAll\" change-select=\"bookCtrl.selectAllBooks(selector,boolean)\" selector-of=\"testing\" select-label=\"To Be Tested\" ng-show=\"bookCtrl.bookCoversTesting.length>0\"></select-all><book-controls all-books-are-selected=\"bookCtrl.testedSelectAll\" selected-books-count=\"bookCtrl.selectedTestingBooksCount\" all-books-count=\"bookCtrl.allBooksInTesting\" ng-show=\"bookCtrl.bookCoversTesting.length>0\" book-type=\"Pending\"></book-controls><a href=\"#\" class=\"inline-block pull-right margin-right-20px\" style=\"margin-top:-3px!important\" uib-popover=\"Approve Books\" popover-class=\"popover-hint\" popover-placement=\"bottom-right\" popover-trigger=\"\'mouseenter\'\" ng-click=\"bookCtrl.selectedTestingBooksCount && bookCtrl.approveBooks()\" ng-disabled=\"true\" ng-show=\"bookCtrl.bookCoversTesting.length>0 && checkForPermission(\'ApproveBooks\')\" ng-class=\"{\'svg-disabled\':!bookCtrl.selectedTestingBooksCount}\"><tick-svg></tick-svg></a> <a href=\"#\" class=\"inline-block pull-right margin-right-20px\" uib-popover=\"Reject Books\" popover-class=\"popover-hint\" popover-placement=\"bottom-right\" popover-trigger=\"\'mouseenter\'\" ng-click=\"bookCtrl.selectedTestingBooksCount && bookCtrl.showRejectBookPopup()\" ng-show=\"bookCtrl.bookCoversTesting.length>0 && checkForPermission(\'RejectBooks\')\" ng-class=\"{\'svg-disabled\':!bookCtrl.selectedTestingBooksCount}\"><reject-svg></reject-svg></a></div><div><book-cover covers-per-line=\"bookCtrl.coversPerLine\" book-covers=\"bookCtrl.bookCoversTesting\" toggle-book=\"bookCtrl.toggleBookTesting(book)\" book-cover-first-part=\"{{bookCtrl.coverUrlFirstPart}}\" book-cover-second-part=\"{{bookCtrl.coverUrlSecondPart}}\" show-book-info=\"bookCtrl.seeBookInfo(book)\"></book-cover><div class=\"text-center load-more-section\"><a href=\"#\" class=\"full-width text-center\" ng-if=\"bookCtrl.allBooksInTesting > bookCtrl.bookCoversTesting.length && bookCtrl.bookCoversTesting.length!=0\" ng-click=\"bookCtrl.getBooksInTesting();\">Load More</a></div></div></div><div class=\"details-group\" ng-show=\"bookCtrl.approvedBooksVisible\"><div class=\"container-action-icons\"><select-all ng-model=\"bookCtrl.approvedAll\" change-select=\"bookCtrl.selectAllBooks(selector,boolean)\" selector-of=\"scheduled\" select-label=\"To Be Scheduled\" ng-show=\"bookCtrl.bookCoversApproved.length>0\"></select-all><book-controls all-books-are-selected=\"bookCtrl.approvedAll\" selected-books-count=\"bookCtrl.selectedApprovedBooksCount\" all-books-count=\"bookCtrl.allApprovedBooks\" ng-show=\"bookCtrl.bookCoversApproved.length>0\" book-type=\"Approved\"></book-controls></div><div><book-cover covers-per-line=\"bookCtrl.coversPerLine\" book-covers=\"bookCtrl.bookCoversApproved\" toggle-book=\"bookCtrl.toggleBookScheduled(book)\" book-cover-first-part=\"{{bookCtrl.coverUrlFirstPart}}\" book-cover-second-part=\"{{bookCtrl.coverUrlSecondPart}}\" show-book-info=\"bookCtrl.seeBookInfo(book)\"></book-cover><div class=\"text-center load-more-section\"><a href=\"#\" class=\"full-width text-center\" ng-if=\"bookCtrl.allApprovedBooks > bookCtrl.bookCoversApproved.length && bookCtrl.bookCoversApproved.length!=0 && !bookCtrl.searchIsActive\" ng-click=\"bookCtrl.getApprovedBooks()\">Load More</a></div></div></div><div class=\"details-group\" ng-show=\"bookCtrl.scheduledBooksVisible\"><div class=\"container-action-icons\"><select-all ng-model=\"bookCtrl.scheduledAll\" change-select=\"bookCtrl.selectAllBooks(selector,boolean)\" selector-of=\"isScheduled\" select-label=\"Scheduled\" ng-show=\"bookCtrl.bookCoversScheduled.length>0\"></select-all><a href=\"#\" class=\"inline-block pull-right margin-right-20px\" style=\"margin-top:-3px!important\" uib-popover=\"Approve Books\" popover-class=\"popover-hint\" popover-placement=\"bottom-right\" popover-trigger=\"\'mouseenter\'\" ng-show=\"bookCtrl.bookCoversScheduled.length>0 && checkForPermission(\'ScheduledBooks\')\" ng-class=\"{\'svg-disabled\':!bookCtrl.selectedScheduledBooksCount}\"><tick-svg></tick-svg></a></div><div><book-cover covers-per-line=\"bookCtrl.coversPerLine\" book-covers=\"bookCtrl.bookCoversScheduled\" toggle-book=\"bookCtrl.toggleBookIsScheduled(book)\" book-cover-first-part=\"{{bookCtrl.coverUrlFirstPart}}\" book-cover-second-part=\"{{bookCtrl.coverUrlSecondPart}}\" show-book-info=\"bookCtrl.seeBookInfo(book)\"></book-cover><div class=\"text-center load-more-section\"><a href=\"#\" class=\"full-width text-center\" ng-if=\"bookCtrl.allScheduledBooks > bookCtrl.bookCoversScheduled.length && bookCtrl.bookCoversScheduled.length!=0\" ng-click=\"bookCtrl.getScheduledBooks();\">Load More</a></div></div></div><div class=\"details-group\" ng-show=\"bookCtrl.releasedBooksVisible\"><div class=\"container-action-icons\"><select-all ng-model=\"bookCtrl.releasedAll\" change-select=\"bookCtrl.selectAllBooks(selector,boolean)\" selector-of=\"released\" select-label=\"Released\" ng-show=\"bookCtrl.bookCoversReleased.length>0\"></select-all><book-controls all-books-are-selected=\"bookCtrl.releasedAll\" selected-books-count=\"bookCtrl.selectedReleasedBooksCount\" all-books-count=\"bookCtrl.allReleasedBooks\" ng-show=\"bookCtrl.bookCoversReleased.length>0\" book-type=\"Released\"></book-controls><a href=\"#\" class=\"inline-block pull-right margin-right-20px\" uib-popover=\"Delete Books\" popover-class=\"popover-hint\" popover-placement=\"bottom-right\" popover-trigger=\"\'mouseenter\'\" ng-click=\"bookCtrl.selectedReleasedBooksCount && bookCtrl.deleteBooks()\" ng-show=\"bookCtrl.bookCoversReleased.length>0 && checkForPermission(\'DeleteBooks\')\" ng-class=\"{\'svg-disabled\':!bookCtrl.selectedReleasedBooksCount}\"><delete-svg></delete-svg></a> <a href=\"#\" class=\"inline-block pull-right margin-right-20px\" uib-popover=\"Lock Books\" popover-class=\"popover-hint\" popover-placement=\"bottom-right\" popover-trigger=\"\'mouseenter\'\" ng-click=\"bookCtrl.selectedReleasedBooksCount && bookCtrl.lockBooks()\" ng-show=\"bookCtrl.bookCoversReleased.length>0 && checkForPermission(\'LockBooks\')\" ng-class=\"{\'svg-disabled\':!bookCtrl.selectedReleasedBooksCount}\"><lock-svg></lock-svg></a> <a href=\"#\" class=\"inline-block pull-right margin-right-20px\" uib-popover=\"Unlock Books\" popover-class=\"popover-hint\" popover-placement=\"bottom-right\" popover-trigger=\"\'mouseenter\'\" ng-click=\"bookCtrl.selectedReleasedBooksCount && bookCtrl.unlockBooks()\" ng-show=\"bookCtrl.bookCoversReleased.length>0 && checkForPermission(\'LockBooks\')\" ng-class=\"{\'svg-disabled\':!bookCtrl.selectedReleasedBooksCount}\"><unlock-svg></unlock-svg></a></div><div><book-cover covers-per-line=\"bookCtrl.coversPerLine\" book-covers=\"bookCtrl.bookCoversReleased\" toggle-book=\"bookCtrl.toggleBookReleased(book)\" book-cover-first-part=\"{{bookCtrl.coverUrlFirstPart}}\" book-cover-second-part=\"{{bookCtrl.coverUrlSecondPart}}\" show-book-info=\"bookCtrl.seeBookInfo(book)\"></book-cover><div class=\"text-center load-more-section\"><a href=\"#\" class=\"full-width\" ng-if=\"bookCtrl.allReleasedBooks > bookCtrl.bookCoversReleased.length && bookCtrl.bookCoversReleased.length!=0\" ng-click=\"bookCtrl.getReleasedBooks()\">Load More</a></div></div></div></section><no-data no-data-found=\"bookCtrl.noDataFound\" display-message=\"\'No books matching the search criteria\'\"></no-data></div>");
$templateCache.put("app/management/device/partials/_device.html","<div class=\"device-box text-center\"><img ng-src=\"assets/images/{{device.DeviceTypeId | deviceTypeIconFilter}}\" width=\"26\" height=\"20\"><div class=\"status-icon\" ng-if=\"device.IsConnected && !device.IsDisabled\"><status-connected></status-connected></div><div class=\"status-icon\" ng-if=\"!device.IsConnected && !device.IsDisabled\"><status-disconnected></status-disconnected></div><div class=\"status-icon\" ng-if=\"!device.IsConnected && device.IsDisabled\"><status-disabled></status-disabled></div><p class=\"box-info main-info\">{{device.Name }}</p><hr><p class=\"box-info\">UUID <span class=\"info-value\">{{device.UUID}}</span></p><p class=\"box-info\">LAST LOGIN <span class=\"info-value\">{{device.LastLogin | date : \'MMMM dd, yyyy - hh:mm a\'}}</span></p><p class=\"box-info\">LAST USER <span class=\"info-value\">{{device.LastUserLogin}} \'</span></p></div>");
$templateCache.put("app/management/device/partials/_deviceBattery.html","<div class=\"{{batteryClass}}\" ng-show=\"batteryStatus\"><div style=\"width: {{batteryStatus}}%\"></div><span>{{batteryStatus}} %</span></div>");
$templateCache.put("app/management/device/partials/_disableMessage.html","<div class=\"model-content-red\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-10\"><span class=\"modal-message-title\">Disable This Device</span></div><div class=\"col-md-2 col-sm-2 col-xs-2 text-right\"><a borderless-eks-icon=\"\" href=\"#\" class=\"modal-close\" ng-click=\"vm.closeModal()\"></a></div></div></div><div class=\"modal-body\" id=\"modal-body\">Are you sure you want to disable this device?</div><div class=\"modal-footer\"><button class=\"btn button-red\" type=\"button\" ng-click=\"vm.ConfirmAction()\">Disable</button></div></div>");
$templateCache.put("app/management/device/partials/_removeAssignedUserMessage.html","<div class=\"model-content-red\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-10\"><span class=\"modal-message-title\">Unassign user</span></div><div class=\"col-md-2 col-sm-2 col-xs-2 text-right\"><a borderless-eks-icon=\"\" href=\"#\" class=\"modal-close\" ng-click=\"vm.closeModal()\"></a></div></div></div><div class=\"modal-body\" id=\"modal-body\">Are you sure you want to unassign the selected user for this device?</div><div class=\"modal-footer\"><button class=\"btn button-red\" type=\"button\" ng-click=\"vm.ConfirmAction()\">Remove</button></div></div>");
$templateCache.put("app/management/device/views/device.html","<div class=\"header-state\">Device Management <a href=\"#\" class=\"page-header-icon pull-right\" ng-if=\"!deviceCtrl.statisticWidgetVisible\" ng-click=\"deviceCtrl.showHideStatisticsWidget()\"><img src=\"assets/images/svgIcons/iconStatistic.svg\"></a></div><div class=\"main-content\"><section class=\"details-section\"><div class=\"advanced-search\"><form role=\"form\" ng-submit=\"deviceCtrl.getDevices(false)\"><div class=\"input-group\"><div class=\"input-group-btn\"><a href=\"#\" class=\"button-advanced\" ng-click=\"deviceCtrl.showHideAdvancedSearch();\" ng-class=\"{\'button-advanced-activated\': deviceCtrl.isSearchBoxVisible}\">Advanced Search <i dropdown-arrow-icon=\"\"></i></a></div><input type=\"search\" name=\"keywordSearch\" class=\"form-control search-text\" placeholder=\"Keyword...\" ng-disabled=\"deviceCtrl.isSearchBoxVisible\" ng-model=\"deviceCtrl.searchCriteria.Keyword\" ng-change=\"deviceCtrl.showKeywords = false\" input-clear=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn button-blue\" ng-disabled=\"deviceCtrl.isSearchBoxVisible || deviceCtrl.isSearching\">Search</button></span></div></form><div ng-show=\"deviceCtrl.showKeywords\"><search-keywords search-text=\"deviceCtrl.searchCriteria.Keyword\" keywords=\"deviceCtrl.searchCriteria.Keywords\" predefined-keywords=\"deviceCtrl.searchPredefinedKeywords\" search=\"deviceCtrl.getDevices(false)\"></search-keywords></div><div class=\"advanced-search-content-form\" ng-show=\"deviceCtrl.isSearchBoxVisible\" outside-click=\"deviceCtrl.isSearchBoxVisible = false\" ignore-for=\"button-advanced button-advanced-activated,action-svg-icon\"><div class=\"arrow\"></div><form role=\"form\" ng-submit=\"deviceCtrl.getDevices(true); deviceCtrl.showHideAdvancedSearch();\"><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-6 filters-header\">Filter by:</div><div class=\"col-md-6 col-sm-6 col-xs-6 text-right\"><a href=\"#\" class=\"reset-search\" ng-click=\"deviceCtrl.resetSearch(\'advanced\')\"><i reset-icon=\"\"></i>Reset</a></div></div><div class=\"row\"><div class=\"col-md-4 form-group\"><ol class=\"nya-bs-select form-control app-dropdown\" ng-model=\"deviceCtrl.searchCriteria.DeviceStatus\" title=\"Status\" size=\"6\" live-search=\"true\" dropdown-clear-selection=\"\"><li nya-bs-option=\"status in deviceCtrl.deviceStatus\" data-value=\"status.Id\"><a>{{ status.Description }}</a></li></ol></div><div class=\"col-md-4 form-group\"><ol class=\"nya-bs-select form-control app-dropdown\" ng-model=\"deviceCtrl.searchCriteria.DeviceTypeId\" title=\"Type\" size=\"6\" live-search=\"true\" dropdown-clear-selection=\"\"><li nya-bs-option=\"type in deviceCtrl.deviceTypes\" data-value=\"type.Id\"><a>{{ type.Description }}</a></li></ol></div><div class=\"col-md-4 form-group\"><ol class=\"nya-bs-select form-control app-dropdown\" ng-model=\"deviceCtrl.searchCriteria.SchoolId\" ng-disabled=\"deviceCtrl.userSchools.length === 0\" title=\"School\" size=\"6\" live-search=\"true\" dropdown-clear-selection=\"\"><li nya-bs-option=\"school in deviceCtrl.userSchools\" data-value=\"school.Id\"><a ng-click=\"deviceCtrl.schoolGrades = school.Class\">{{ school.LongName }}</a></li></ol></div></div><div class=\"row\"><div class=\"col-md-4 form-group\"><ol class=\"nya-bs-select form-control app-dropdown\" ng-model=\"deviceCtrl.searchCriteria.GradeId\" ng-disabled=\"deviceCtrl.userSchools.length === 0\" title=\"Grade\" size=\"6\" live-search=\"true\" dropdown-clear-selection=\"\"><li nya-bs-option=\"class in deviceCtrl.schoolGrades\" data-value=\"class.Id\"><a>{{ class.Class }}</a></li></ol></div></div><button type=\"submit\" class=\"btn btn-block button-blue\" ng-disabled=\"deviceCtrl.isSearching\">Search</button></form></div></div><section class=\"module-statistics-section\" ng-show=\"deviceCtrl.statisticWidgetVisible\"><div class=\"section-heading\">Statistics <a href=\"#\" class=\"pull-right\" borderless-eks-icon=\"\" ng-click=\"deviceCtrl.showHideStatisticsWidget()\"></a></div><div class=\"section-content\"><slick ng-if=\"deviceCtrl.slickLoaded\" settings=\"deviceCtrl.slickConfig\"><div><div class=\"chart-content\" ng-hide=\"!deviceCtrl.slickLoaded\"><h2>Usage by Android Version</h2><h3>{{deviceCtrl.androidVersionStatsSchool }}</h3><no-data no-data-found=\"deviceCtrl.deviceUsageByOSVersionData.datasets.data.length == 0\" display-message=\"\'No statistics yet for usage by android version\'\"></no-data><div><canvas class=\"chart chart-pie\" chart-data=\"deviceCtrl.deviceUsageByOSVersionData.datasets.data\" chart-labels=\"deviceCtrl.deviceUsageByOSVersionData.labels\" chart-options=\"deviceCtrl.deviceUsageByOSVersionData.datasets.options\" chart-colors=\"deviceCtrl.chartColors\"></canvas></div></div></div><div><div class=\"chart-content\" ng-hide=\"!deviceCtrl.slickLoaded\"><h2>Usage by Brand</h2><h3>{{deviceCtrl.brandStatsSchool}}</h3><no-data no-data-found=\"deviceCtrl.deviceUsageByBrandData.datasets.data.length == 0\" display-message=\"\'No statistics yet for usage by brand\'\"></no-data><div><canvas class=\"chart chart-pie\" chart-data=\"deviceCtrl.deviceUsageByBrandData.datasets.data\" chart-labels=\"deviceCtrl.deviceUsageByBrandData.labels\" chart-options=\"deviceCtrl.deviceUsageByBrandData.datasets.options\" chart-colors=\"deviceCtrl.chartColors\"></canvas></div></div></div><div><div class=\"chart-content\" ng-hide=\"!deviceCtrl.slickLoaded\"><h2>Usage by Resolution</h2><h3>{{deviceCtrl.resolutionStatsSchool}}</h3><no-data no-data-found=\"deviceCtrl.deviceUsageByResolutionData.datasets.data.length == 0\" display-message=\"\'No statistics yet for usage by resolution\'\"></no-data><div><canvas class=\"chart chart-pie\" chart-data=\"deviceCtrl.deviceUsageByResolutionData.datasets.data\" chart-labels=\"deviceCtrl.deviceUsageByResolutionData.labels\" chart-options=\"deviceCtrl.deviceUsageByResolutionData.datasets.options\" chart-colors=\"deviceCtrl.chartColors\"></canvas></div></div></div></slick></div></section><span role=\"alert\" class=\"raw-alert action-default-info\" ng-show=\"deviceCtrl.deviceSearchResults.devices.length == 0 && deviceCtrl.noDataFound == false\">Run a search to view results</span> <span role=\"alert\" class=\"raw-alert action-info\">{{deviceCtrl.searchTypeDescription}}</span><div class=\"details-group\"><div class=\"row\"><div class=\"col-md-3 col-sm-4 details-group-content-item\" ng-repeat=\"device in deviceCtrl.deviceSearchResults.devices | limitTo: deviceCtrl.deviceSearchResults.visibleDevicesItems\"><a href=\"#\" ui-sref=\"mainAuth.management.deviceDetails({ deviceId: device.Id, deviceSearchResults: deviceCtrl.deviceSearchResults, searchCriteriaBackup: deviceCtrl.searchCriteriaBackup })\"><device info=\"device\"></device></a></div></div></div><div class=\"text-center load-more-section\" ng-show=\"deviceCtrl.deviceSearchResults.devices.length > deviceCtrl.deviceSearchResults.visibleDevicesItems\"><a href=\"#\" ng-click=\"deviceCtrl.getMoreDevices();\">Load more</a></div></section><no-data no-data-found=\"deviceCtrl.noDataFound\" display-message=\"\'No devices matching the search criteria\'\"></no-data></div>");
$templateCache.put("app/management/device/views/deviceDetails.html","<div class=\"header-state\"><a ui-sref=\"mainAuth.management.device({deviceSearchResults: deviceDetailsCtrl.deviceSearchResults, searchCriteriaBackup: deviceDetailsCtrl.searchCriteriaBackup})\" class=\"back-link\">Device Management</a><breadcrumb-icon></breadcrumb-icon>{{deviceDetailsCtrl.device.Name}}</div><div class=\"main-content\"><div class=\"form-with-action-bar\" ng-show=\"!deviceDetailsCtrl.isLoadingOnInit\"><section class=\"item-detail-main-info-box\"><div class=\"row\"><div class=\"col-md-2 text-center\"><div class=\"details-device-icon\"><img ng-src=\"assets/images/{{deviceDetailsCtrl.device.DeviceTypeId | deviceTypeIconFilter}}\" width=\"40\" height=\"40\"></div></div><div class=\"col-md-10\"><form name=\"deviceInfoForm\"><div class=\"row\"><div class=\"col-md-4 form-group\">Name: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.Name}}</span></div><div class=\"col-md-4 form-group\">Brand: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.Brand}}</span></div><div class=\"col-md-4 form-group\">Model: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.Model}}</span></div></div><div class=\"row\"><div class=\"col-md-4 form-group\">Resolution: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.Resolution}}</span></div><div class=\"col-md-4 form-group\">UUID: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.UUID}}</span></div><div class=\"col-md-4 form-group\">IP: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.IP}}</span></div></div><div class=\"row\"><div class=\"col-md-4 form-group\">First Login: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.FirstLogin | date : \'MMMM dd, yyyy - hh:mm a\'}}</span></div><div class=\"col-md-4 form-group\">Last Login: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.LastLogin | date : \'MMMM dd, yyyy - hh:mm a\'}}</span></div><div class=\"col-md-4 form-group\">CPU Model: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.CPUModel}}</span></div></div><div class=\"row\"><div class=\"col-md-12 form-group\"><hr></div></div><div class=\"row\"><div class=\"col-md-4 form-group\">OS Type: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.OSType}}</span></div><div class=\"col-md-4 form-group\">Version: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.Version}}</span></div><div class=\"col-md-4 form-group\">App Version: <span class=\"form-readonly-info\">{{deviceDetailsCtrl.device.AppVersion}}</span></div></div></form></div></div></section><section class=\"details-section\"><div class=\"details-group\"><h1 class=\"details-group-title\">Assigned Users</h1><div class=\"row\"><div class=\"col-md-3 col-sm-4 details-group-content-item\" ng-repeat=\"user in deviceDetailsCtrl.device.Users\"><a href=\"javascript:void(0);\" ng-class=\"{\'default-cursor\': user.IsDeleted}\" ng-if=\"user.RoleId != deviceDetailsCtrl.userRolesConstant.loaner && user.RoleId != deviceDetailsCtrl.userRolesConstant.nonTeachingStaff\" ui-sref=\"{{user.IsDeleted ? \'#\': \'mainAuth.management.userDetails({ userId: user.Id, userSearchResults: [], searchCriteriaBackup: null })\'}}\"><div ng-switch=\"deviceDetailsCtrl.removeUserFromDevice && deviceDetailsCtrl.manageDevice\"><user info=\"user\" role-id=\"user.RoleId\" delete=\"deviceDetailsCtrl.askRemoveAssignedUser(user.Id)\" ng-switch-when=\"true\" ng-disabled=\"deviceDetailsCtrl.isLoading\"></user><user info=\"user\" role-id=\"user.RoleId\" ng-switch-when=\"false\"></user></div></a><a href=\"javascript:void(0);\" ng-class=\"{\'default-cursor\': user.IsDeleted}\" ng-if=\"user.RoleId == deviceDetailsCtrl.userRolesConstant.loaner\" ui-sref=\"{{user.IsDeleted ? \'#\':\'mainAuth.management.loanerDetails({ userId: user.Id, userSearchResults: [], searchCriteriaBackup: null })\'}}\"><div ng-switch=\"deviceDetailsCtrl.removeUserFromDevice && deviceDetailsCtrl.manageDevice\"><user info=\"user\" role-id=\"user.RoleId\" delete=\"deviceDetailsCtrl.askRemoveAssignedUser(user.Id)\" ng-switch-when=\"true\" ng-disabled=\"deviceDetailsCtrl.isLoading\"></user><user info=\"user\" role-id=\"user.RoleId\" ng-switch-when=\"false\"></user></div></a><a href=\"javascript:void(0);\" ng-class=\"{\'default-cursor\': user.IsDeleted}\" ng-if=\"user.RoleId == deviceDetailsCtrl.userRolesConstant.nonTeachingStaff\" ui-sref=\"{{user.IsDeleted ? \'#\': \'mainAuth.management.noneTeachingStaffDetails({ userId: user.Id, userSearchResults: [], searchCriteriaBackup: null })\'}}\"><div ng-switch=\"deviceDetailsCtrl.removeUserFromDevice && deviceDetailsCtrl.manageDevice\"><user info=\"user\" role-id=\"user.RoleId\" delete=\"deviceDetailsCtrl.askRemoveAssignedUser(user.Id)\" ng-switch-when=\"true\" ng-disabled=\"deviceDetailsCtrl.isLoading\"></user><user info=\"user\" role-id=\"user.RoleId\" ng-switch-when=\"false\"></user></div></a></div></div><no-data no-data-found=\"deviceDetailsCtrl.device.Users == null || deviceDetailsCtrl.device.Users.length == 0\" display-message=\"\'No assigned user(s) for this device\'\"></no-data></div></section><div class=\"footer-actions text-right\" ng-show=\"deviceDetailsCtrl.manageDevice\"><button class=\"btn button-blue\" ng-click=\"deviceDetailsCtrl.changeDeviceStatus(false)\" ng-show=\"deviceDetailsCtrl.device.DeviceStatus == 1\" ng-disabled=\"deviceDetailsCtrl.isLoading\">Enable</button> <button class=\"btn button-red\" ng-click=\"deviceDetailsCtrl.askChangeDeviceStatus(\'disableDevice\')\" ng-show=\"deviceDetailsCtrl.device.DeviceStatus == 0\" ng-disabled=\"deviceDetailsCtrl.isLoading\">Disable</button></div></div></div>");
$templateCache.put("app/management/role/views/role.html","<div class=\"header-state\">Role Management</div><div class=\"main-content\"><form name=\"roleForm\" id=\"roleForm\" class=\"page-header-form section-header-form\" ng-submit=\"roleForm.$valid && roleCtrl.addRole()\" ng-show=\"roleCtrl.isRoleEntryVisible\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12 form-group\" ng-class=\"{\'has-error\' : (roleForm.$submitted || roleForm.roleDescription.$touched) && roleForm.roleDescription.$error.required}\"><label class=\"required input-label\" for=\"roleDescription\">Role Description</label> <input name=\"roleDescription\" type=\"text\" class=\"form-control\" ng-model=\"roleCtrl.newRole.Name\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-12 form-group text-right\"><button type=\"submit\" class=\"btn button-blue\">Save</button></div></div></form><section class=\"roles-section section-header-titles-row\"><div uib-dropdown=\"\" class=\"section-dropdown\" ng-hide=\"roleCtrl.roles.length == 0\"><a href=\"#\" id=\"rolesList\" uib-dropdown-toggle=\"\">{{roleCtrl.selectedRole.Name}}&nbsp;<div ng-include=\"\'assets/images/dropdown-arrow.svg\'\"></div></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"rolesList\"><li><input type=\"text\" placeholder=\"Keyword...\" class=\"search-text\" ng-model=\"listQuery\" ng-click=\"$event.stopPropagation()\"></li><li ng-repeat=\"role in roleCtrl.roles | filter:listQuery\"><a href=\"#\" ng-click=\"roleCtrl.selectedRole = role\">{{role.Name}}</a></li></ul></div></section><section class=\"permissions-section\"><div class=\"row\"><div class=\"col-md-4\" ng-repeat=\"permission in roleCtrl.permissions\"><div class=\"permission-box text-center\" ng-class=\"{\'permission-box-selected\': (roleCtrl.roles | filter : {Id: roleCtrl.selectedRole.Id, RolePermissions: permission.Id} : true).length > 0}\"><p>{{permission.Type}}</p></div></div></div></section></div>");
$templateCache.put("app/management/user/partials/_disableMessage.html","<div class=\"model-content-red\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-10\"><span class=\"modal-message-title\">Disable User Account</span></div><div class=\"col-md-2 col-sm-2 col-xs-2 text-right\"><a borderless-eks-icon=\"\" href=\"#\" class=\"modal-close\" ng-click=\"vm.closeModal()\"></a></div></div></div><div class=\"modal-body\" id=\"modal-body\">Are you sure you want to disable this account?</div><div class=\"modal-footer\"><button class=\"btn button-red\" type=\"button\" ng-click=\"vm.ConfirmAction()\">Disable</button></div></div>");
$templateCache.put("app/management/user/partials/_pairedDeviceMessage.html","<div class=\"model-content-red\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-10\"><span class=\"modal-message-title\">Remove paired device</span></div><div class=\"col-md-2 col-sm-2 col-xs-2 text-right\"><a borderless-eks-icon=\"\" href=\"#\" class=\"modal-close\" ng-click=\"vm.closeModal()\"></a></div></div></div><div class=\"modal-body\" id=\"modal-body\">Are you sure you want to remove device for this account?</div><div class=\"modal-footer\"><button class=\"btn button-red\" type=\"button\" ng-click=\"vm.ConfirmAction()\">Remove</button></div></div>");
$templateCache.put("app/management/user/partials/_user.html","<div class=\"user-box text-center\" style=\"position:relative\"><style>\r\n    </style><img ng-src=\"assets/images/{{user.Gender | avatarFilter}}\" class=\"img-circle\" width=\"100\" height=\"100\"><div class=\"status-icon\" title=\"Deleted\" ng-if=\"user.IsDeleted\"><status-disabled></status-disabled></div><div ng-if=\"!user.IsDeleted\"><div class=\"status-icon\" ng-if=\"user.IsConnected && !user.IsDisabled\"><status-connected></status-connected></div><div class=\"status-icon\" ng-if=\"!user.IsConnected && !user.IsDisabled\"><status-disconnected></status-disconnected></div><div class=\"status-icon\" ng-if=\"!user.IsConnected && user.IsDisabled\"><status-disabled></status-disabled></div></div><div><p class=\"full-name box-info main-info centered-name\" ng-if=\"user.user.FirstName != null\">{{user.FirstName + \' \' + user.LastName}}</p><p class=\"full-name box-info main-info centered-name\" ng-if=\"user.user.FirstName == null\">{{user.Username}}</p><p class=\"full-name box-info main-info centered-name\" ng-if=\"user.UserNumber\">{{user.UserNumber}}</p></div><hr><p class=\"user-school\">{{user.SchoolNames[0]}}</p><div class=\"grade-section\" ng-if=\"!user.SchoolNames\">SABIS<sup class=\"sabis-registered-trademark\">®</sup> Educational Services</div><span class=\"user-department\">{{user.Department}}</span><div ng-if=\"roleId != userCtrl.userRolesConstant.loaner && roleId != userCtrl.userRolesConstant.nonTeachingStaff\"><div class=\"grade-section\" ng-if=\"user.Grade || user.Section\">Grade{{\' \'+user.Grade + \' \'}}-&nbsp;Section{{\' \'+user.Section}}</div><div class=\"grade-section\" ng-if=\"user.IsSpdRole && (!user.Grade && !user.Section)\">&nbsp;</div></div><div class=\"educational-services-sign\" ng-if=\"roleId == userCtrl.userRolesConstant.loaner || roleId == userCtrl.userRolesConstant.nonTeachingStaff\">Level{{ \' \' + userLevel}}</div><delete-icon ng-click=\"$event.preventDefault(); $event.stopPropagation(); userCtrl.deleteUser();\" ng-show=\"delete !== undefined\"></delete-icon></div>");
$templateCache.put("app/management/user/views/user.html","<div class=\"header-state\">User Management<a href=\"#\" class=\"page-header-add-button pull-right\" ng-class=\"{\'section-header-event-selected\': userCtrl.isUserEntryVisible}\" ng-click=\"userCtrl.isUserEntryVisible = !userCtrl.isUserEntryVisible\" ng-if=\"checkForPermission(\'AddUser\')\">Add User<i add-icon=\"\"></i></a></div><div class=\"main-content\"><div ng-show=\"userCtrl.isUserEntryVisible\"><form name=\"newUserForm\" id=\"newUserForm\" class=\"page-header-form section-header-form\" ng-submit=\"newUserForm.$valid && userCtrl.addUser()\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (newUserForm.$submitted || newUserForm.firstName.$touched) && newUserForm.firstName.$error.required}\"><label class=\"required input-label\" for=\"firstName\">First Name</label> <input name=\"firstName\" type=\"text\" class=\"form-control\" maxlength=\"50\" ng-model=\"userCtrl.user.FirstName\" required=\"\" input-clear=\"\"></div><div class=\"col-md-4 form-group\"><label class=\"input-label\" for=\"middleName\">Middle Name</label> <input name=\"middleName\" type=\"text\" class=\"form-control\" maxlength=\"50\" ng-model=\"userCtrl.user.middleName\" input-clear=\"\"></div><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (newUserForm.$submitted || newUserForm.lastName.$touched) && newUserForm.lastName.$error.required}\"><label class=\"required input-label\" for=\"lastName\">Last Name</label> <input name=\"lastName\" type=\"text\" class=\"form-control\" maxlength=\"50\" ng-model=\"userCtrl.user.LastName\" required=\"\" input-clear=\"\"></div></div><div class=\"row\"><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (newUserForm.$submitted || newUserForm.userName.$touched) && (newUserForm.userName.$error.required || newUserForm.userName.$error.usernameUnique)}\"><label class=\"required input-label\" for=\"userName\">Username</label> <input name=\"userName\" type=\"text\" class=\"form-control\" maxlength=\"200\" ng-model=\"userCtrl.user.Username\" username-available-validator=\"\" ng-model-options=\"{ updateOn: \'blur\' }\" required=\"\" input-clear=\"\"> <span class=\"help-block\" ng-show=\"!newUserForm.userName.$error.required && newUserForm.userName.$error.usernameUnique\">This username is not available</span></div><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\': (newUserForm.$submitted || newUserForm.email.$touched) && (newUserForm.email.$error.required || newUserForm.email.$error.email || newUserForm.email.$error.emailUnique)}\"><label class=\"required input-label\" for=\"email\">Email</label> <input name=\"email\" type=\"email\" id=\"emailTextBox\" class=\"form-control\" maxlength=\"100\" placeholder=\"example@domain.com\" ng-model=\"userCtrl.user.EmailAddress\" user-email-available-validator=\"\" ng-model-options=\"{ updateOn: \'blur\' }\" required=\"\" input-clear=\"\"> <span class=\"help-block\" ng-show=\"newUserForm.email.$error.email\">This is not a valid email</span> <span class=\"help-block\" ng-show=\"!newUserForm.email.$error.required && !newUserForm.email.$error.email && newUserForm.email.$error.emailUnique\">This email is not available</span></div><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\': (newUserForm.$submitted || newUserForm.userRole.$touched) && newUserForm.userRole.$error.required}\"><label class=\"required input-label\" for=\"notificationType\">Role</label><ol name=\"userRole\" class=\"nya-bs-select form-control app-dropdown\" ng-model=\"userCtrl.user.RoleId\" title=\"Select role\" size=\"10\" live-search=\"true\" required=\"\" dropdown-clear-selection=\"\"><li nya-bs-option=\"role in userCtrl.cmsAvailableRoles\" data-value=\"role.Id\"><a ng-click=\"userCtrl.checkRoleSpecificPermissions(role)\">{{ role.Name }}</a></li></ol></div></div><div class=\"row\"><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\': (newUserForm.$submitted || newUserForm.userGender.$touched) && newUserForm.userGender.$error.required}\"><label class=\"required input-label\" for=\"notificationType\">Gender</label><ol name=\"userGender\" class=\"nya-bs-select form-control app-dropdown\" ng-model=\"userCtrl.user.Gender\" title=\"Select gender\" size=\"10\" live-search=\"true\" required=\"\" dropdown-clear-selection=\"\"><li nya-bs-option=\"gender in userCtrl.genders\" data-value=\"gender.Id\"><a>{{ gender.Description }}</a></li></ol></div><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (newUserForm.$submitted || newUserForm.allowedDevices.$touched) && newUserForm.allowedDevices.$error.required}\"><label class=\"required input-label\" for=\"notificationType\">Authorized Devices</label> <input name=\"allowedDevices\" type=\"number\" class=\"form-control\" min=\"0\" max=\"2147483647\" ng-model=\"userCtrl.user.AllowedDevices\" ng-disabled=\"!userCtrl.canLogInToMobileBookshelf\" ng-paste=\"$event.preventDefault()\" input-number-positive=\"\" required=\"\"></div></div><div class=\"row\" ng-if=\"userCtrl.ShowSubjectAssignmentSection\"><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (newUserForm.$submitted || newUserForm.userAssignedSubjects.$touched) && newUserForm.userAssignedSubjects.$error.required}\"><label class=\"required input-label\">Subjects</label><ol name=\"userAssignedSubjects\" class=\"nya-bs-select form-control app-dropdown\" ng-model=\"userCtrl.user.AssignedSubjects\" title=\"Select Subject(s)\" size=\"10\" ng-disabled=\"userCtrl.user.HasAllSubjects\" live-search=\"true\" required=\"\" dropdown-clear-selection=\"\" multiple=\"\"><li nya-bs-option=\"subject in userCtrl.availableSubjects\" data-value=\"subject\" ng-class=\"{\'selected-option\' : userCtrl.isSubjectSelected(subject)}\"><a>{{subject.Name}}</a></li></ol></div><div class=\"col-md-4 form-group\" style=\"padding-top:20px;\"><div class=\"checkbox\"><label><input name=\"hasAllSubjects\" type=\"checkbox\" ng-model=\"userCtrl.user.HasAllSubjects\" ng-checked=\"userCtrl.user.HasAllSubjects\"> <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span> <span class=\"cr-label\">Has All Subjects</span></label></div></div></div><div class=\"row\"><div class=\"col-md-12 form-group text-right\"><button type=\"submit\" class=\"btn button-blue\" ng-disabled=\"userCtrl.isSavingUser\">Add</button></div></div></form></div><section class=\"details-section\"><div class=\"advanced-search\"><form role=\"form\" ng-submit=\"userCtrl.getUsers(false)\"><div class=\"input-group\"><div class=\"input-group-btn\"><a href=\"#\" class=\"button-advanced\" ng-click=\"userCtrl.showHideAdvancedSearch();\" ng-class=\"{\'button-advanced-activated\': userCtrl.isSearchBoxVisible}\">Advanced Search <i dropdown-arrow-icon=\"\"></i></a></div><input type=\"search\" name=\"keywordSearch\" class=\"form-control search-text\" placeholder=\"keyword....\" ng-disabled=\"userCtrl.isSearchBoxVisible\" ng-model=\"userCtrl.searchCriteria.Keyword\" ng-change=\"userCtrl.showKeywords = false\" input-clear=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn button-blue\" ng-disabled=\"userCtrl.isSearchBoxVisible || userCtrl.isSearching\">Search</button></span></div></form><div ng-show=\"userCtrl.showKeywords\"><search-keywords search-text=\"userCtrl.searchCriteria.Keyword\" keywords=\"userCtrl.searchCriteria.Keywords\" predefined-keywords=\"userCtrl.searchPredefinedKeywords\" search=\"userCtrl.getUsers(false)\"></search-keywords></div><div class=\"advanced-search-content-form\" ng-show=\"userCtrl.isSearchBoxVisible\" outside-click=\"userCtrl.isSearchBoxVisible = false\" ignore-for=\"button-advanced button-advanced-activated,action-svg-icon\"><div class=\"arrow\"></div><form role=\"form\" ng-submit=\"userCtrl.getUsers(true); userCtrl.showHideAdvancedSearch();\"><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-6 filters-header\">Filter by:</div><div class=\"col-md-6 col-sm-6 col-xs-6 text-right\"><a href=\"#\" class=\"reset-search\" ng-click=\"userCtrl.resetSearch(\'advanced\')\"><i reset-icon=\"\"></i>Reset</a></div></div><div class=\"row\"><div class=\"col-md-4 form-group\"><input type=\"text\" name=\"firstNameSearch\" class=\"form-control\" placeholder=\"First Name\" ng-model=\"userCtrl.searchCriteria.FirstName\" input-clear=\"\"></div><div class=\"col-md-4 form-group\"><input type=\"text\" name=\"middleNameSearch\" class=\"form-control\" placeholder=\"Middle Name\" ng-model=\"userCtrl.searchCriteria.MiddleName\" input-clear=\"\"></div><div class=\"col-md-4 form-group\"><input type=\"text\" name=\"lastNameSearch\" class=\"form-control\" placeholder=\"Last Name\" ng-model=\"userCtrl.searchCriteria.LastName\" input-clear=\"\"></div></div><div class=\"row\"><div class=\"col-md-4 form-group\"><input type=\"text\" name=\"userNameSearch\" class=\"form-control\" placeholder=\"Username\" ng-model=\"userCtrl.searchCriteria.UserName\" input-clear=\"\"></div><div class=\"col-md-4 form-group\" ng-if=\"userCtrl.loggedInUserRoleId == userCtrl.userRolesConstant.schoolAdmin\"><input type=\"text\" name=\"UserNumberSearch\" class=\"form-control\" placeholder=\"Student Number\" ng-model=\"userCtrl.searchCriteria.UserNumber\" input-clear=\"\"></div><div class=\"col-md-4 form-group\"><ol class=\"nya-bs-select form-control app-dropdown\" ng-model=\"userCtrl.searchCriteria.RoleId\" title=\"Role\" size=\"6\" live-search=\"true\" dropdown-clear-selection=\"\"><li nya-bs-option=\"role in userCtrl.roles\" data-value=\"role.Id\"><a ng-click=\"userCtrl.isSDPRole = role.IsSDPRole\">{{ role.Name }}</a></li></ol></div><div class=\"col-md-4 form-group\" ng-if=\"userCtrl.loggedInUserRoleId != userCtrl.userRolesConstant.schoolAdmin\"><ol class=\"nya-bs-select form-control app-dropdown\" ng-model=\"userCtrl.searchCriteria.IsDisabled\" title=\"Status\" live-search=\"true\" dropdown-clear-selection=\"\"><li nya-bs-option=\"status in userCtrl.userStatus\" data-value=\"status.Id\"><a>{{ status.Description }}</a></li></ol></div></div><div class=\"row\"><div class=\"col-md-4 form-group\" ng-if=\"userCtrl.loggedInUserRoleId == userCtrl.userRolesConstant.schoolAdmin\"><ol class=\"nya-bs-select form-control app-dropdown\" ng-model=\"userCtrl.searchCriteria.IsDisabled\" title=\"Status\" live-search=\"true\" dropdown-clear-selection=\"\"><li nya-bs-option=\"status in userCtrl.userStatus\" data-value=\"status.Id\"><a>{{ status.Description }}</a></li></ol></div><div class=\"col-md-4 form-group\"><ol class=\"nya-bs-select form-control app-dropdown\" ng-model=\"userCtrl.searchCriteria.SchoolExternalId\" ng-disabled=\"userCtrl.userSchools.length === 0 || !userCtrl.isSDPRole\" title=\"School\" size=\"6\" live-search=\"true\" dropdown-clear-selection=\"\"><li nya-bs-option=\"school in userCtrl.userSchools\" data-value=\"school.SchoolSDPId\"><a>{{ school.SchoolLongName }}</a></li></ol></div><div class=\"col-md-4 form-group\"><ol class=\"nya-bs-select form-control app-dropdown\" ng-model=\"userCtrl.searchCriteria.Levels\" ng-disabled=\"!userCtrl.selectedSchool\" title=\"Level\" size=\"6\" live-search=\"true\" dropdown-clear-selection=\"\" multiple=\"\"><li nya-bs-option=\"level in userCtrl.selectedSchool.SchoolLevels\" data-value=\"level.Name\" ng-class=\"{\'selected-option\' : (userCtrl.searchCriteria.Levels && userCtrl.searchCriteria.Levels.indexOf(level.Name)>-1)}\"><a>{{level.Name }}</a></li></ol></div></div><button type=\"submit\" class=\"btn btn-block button-blue\" ng-disabled=\"userCtrl.isSearching\">Search</button></form></div></div><span role=\"alert\" class=\"raw-alert action-default-info\" ng-show=\"userCtrl.rolesWithUsers.length == 0 && userCtrl.noDataFound == false\">Run a search to view results</span> <span role=\"alert\" class=\"raw-alert action-info\">{{userCtrl.searchTypeDescription}}</span><div class=\"details-group\" ng-repeat=\"role in userCtrl.rolesWithUsers\"><h1 class=\"details-group-title\" ng-if=\"role.users.length > 0\">{{role.name}}</h1><div class=\"row\"><div class=\"col-md-3 col-sm-4 details-group-content-item\" ng-repeat=\"user in role.users | limitTo: role.visibleUsersItems\"><a href=\"#\" ui-sref=\"mainAuth.management.userDetails({ userId: user.Id, userSearchResults: userCtrl.rolesWithUsers, searchCriteriaBackup: userCtrl.searchCriteriaBackup })\"><user info=\"user\"></user></a></div></div><div class=\"text-center load-more-section\" ng-show=\"role.users.length > role.visibleUsersItems\"><a href=\"#\" ng-click=\"userCtrl.getMoreUsersPerRole(role);\">Load more</a></div></div></section><no-data no-data-found=\"userCtrl.noDataFound\" display-message=\"\'No users matching the search criteria\'\"></no-data></div>");
$templateCache.put("app/management/user/views/userDetails.html","<div class=\"header-state\" ng-switch=\"userDetailsCtrl.isSavingUser\"><a ui-sref=\"mainAuth.management.olduser({userSearchResults: userDetailsCtrl.userSearchResults, searchCriteriaBackup: userDetailsCtrl.searchCriteriaBackup})\" class=\"back-link\" ng-switch-when=\"false\">User Management</a> <span ng-switch-when=\"true\">User Management</span><breadcrumb-icon></breadcrumb-icon>{{userDetailsCtrl.user.FirstName + \' \' + userDetailsCtrl.user.LastName}}</div><div class=\"main-content\"><div class=\"form-with-action-bar\"><section class=\"item-detail-main-info-box\"><div class=\"row\"><div class=\"col-md-2 text-center\"><img ng-src=\"assets/images/{{userDetailsCtrl.user.Gender | avatarFilter}}\" ng-show=\"userDetailsCtrl.user.Gender !== undefined\" class=\"img-circle\" width=\"140\" height=\"140\" ng-cloak=\"\"></div><div class=\"col-md-10\"><form name=\"userInfoForm\" ng-submit=\"(userInfoForm.$valid && userDetailsCtrl.updateUser())|| (userDetailsCtrl.manageDevicePermission && userDetailsCtrl.updateUser())\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (userInfoForm.$submitted || userInfoForm.firstName.$touched) && userInfoForm.firstName.$error.required}\"><label class=\"required input-label\" for=\"firstName\">First Name</label> <input name=\"firstName\" type=\"text\" class=\"form-control\" maxlength=\"50\" ng-model=\"userDetailsCtrl.user.FirstName\" ng-disabled=\"userDetailsCtrl.user.IsSDPUser\" ng-required=\"userDetailsCtrl.addUserFieldsRequired\" input-clear=\"\"></div><div class=\"col-md-4 form-group\"><label class=\"input-label\" for=\"middleName\">Middle Name</label> <input name=\"middleName\" type=\"text\" class=\"form-control\" maxlength=\"50\" ng-model=\"userDetailsCtrl.user.MiddleName\" ng-disabled=\"userDetailsCtrl.user.IsSDPUser\" input-clear=\"\"></div><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (userInfoForm.$submitted || userInfoForm.lastName.$touched) && userInfoForm.lastName.$error.required}\"><label class=\"required input-label\" for=\"lastName\">Last Name</label> <input name=\"lastName\" type=\"text\" class=\"form-control\" maxlength=\"50\" ng-model=\"userDetailsCtrl.user.LastName\" ng-disabled=\"userDetailsCtrl.user.IsSDPUser\" ng-required=\"userDetailsCtrl.addUserFieldsRequired\" input-clear=\"\"></div></div><div class=\"row\"><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\' : (userInfoForm.$submitted || userInfoForm.userName.$touched) && (userInfoForm.userName.$error.required || userInfoForm.userName.$error.usernameUnique) && (!userDetailsCtrl.user.IsSDPUser)}\"><label class=\"required input-label\" for=\"userName\">Username</label> <input name=\"userName\" type=\"text\" class=\"form-control\" maxlength=\"200\" ng-model=\"userDetailsCtrl.user.Username\" user-id=\"{{userDetailsCtrl.userId}}\" username-available-validator=\"\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-disabled=\"userDetailsCtrl.user.IsSDPUser\" ng-required=\"userDetailsCtrl.addUserFieldsRequired\" input-clear=\"\"> <span class=\"help-block\" ng-show=\"!userInfoForm.userName.$error.required && userInfoForm.userName.$error.usernameUnique && !userDetailsCtrl.user.IsSDPUser\">This username is not available</span></div><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\': (userInfoForm.$submitted || userInfoForm.email.$touched) && (userInfoForm.email.$error.required || userInfoForm.email.$error.email || userInfoForm.email.$error.emailUnique)}\"><label class=\"required input-label\" for=\"email\">Email</label> <input name=\"email\" type=\"email\" id=\"emailTextBox\" class=\"form-control\" maxlength=\"100\" placeholder=\"example@domain.com\" ng-model=\"userDetailsCtrl.user.EmailAddress\" ng-disabled=\"userDetailsCtrl.user.IsSDPUser\" user-id=\"{{userDetailsCtrl.userId}}\" user-email-available-validator=\"\" ng-model-options=\"{ updateOn: \'blur\' }\" input-clear=\"\" ng-required=\"!userDetailsCtrl.user.IsSDPUser && userDetailsCtrl.addUserFieldsRequired\"> <span class=\"help-block\" ng-show=\"userInfoForm.email.$error.email\">This is not a valid email</span> <span class=\"help-block\" ng-show=\"!userInfoForm.email.$error.required && !userInfoForm.email.$error.email && userInfoForm.email.$error.emailUnique\">This email is not available</span></div><div class=\"col-md-4 form-group\" ng-class=\"{\'has-error\': (userInfoForm.$submitted || userInfoForm.userRole.$touched) && userInfoForm.userRole.$error.required}\"><label class=\"required input-label\" for=\"notificationType\">Role</label><ol name=\"userRole\" class=\"nya-bs-select form-control app-dropdown\" ng-model=\"userDetailsCtrl.user.RoleId\" title=\"Select role\" size=\"10\" live-search=\"true\" ng-disabled=\"userDetailsCtrl.user.IsSDPUser\" ng-required=\"userDetailsCtrl.addUserFieldsRequired\" dropdown-clear-selection=\"\"><li nya-bs-option=\"role in userDetailsCtrl.roles\" data-value=\"role.Id\" ng-class=\"{\'disabled\': role.IsSDPRole }\"><a>{{ role.Name }}</a></li></ol></div></div><div class=\"row\"><div class=\"col-md-4 form-group\" ng-show=\"checkForPermission(\'ManageUserDevice\')\" ng-class=\"{\'has-error\' : (userInfoForm.$submitted || userInfoForm.allowedDevices.$touched) && userInfoForm.allowedDevices.$error.required}\"><label class=\"required input-label\" for=\"notificationType\">Authorized Devices</label> <input name=\"allowedDevices\" type=\"number\" class=\"form-control\" min=\"0\" max=\"1000\" ng-model=\"userDetailsCtrl.user.AllowedDevices\" ng-disabled=\"!userDetailsCtrl.canLogInToMobileBookshelf\" ng-paste=\"$event.preventDefault()\" input-number-positive=\"\" ng-required=\"userDetailsCtrl.addUserFieldsRequired\"></div><div class=\"col-md-4 form-group\" ng-if=\"userDetailsCtrl.ShowSubjectAssignmentSection\" ng-class=\"{\'has-error\' : (userInfoForm.$submitted || userInfoForm.userAssignedSubjects.$touched) && userInfoForm.userAssignedSubjects.$error.required}\"><label class=\"required input-label\">Subjects</label><ol name=\"userAssignedSubjects\" class=\"nya-bs-select form-control app-dropdown\" ng-model=\"userDetailsCtrl.user.AssignedSubjects\" title=\"Select Subject(s)\" size=\"10\" ng-disabled=\"userDetailsCtrl.user.HasAllSubjects\" live-search=\"true\" required=\"\" dropdown-clear-selection=\"\" multiple=\"\"><li nya-bs-option=\"subject in userDetailsCtrl.availableSubjects\" data-value=\"subject\" ng-class=\"{\'selected-option\' : userDetailsCtrl.isSubjectSelected(subject)}\"><a>{{subject.Name}}</a></li></ol></div><div class=\"col-md-4 form-group\" ng-if=\"userDetailsCtrl.ShowSubjectAssignmentSection\" style=\"padding-top:20px;\"><div class=\"checkbox\"><label><input name=\"hasAllSubjects\" type=\"checkbox\" ng-model=\"userDetailsCtrl.user.HasAllSubjects\" ng-checked=\"userDetailsCtrl.user.HasAllSubjects\"> <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span> <span class=\"cr-label\">Has All Subjects</span></label></div></div></div></form><div class=\"clearfix\" ng-if=\"checkForPermission(\'AddUser\')\"><button type=\"button\" class=\"pull-right btn button-red\" ng-click=\"userDetailsCtrl.resetPassword(userDetailsCtrl.user.Username)\">Reset Password</button></div></div></div></section><section class=\"details-section\"><div class=\"details-group\"><h1 class=\"details-group-title\">Paired Devices</h1><div ui-grid=\"devicesGridOptions\" ui-grid-auto-resize=\"\" ng-show=\"userDetailsCtrl.userPairedDevices.length > 0\"></div><no-data no-data-found=\"userDetailsCtrl.userPairedDevices.length == 0 && !userDetailsCtrl.isLoadingPairedDevices\" display-message=\"\'No paired devices yet for this user\'\"></no-data></div></section><section class=\"details-section hidden\" ng-show=\"userDetailsCtrl.user.RoleId === 7 && !userDetailsCtrl.isLoadingUserBooksStatistics\"><div class=\"details-group\"><h1 class=\"details-group-title\">Book Status</h1><div class=\"row user-statistics\"><div class=\"col-md-4 text-center\"><div class=\"assigned-books-box\"><p>ASSIGNED BOOKS</p><span class=\"statistics-value\">{{userDetailsCtrl.userDownloads.AssignedBooks}}</span></div></div><div class=\"col-md-4 text-center\"><div class=\"downloads-box\"><p>DOWNLOADS</p><div class=\"col-md-4 text-center\"><span class=\"statistics-value\">{{userDetailsCtrl.userDownloads.CompletedDownloads}}</span><br><span>COMPLETED</span></div><div class=\"col-md-4 text-center\"><span class=\"statistics-value\">{{userDetailsCtrl.userDownloads.DownloadsInProgress}}</span><br><span>IN PROGRESS</span></div><div class=\"col-md-4 text-center\"><span class=\"statistics-value\">{{userDetailsCtrl.userDownloads.PendingDownloads}}</span><br><span>PENDING</span></div></div></div><div class=\"col-md-4 text-center\"><div class=\"updates-box\"><p>UPDATES</p><div class=\"col-md-4 text-center\"><span class=\"statistics-value\">{{userDetailsCtrl.userDownloads.CompletedUpdates}}</span><br><span>COMPLETED</span></div><div class=\"col-md-4 text-center\"><span class=\"statistics-value\">{{userDetailsCtrl.userDownloads.UpdatesInProgress}}</span><br><span>IN PROGRESS</span></div><div class=\"col-md-4 text-center\"><span class=\"statistics-value\">{{userDetailsCtrl.userDownloads.PendingUpdates}}</span><br><span>PENDING</span></div></div></div></div></div></section><div class=\"footer-actions text-right\" ng-hide=\"!userDetailsCtrl.user || userDetailsCtrl.isLoadingPairedDevices || userDetailsCtrl.isLoadingUserBooksStatistics\"><button class=\"btn button-blue\" ng-click=\"userDetailsCtrl.changeUserStatus(0)\" ng-hide=\"userDetailsCtrl.user.IsSDPUser || userDetailsCtrl.user.Status === 0\" ng-disabled=\"userDetailsCtrl.isSavingUser\" ng-if=\"checkForPermission(\'AddUser\')\">Enable</button> <button class=\"btn button-red\" ng-click=\"userDetailsCtrl.askChangeUserStatus(true)\" ng-disabled=\"userDetailsCtrl.isSavingUser\" ng-hide=\"userDetailsCtrl.user.IsSDPUser || userDetailsCtrl.user.Status === 1\" ng-if=\"checkForPermission(\'AddUser\')\">Disable</button> <button type=\"submit\" class=\"btn button-blue button-left-space\" ng-click=\"userDetailsCtrl.saveUser()\" ng-disabled=\"userDetailsCtrl.isSavingUser\" ng-if=\"checkForPermission(\'AddUser\') || userDetailsCtrl.manageDevicePermission\">Save</button></div></div></div>");
$templateCache.put("app/school-management/downloads/details/download-details.template.html","<h1>Download Details</h1>");
$templateCache.put("app/school-management/downloads/list/downloads-list.template.html","<h1>Downloads List</h1>");}]);